[
  {
    "key": "txt_DRIVER_MOD_SCORE",
    "text": "Factor Exit Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة عامل خروج الموظفين"
      }
    ]
  },
  {
    "key": "txt_DRIVER/IM_469",
    "text": "Impact / Factor",
    "translations": [
      {
        "language": "AR",
        "text": "التأثير / العامل"
      },
      {
        "language": "EN",
        "text": "Impact / Factor"
      }
    ]
  },
  {
    "key": "ap_module_score",
    "text": "Exit Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الموظفين المغادرين"
      }
    ]
  },
  {
    "key": "ap_section",
    "text": "Factor",
    "translations": [
      {
        "language": "AR",
        "text": "عامل"
      }
    ]
  },
  {
    "key": "ap_by_driver",
    "text": "By Factor",
    "translations": [
      {
        "language": "AR",
        "text": "حسب العامل"
      }
    ]
  },
  {
    "key": "ap_for_survey",
    "text": "For Exit Survey:",
    "translations": [
      {
        "language": "AR",
        "text": "لاستبيان خروج الموظف:"
      }
    ]
  },
  {
    "key": "txt_drivers",
    "text": "Factors",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل خروج الموظفين"
      }
    ]
  },
  {
    "key": "txt_ActionPla_663",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "EX:EXC17",
    "text": "Missing Required Fields",
    "translations": [
      {
        "language": "AR",
        "text": "الحقول المطلوبة مفقودة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "EX:EXC16",
    "text": "Entity Hierarchy Invalid",
    "translations": [
      {
        "language": "AR",
        "text": "تسلسل الهرم للوحدات غير صالح"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "EX:EXC12",
    "text": "Duplicate Leaver ID",
    "translations": [
      {
        "language": "AR",
        "text": "هوية الموظف المغادر مكررة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Row",
    "text": "Row",
    "translations": [
      {
        "language": "AR",
        "text": "صف"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Excel:Validation:Failed",
    "text": "Excel Validation Failed",
    "translations": [
      {
        "language": "AR",
        "text": "فشل التحقق من بيانات الملف"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Excel:Validation:ValueNotFound",
    "text": "Option Not Found",
    "translations": [
      {
        "language": "AR",
        "text": "الخيار غير موجود"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Excel:Validation:DuplicateEmployeeId",
    "text": "Duplicate Employee Id",
    "translations": [
      {
        "language": "AR",
        "text": "رقم هوية الموظف مكررة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Excel:Validation:EmployeeIdMissing",
    "text": "Employee Id is missing",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة رقم هوية الموظف"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ErrorsEncountered",
    "text": "Errors Found",
    "translations": [
      {
        "language": "AR",
        "text": "تم العثور على أخطاء"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "btn_Finish",
    "text": "Finish",
    "translations": [
      {
        "language": "AR",
        "text": "تم"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_TotalUpdated",
    "text": "Total Updated",
    "translations": [
      {
        "language": "AR",
        "text": "إجمالي السجلات التي تم تحديثها"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_TotalProcessed",
    "text": "Total Processed",
    "translations": [
      {
        "language": "AR",
        "text": "جمالي السجلات المعالَجة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_BulkUpdateSuccess",
    "text": "Update Success",
    "translations": [
      {
        "language": "AR",
        "text": "تم التعديل بنجاح"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Your request is not valid",
    "text": "Your request is not valid",
    "translations": [
      {
        "language": "AR",
        "text": "الطلب غير صالح"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ResultSummary",
    "text": "Update Summary",
    "translations": [
      {
        "language": "AR",
        "text": "مُلخص التعديلات"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_RecordsIdentified",
    "text": "Leavers Identified",
    "translations": [
      {
        "language": "AR",
        "text": "الموظفون المغادرون المحددون"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ValidationSuccessful",
    "text": "Leavers have been updated",
    "translations": [
      {
        "language": "AR",
        "text": "تم تعديل الموظفين المغادرين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtCriteriaForExistingLeavers",
    "text": "existing leavers criteria by linking it to their unique IDs",
    "translations": [
      {
        "language": "AR",
        "text": "معايير الموظفين المغادرين الموجودين بالفعل من خلال ربطها برقم الهوية الخاص بهم."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtUpdate",
    "text": "Update",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_BulkUpdateDescriptionShort",
    "text": "Use a spreadsheet",
    "translations": [
      {
        "language": "AR",
        "text": "استعمل جدول"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_BulkUpdateDescription",
    "text": "You can update any leaver's information using their unique ID.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث معلومات أي موظف مغادر باستخدام رقم الهوية الفريد الخاص به."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "EX:EXC11",
    "text": "Invalid Joining Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإنضمام غير صالح"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "EX:EXC10",
    "text": "Invalid Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "الجنسية غير صالحة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "EX:EXC09",
    "text": "Invalid Gender",
    "translations": [
      {
        "language": "AR",
        "text": "الجنس غير صالح"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_BulkUpdate",
    "text": "Bulk Update",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل جماعي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Filters_429",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_heatmap_leaver_experience",
    "text": "Leaver Experience",
    "translations": [
      {
        "language": "AR",
        "text": "معدل تجربة الموظفين المغادرين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Ifyouwant_739",
    "text": "If you want to add more statements, click <b>“New Custom Factor”</b>. <br><br>Note: Total factors covering the <b>Predefined</b> and <b>Custom Factors</b> shall not exceed 8 Factors.",
    "translations": [
      {
        "language": "AR",
        "text": "إذا كنت ترغب في إضافة المزيد من العبارات، انقر على <b>\"عامل مخصص جديد\"</b>. <br><br>ملحوظة: يجب ألا يتجاوز إجمالي <b>العوامل المُعرفة مسبقاً</b> و<b>المخصصة</b> عن 8 عوامل."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "If you want to add more statements, click <b>“New Custom Factor”</b>. <br><br>Note: Total factors covering the <b>Predefined</b> and <b>Custom Factors</b> shall not exceed 8 Factors."
      }
    ]
  },
  {
    "key": "txt_Useouradv_732",
    "text": "Use our advanced AI tool to generate statements tailored to your need!",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم أداة الذكاء الاصطناعي المتطورة لإنشاء عبارات مصممة خصيصًا لاحتياجاتك!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Use our advanced AI tool to generate statements tailored to your need!"
      }
    ]
  },
  {
    "key": "txt_GenerateS_856",
    "text": "Generate Statement",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء عبارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Generate Statement"
      }
    ]
  },
  {
    "key": "txt_ClickonnewStatement_917",
    "text": "Click on <b>“New Statement”</b> to add a new custom statement using the agreement scale question type. <br><br>Hint: Click “👁️” to preview the statement sample used in the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"عبارة جديدة\"</b> لإضافة عبارة مخصصة جديدة باستخدام نوع السؤال لمقياس الاتفاق.<br><br>تلميح: انقر على \"👁️\" لعرض نموذج السؤال الذي سيتم استخدامه في الاستبيان."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click on <b>“New Statement”</b> to add a new custom statement using the agreement scale question type. <br><br>Hint: Click “👁️” to preview the statement sample used in the survey."
      }
    ]
  },
  {
    "key": "txt_EditCusto_desc",
    "text": "Edit or delete the new custom factor.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف العامل المخصص الجديد."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Edit or delete the new custom factor."
      }
    ]
  },
  {
    "key": "txt_EditCusto_448",
    "text": "Edit Custom Factor",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل العامل المخصص"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Edit Custom Factor"
      }
    ]
  },
  {
    "key": "txt_Similarto_253",
    "text": "Similar to <b>“General Questions”</b>, you can add unlimited questions to be shown in the last section of the employee exit survey.",
    "translations": [
      {
        "language": "AR",
        "text": "استناداً إلى قسم <b>\"الأسئلة العامة\"</b>, يمكنك هنا أيضاً إضافة عدد غير محدود من الأسئلة لتظهر في القسم الأخير من استبيان خروج الموظفين."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Similar to <b>“General Questions”</b>, you can add unlimited questions to be shown in the last section of the employee exit survey."
      }
    ]
  },
  {
    "key": "txt_Maximizey_717",
    "text": "Maximize your experience with the full <b>Employee Exit</b> predefined factors, or tailor it to your needs by selecting a minimum of 5 factors. ",
    "translations": [
      {
        "language": "AR",
        "text": "حقق أقصى استفادة مع عوامل <b>الموظف المغادر</b> المُعرفة مسبقاً، أو قم بتخصيصها لتناسب احتياجاتك عن طريق اختيار 5 عوامل كحد أدنى."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Maximize your experience with the full <b>Employee Exit</b> predefined factors, or tailor it to your needs by selecting a minimum of 5 factors. "
      }
    ]
  },
  {
    "key": "txt_Clickhere_627",
    "text": "Click here to view the last question section.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض قسم السؤال الأخير."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click here to view the last question section."
      }
    ]
  },
  {
    "key": "txt_Clickhere_871",
    "text": "Click here to preview the employee exit factors and their statements!",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض عوامل وعبارات استبيان الموظفين المغادرين!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click here to preview the employee exit factors and their statements!"
      }
    ]
  },
  {
    "key": "txt_download_comments_desc",
    "text": "Click here to download all comments.<br><br>Note: Available in Excel format",
    "translations": [
      {
        "language": "AR",
        "text": "انقرهنا لتحميل جميع التعليقات.<br><br>ملحوظة: متوفر في صيغة Excel."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click here to download all comments.<br><br>Note: Available in Excel format"
      }
    ]
  },
  {
    "key": "txtComments_desc",
    "text": "Unlock the magic of AI with sentiment analysis in <b>“Comments”</b> – witness the power of your leavers’ feedback!",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف سحر الذكاء الصناعي من خلال تحليل المشاعر والآراء في <b>\"التعليقات\"</b> - شاهد قوة تعليقات المغادرين!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Unlock the magic of AI with sentiment analysis in <b>“Comments”</b> – witness the power of your leavers’ feedback!"
      }
    ]
  },
  {
    "key": "txt_statementsscore_desc",
    "text": "Expand the factor to view each statement score and the distribution of leavers’ answers.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على العامل لعرض متوسط كل عبارة وتوزيع إجابات المغادرين."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Expand the factor to view each statement score and the distribution of leavers’ answers."
      }
    ]
  },
  {
    "key": "txt_Statement_419",
    "text": "Statements’ Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة العبارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Statements’ Score"
      }
    ]
  },
  {
    "key": "txt_questions_desc",
    "text": "In <b>\"Statements\"</b>, each factor’s score with its corresponding statement is shown.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"العبارات\"</b>، يتم عرض متوسط كل عامل مع العبارات الخاصة به. "
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "In <b>\"Statements\"</b>, each factor’s score with its corresponding statement is shown."
      }
    ]
  },
  {
    "key": "txt_Changethe_779",
    "text": "Change the type of the chart by clicking here.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتغيير نوع الرسم البياني بالنقر هنا."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Change the type of the chart by clicking here."
      }
    ]
  },
  {
    "key": "txt_ChartType_628",
    "text": "Chart Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الرسم البياني"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Chart Type"
      }
    ]
  },
  {
    "key": "txtLeaversAnalysis_desc",
    "text": "In <b>“Leavers’ Analysis”</b>, the charts shown depend on the analytical criteria filled in while adding a leaver.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"تحليلات المغادرين\"</b> تعتمد الرسوم البيانية المعروضة على المعايير التحليلية المُعبئة خلال إضافة الموظف المغادر."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "In <b>“Leavers’ Analysis”</b>, the charts shown depend on the analytical criteria filled in while adding a leaver."
      }
    ]
  },
  {
    "key": "txt_Drilldown_desc",
    "text": "Click on the charts bar to drilldown the names of the leaver’s choices.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على شريط الرسم البياني لكشف أسماء اختيارات الموظفين المغادرين."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click on the charts bar to drilldown the names of the leaver’s choices."
      }
    ]
  },
  {
    "key": "txt_Drilldown_245",
    "text": "Drilldown",
    "translations": [
      {
        "language": "AR",
        "text": "كشف قائمة الموظفين المغادرين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Drilldown"
      }
    ]
  },
  {
    "key": "txtENPS_tour_desc",
    "text": "The employee net promoter score, “how likely your employees will recommend your company to their friends/relatives” is recommended to be above 30% as per the leading practice.",
    "translations": [
      {
        "language": "AR",
        "text": "من الموصى أن تكون درجة صافي نقاط ترويج الموظفين \"ما مدى احتمالية الموظفين بتوصية الشركة  لصديق أو قريب\" فوق ال 30% للتوافق مع الممارسات الرائدة."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "The employee net promoter score, “how likely your employees will recommend your company to their friends/relatives” is recommended to be above 30% as per the leading practice."
      }
    ]
  },
  {
    "key": "txtENPS_tour",
    "text": "eNPS",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "eNPS"
      }
    ]
  },
  {
    "key": "txt_filter_timeframe_desc",
    "text": "Are you looking for a specific timeframe for your analysis? Set the start and end date and uncover the insights you need!",
    "translations": [
      {
        "language": "AR",
        "text": "هل تبحث عن مدة زمنية محددة لعرض التحليلات؟ قم بتعيين تاريخ البدء والانتهاء واكتشف التحليلات التي تحتاجها!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Are you looking for a specific timeframe for your analysis? Set the start and end date and uncover the insights you need!"
      }
    ]
  },
  {
    "key": "txt_filter_timeframe",
    "text": "Filter by Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "تصفية حسب المدة الزمنية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Filter by Timeframe"
      }
    ]
  },
  {
    "key": "txt_filter_leaver_seperation_types_desc",
    "text": "The system is interactive. Click on the separation type legend to turn on/off options and have a clearer view of the results.",
    "translations": [
      {
        "language": "AR",
        "text": "تلميح: النظام تفاعلي. انقر على مفتاح نوع الفصل لتفعيل/إيقاف الخيارات والحصول على رؤية أوضح للنتائج."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "The system is interactive. Click on the separation type legend to turn on/off options and have a clearer view of the results."
      }
    ]
  },
  {
    "key": "txt_filter_leaver_seperation_types",
    "text": "Filter by Separation type",
    "translations": [
      {
        "language": "AR",
        "text": "تصفية حسب نوع الفصل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Filter by Separation type"
      }
    ]
  },
  {
    "key": "txtExport_desc",
    "text": "Click here to download the report and turn on the sections you want to include. <br><br>Hint: Easily access detailed entity reports by choosing your preferred entity type in the 'View by' menu and start downloading now!  - Available in PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتحميل التقرير واختر الأقسام التي ترغب في تضمينها في التقرير.<br><br>تلميح: قم بالوصول بسهولة إلى تقارير الوحدات التنظيمية المفصلة عن طريق اختيار نوع الوحدة التنظيمية في قائمة <b>\"تصفح عن طريق\" </b>وابدأ بالتحميل الآن! - متوفر في صيغة PDF. "
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click here to download the report and turn on the sections you want to include. <br><br>Hint: Easily access detailed entity reports by choosing your preferred entity type in the 'View by' menu and start downloading now!  - Available in PDF."
      }
    ]
  },
  {
    "key": "txtViewBy_desc",
    "text": "Click here to filter the analysis by choosing the entity.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض التحليلات عن طريق اختيار الوحدة التنظيمية."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click here to filter the analysis by choosing the entity."
      }
    ]
  },
  {
    "key": "txtOverview_desc",
    "text": "The <b>“Overview”</b> page shows the leaver experience rate, factors’ score, and other valuable insights. ",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة <b>\"نظرة عامة\"</b> تعرض معدل تجربة الموظفين المغادرين ومتوسط عوامل خروج الموظفين والعديد من التحليلات الأخرى."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "The <b>“Overview”</b> page shows the leaver experience rate, factors’ score, and other valuable insights. "
      }
    ]
  },
  {
    "key": "txt_Ontheanalysis_761",
    "text": "On the <b>“Analysis”</b> page, you uncover the overall results for leavers who completed the survey!",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"التحليلات\"</b> تكشف الدرجات الكلية لجميع المغادرين الذين استكملوا الاستبيان!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "On the <b>“Analysis”</b> page, you uncover the overall results for leavers who completed the survey!"
      }
    ]
  },
  {
    "key": "txt_Clickhere_151",
    "text": "Click here and select <b>“Export Template”</b> to view your Survey's selected factors, statements, and questions! You can also select <b>“Edit Template”</b> to rename your template or <b>“Delete Template”</b> to delete your template.<br><br> Note: Export is Available in PDF format. Careful! Only inactive templates can be edited and deleted.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"تحميل النموذج\"</b> لعرض العوامل والعبارات والأسئلة المختارة في الاستبيان الخاص بك! يمكنك أيضاً تعديل او حذف النموذج بالنقر على <b>\"تعديل النموذج\"</b> أو <b>\"حذف النموذج\"</b>. <br><br>ملحوظة: تحميل النموذج متوفر في صيغة PDF. انتبه! لا يمكن تعديل أو حذف النماذج المستخدمة."
      },
      {
        "language": "EN",
        "text": "Click here and select <b>“Export Template”</b> to view your Survey's selected factors, statements, and questions! You can also select <b>“Edit Template”</b> to rename your template or <b>“Delete Template”</b> to delete your template.<br><br> Note: Export is Available in PDF format. Careful! Only inactive templates can be edited and deleted."
      }
    ]
  },
  {
    "key": "txt_Fillinyou_413",
    "text": "Fill in your question title and options (if any).",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة عنوان السؤال والخيارات (إن وجد)."
      },
      {
        "language": "EN",
        "text": "Fill in your question title and options (if any)."
      }
    ]
  },
  {
    "key": "txt_QuestionD_182",
    "text": "Question Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل السؤال"
      },
      {
        "language": "EN",
        "text": "Question Details"
      }
    ]
  },
  {
    "key": "txt_Clicksave_286",
    "text": "Click <b>“Save Changes”</b> to save your edits.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"حفظ التغييرات\"</b> لحفظ التعديلات."
      },
      {
        "language": "EN",
        "text": "Click <b>“Save Changes”</b> to save your edits."
      }
    ]
  },
  {
    "key": "txt_Settheque_136",
    "text": "Set the question properties by selecting the question type (MCQ, Multiple Selection/Single Selection, or Text) and separation type.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد إعدادات السؤال من خلال اختيار نوع السؤال (متعدد الخيارات أو خيار واحد أو نص) ونوع الفصل."
      },
      {
        "language": "EN",
        "text": "Set the question properties by selecting the question type (MCQ, Multiple Selection/Single Selection, or Text) and separation type."
      }
    ]
  },
  {
    "key": "txt_QuestionS_313",
    "text": "Question Settings",
    "translations": [
      {
        "language": "AR",
        "text": "إعدادات السؤال"
      },
      {
        "language": "EN",
        "text": "Question Settings"
      }
    ]
  },
  {
    "key": "txt_Enablethi_448",
    "text": "Enable this option to ensure the leaver responds to this question before moving on to the next.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتفعيل هذا الخيار إذا كنت تريد الموظف المغادر أن يقوم بالإجابة على هذا السؤال قبل الانتقال للسؤال التالي."
      },
      {
        "language": "EN",
        "text": "Enable this option to ensure the leaver responds to this question before moving on to the next."
      }
    ]
  },
  {
    "key": "txt_Tostartad_702",
    "text": "To start adding custom questions, click <b>“New Question\"</b>.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"سؤال جديد\"</b> لإضافة أسئلة مخصصة."
      },
      {
        "language": "EN",
        "text": "To start adding custom questions, click <b>“New Question\"</b>."
      }
    ]
  },
  {
    "key": "txt_Inthegeneral_394",
    "text": "In the <b>“General Questions”</b> section, you can add unlimited questions with different types.",
    "translations": [
      {
        "language": "AR",
        "text": "في قسم <b>\"الأسئلة العامة\"</b> يمكنك إضافة عدد غير محدود من الأسئلة بأنواع مختلفة."
      },
      {
        "language": "EN",
        "text": "In the <b>“General Questions”</b> section, you can add unlimited questions with different types."
      }
    ]
  },
  {
    "key": "txt_Doyouhave_406",
    "text": "Do you have a variety of question types you'd like to include in your survey? Look no further! Click here to start designing an employee exit survey tailored to your needs.",
    "translations": [
      {
        "language": "AR",
        "text": "هل لديك مجموعة متنوعة من أنواع الأسئلة التي ترغب في تضمينها في الاستبيان؟ لا داعي للبحث أكثر! انقر هنا لبدء تصميم استبيان خروج الموظفين المصمم خصيصاً لتلبية احتياجاتك."
      },
      {
        "language": "EN",
        "text": "Do you have a variety of question types you'd like to include in your survey? Look no further! Click here to start designing an employee exit survey tailored to your needs."
      }
    ]
  },
  {
    "key": "txt_Separatio_105",
    "text": "Separation type is distinguished by color, where grey is all, red is termination, blue is retirement, and orange is resignation.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكن التمييز بين نوع الفصل حسب اللون حيث يُمثل اللون الرمادي الكل واللون الأحمر هو إنهاء خدمات واللون الأزرق هو تقاعد واللون البرتقالي هو استقالة."
      },
      {
        "language": "EN",
        "text": "Separation type is distinguished by color, where grey is all, red is termination, blue is retirement, and orange is resignation."
      }
    ]
  },
  {
    "key": "txt_Eachquest_776",
    "text": "Each question type is shown in the boxes.",
    "translations": [
      {
        "language": "AR",
        "text": "يتم عرض نوع السؤال في الصندوق."
      },
      {
        "language": "EN",
        "text": "Each question type is shown in the boxes."
      }
    ]
  },
  {
    "key": "txt_Clickhere_232",
    "text": "Click here to preview the general questions of the survey!",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض الأسئلة العامة للاستبيان!"
      },
      {
        "language": "EN",
        "text": "Click here to preview the general questions of the survey!"
      }
    ]
  },
  {
    "key": "txt_Clickhere_525",
    "text": "Click here to preview the questions for the employee exit predefined template! <br><br>Note: You cannot make any edits on predefined templates.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض أسئلة نموذج استبيان الموظفين المغادرين المُعرف مسبقاً! <br><br> ملحوظة: لا يمكنك إجراء أي تعديلات على النماذج المُعرفة مسبقاً."
      },
      {
        "language": "EN",
        "text": "Click here to preview the questions for the employee exit predefined template! <br><br>Note: You cannot make any edits on predefined templates."
      }
    ]
  },
  {
    "key": "txt_Inthesurv_894",
    "text": "In the <b>“Survey Templates”</b> page, you preview the predefined template questions and create new templates tailored to your needs!",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"نماذج الاستبيان\" </b>يمكنك عرض أسئلة النماذج المُعرفة مسبقاُ وإنشاء نماذج جديدة مصممة خصيصاً لتلبية احتياجاتك!"
      },
      {
        "language": "EN",
        "text": "In the <b>“Survey Templates”</b> page, you preview the predefined template questions and create new templates tailored to your needs!"
      }
    ]
  },
  {
    "key": "txt_Pointthem_625",
    "text": "Point the mouse over the leavers who completed the survey to view their answers. <br><br>Note: Available in PDF format",
    "translations": [
      {
        "language": "AR",
        "text": "ضع مؤشر الماوس فوق الموظف المغادر الذي استكمل الاستبيان لعرض الأجوبة. <br><br>ملحوظة: متوفر في صيغة PDF."
      },
      {
        "language": "EN",
        "text": "Point the mouse over the leavers who completed the survey to view their answers. <br><br>Note: Available in PDF format"
      }
    ]
  },
  {
    "key": "txt_Clickhere_319",
    "text": "Click here to send manual reminders and edit or delete the leaver.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لإرسال تذكيرات يدوية وتعديل أو حذف الموظف المغادر."
      },
      {
        "language": "EN",
        "text": "Click here to send manual reminders and edit or delete the leaver."
      }
    ]
  },
  {
    "key": "txt_MoreActio_765",
    "text": "More Actions",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات إضافية "
      },
      {
        "language": "EN",
        "text": "More Actions"
      }
    ]
  },
  {
    "key": "txt_Clickhere_840",
    "text": "Click here to customize the list of leavers to your preference!",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتعديل قائمة الموظفين المغادرين حسب تفضيلاتك!"
      },
      {
        "language": "EN",
        "text": "Click here to customize the list of leavers to your preference!"
      }
    ]
  },
  {
    "key": "txt_Clickhere_644",
    "text": "Click here to send reminders to leavers who did not complete the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لإرسال تذكيرات للموظفين المغادرين الذين لم يستكملوا الاستبيان."
      },
      {
        "language": "EN",
        "text": "Click here to send reminders to leavers who did not complete the survey."
      }
    ]
  },
  {
    "key": "txt_Youcandow_702",
    "text": "You can download the list of leavers with their survey status! <br><br>Note: Available in Excel format.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل قائمة الموظفين المغادرين مع حالة الاستبيان الخاص بهم! <br><br> ملحوظة: متوفر في صيغة Excel."
      },
      {
        "language": "EN",
        "text": "You can download the list of leavers with their survey status! <br><br>Note: Available in Excel format."
      }
    ]
  },
  {
    "key": "txt_ExportLea_980",
    "text": "Export Leavers",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل الموظفين المغادرين"
      },
      {
        "language": "EN",
        "text": "Export Leavers"
      }
    ]
  },
  {
    "key": "txt_Clickhere_234",
    "text": "Click here to filter the leavers’ list by survey status.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتصفية قائمة الموظفين حسب حالة الاستبيان."
      },
      {
        "language": "EN",
        "text": "Click here to filter the leavers’ list by survey status."
      }
    ]
  },
  {
    "key": "txt_Tostartad_645",
    "text": "To start adding leavers, click on <b>“Add Leaver”</b>. You have the option to add leavers manually or by using Excel! <br><br>Hint: We recommend adding by using Excel to save time and simplify your experience!",
    "translations": [
      {
        "language": "AR",
        "text": "للبدء في إضافة الموظفين المغادرين، انقر على <b>\"إضافة موظف مغادر\"</b>. لديك الخيار لإضافة الموظفين المغادرين يدوياً أو عبر ملف Excel! تلميح: نوصي باستخدام ملف<br><br> Excel لتوفير الوقت وتسهيل تجربتك!"
      },
      {
        "language": "EN",
        "text": "To start adding leavers, click on <b>“Add Leaver”</b>. You have the option to add leavers manually or by using Excel! <br><br>Hint: We recommend adding by using Excel to save time and simplify your experience!"
      }
    ]
  },
  {
    "key": "txt_AddLeaver_425",
    "text": "Add Leaver",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة موظف مغادر"
      },
      {
        "language": "EN",
        "text": "Add Leaver"
      }
    ]
  },
  {
    "key": "txt_Clickhere_611",
    "text": "Click here to select the employee exit template you want to view (if any).",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لاختيار وعرض النموذج لاستبيان الموظفين المغادرين (إن وجد)."
      },
      {
        "language": "EN",
        "text": "Click here to select the employee exit template you want to view (if any)."
      }
    ]
  },
  {
    "key": "txt_SelectTem_385",
    "text": "Select Template",
    "translations": [
      {
        "language": "AR",
        "text": "اختر النموذج"
      },
      {
        "language": "EN",
        "text": "Select Template"
      }
    ]
  },
  {
    "key": "txt_Ontheleav_485",
    "text": "On the <b>“Leavers”</b> page, you add the leavers and track their survey status, send reminders, and view each leaver’s answer individually.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"الموظفين المغادرين\"</b> تقوم بإضافة الموظفين الذين غادروا مكان العمل وتتبع حالة الاستبيان وإرسال تذكيرات وعرض أجوبة كل موظف مغادر على حدة."
      },
      {
        "language": "EN",
        "text": "On the <b>“Leavers”</b> page, you add the leavers and track their survey status, send reminders, and view each leaver’s answer individually."
      }
    ]
  },
  {
    "key": "txt_levaers_tour",
    "text": "Leavers",
    "translations": [
      {
        "language": "AR",
        "text": "الموظفين المغادرين"
      },
      {
        "language": "EN",
        "text": "Leavers"
      }
    ]
  },
  {
    "key": "txtPeople",
    "text": "Leavers",
    "translations": [
      {
        "language": "AR",
        "text": "المغادرون"
      },
      {
        "language": "EN",
        "text": "Leavers"
      }
    ]
  },
  {
    "key": "txtMonths",
    "text": "Month(s)",
    "translations": [
      {
        "language": "AR",
        "text": "شهور"
      },
      {
        "language": "EN",
        "text": "Month(s)"
      }
    ]
  },
  {
    "key": "txtDays",
    "text": "Day(s)",
    "translations": [
      {
        "language": "AR",
        "text": "أيام"
      },
      {
        "language": "EN",
        "text": "Day(s)"
      }
    ]
  },
  {
    "key": "txt_Analysis_348",
    "text": "Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات"
      },
      {
        "language": "EN",
        "text": "Analysis"
      }
    ]
  },
  {
    "key": "txtNoSentiment",
    "text": "No Sentiment",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد"
      },
      {
        "language": "EN",
        "text": "No Sentiment"
      }
    ]
  },
  {
    "key": "txtLeaverAnswerReport",
    "text": "<span>Leaver Answer </span> <br> <span class=\"font-normal\">Report</span>",
    "translations": [
      {
        "language": "AR",
        "text": "<span class=\"font-normal\">تقرير</span> <br> <span>أجوبة المغادر</span>"
      },
      {
        "language": "EN",
        "text": "<span>Leaver Answer </span> <br> <span class=\"font-normal\">Report</span>"
      }
    ]
  },
  {
    "key": "txtCommentAiChartTitle",
    "text": "Comments’ Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات التعليقات"
      },
      {
        "language": "EN",
        "text": "Comments’ Analysis"
      }
    ]
  },
  {
    "key": "txtPositive",
    "text": "Positive",
    "translations": [
      {
        "language": "AR",
        "text": "إيجابي"
      },
      {
        "language": "EN",
        "text": "Positive"
      }
    ]
  },
  {
    "key": "txtNeutralAISection",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "حيادي"
      },
      {
        "language": "EN",
        "text": "Neutral"
      }
    ]
  },
  {
    "key": "txtNegative",
    "text": "Negative",
    "translations": [
      {
        "language": "AR",
        "text": "سلبي"
      },
      {
        "language": "EN",
        "text": "Negative"
      }
    ]
  },
  {
    "key": "txt_invitationEmail",
    "text": "Invitation Email",
    "translations": [
      {
        "language": "AR",
        "text": "دعوة لاستكمال الاستبيان"
      },
      {
        "language": "EN",
        "text": "Invitation Email"
      }
    ]
  },
  {
    "key": "txt_send",
    "text": "Send",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال"
      },
      {
        "language": "EN",
        "text": "Send"
      }
    ]
  },
  {
    "key": "txt_bulk_reminders",
    "text": "Are you sure you wish to send reminders to all pending leavers?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من أنك ترغب في إرسال تذكيرات للمغادرين الذين لم يستكملوا الاستبيان؟"
      },
      {
        "language": "EN",
        "text": "Are you sure you wish to send reminders to all pending leavers?"
      }
    ]
  },
  {
    "key": "txt_respondents_list",
    "text": "Respondents List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجبيبون"
      },
      {
        "language": "EN",
        "text": "Respondents List"
      }
    ]
  },
  {
    "key": "txt_switch_template_subject",
    "text": "Template View Change",
    "translations": [
      {
        "language": "AR",
        "text": "تغييرعرض النموذج"
      },
      {
        "language": "EN",
        "text": "Template View Change"
      }
    ]
  },
  {
    "key": "txt_switch_template_text",
    "text": "You have selected a different template, do you wish to change view?",
    "translations": [
      {
        "language": "AR",
        "text": "لقد قمت باختيار نموذج مختلف. هل تريد تغيير العرض؟"
      },
      {
        "language": "EN",
        "text": "You have selected a different template, do you wish to change view?"
      }
    ]
  },
  {
    "key": "txt_Start&CompletionDates",
    "text": "Start and end dates need to be set",
    "translations": [
      {
        "language": "AR",
        "text": "يجب تحديد تاريخ البدء والإكمال للاستبيان"
      },
      {
        "language": "EN",
        "text": "Start and end dates need to be set"
      }
    ]
  },
  {
    "key": "txt_editor_delete_question",
    "text": "Delete Question",
    "translations": [
      {
        "language": "AR",
        "text": "حذف السؤال"
      },
      {
        "language": "EN",
        "text": "Delete Question"
      }
    ]
  },
  {
    "key": "txt_editor_sample_question",
    "text": "Sample Question",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج السؤال"
      },
      {
        "language": "EN",
        "text": "Sample Question"
      }
    ]
  },
  {
    "key": "preview_single-answer-confidence",
    "text": "Agreement Scale",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس الاتفاقية"
      },
      {
        "language": "EN",
        "text": "Agreement Scale"
      }
    ]
  },
  {
    "key": "preview_undefined",
    "text": "preview_undefined",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "preview_undefined"
      }
    ]
  },
  {
    "key": "preview_single-answer-out-10",
    "text": "0 of 10",
    "translations": [
      {
        "language": "AR",
        "text": "0 من 10"
      },
      {
        "language": "EN",
        "text": "0 of 10"
      }
    ]
  },
  {
    "key": "preview_single-answer-confidence-with-na",
    "text": "Agreement Scale",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس الاتفاقية"
      },
      {
        "language": "EN",
        "text": "Agreement Scale"
      }
    ]
  },
  {
    "key": "preview_multi-options-single-answer",
    "text": "Single Choice",
    "translations": [
      {
        "language": "AR",
        "text": "خيار واحد"
      },
      {
        "language": "EN",
        "text": "Single Choice"
      }
    ]
  },
  {
    "key": "preview_multi-options-multi-answer",
    "text": "Multiple Choices",
    "translations": [
      {
        "language": "AR",
        "text": "متعدد الخيارات"
      },
      {
        "language": "EN",
        "text": "Multiple Choices"
      }
    ]
  },
  {
    "key": "preview_text",
    "text": "Open Text",
    "translations": [
      {
        "language": "AR",
        "text": "نص"
      },
      {
        "language": "EN",
        "text": "Open Text"
      }
    ]
  },
  {
    "key": "txtLegend",
    "text": "Legend",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      },
      {
        "language": "EN",
        "text": "Legend"
      }
    ]
  },
  {
    "key": "txt_C-Factors_788",
    "text": "Minimum 5 predefined factors should be selected",
    "translations": [
      {
        "language": "AR",
        "text": "يجب اختيار 5 عوامل كحد أدنى"
      },
      {
        "language": "EN",
        "text": "Minimum 5 predefined factors should be selected"
      }
    ]
  },
  {
    "key": "txtMinAndMaxDatesRequired",
    "text": "min and max dates are required to save",
    "translations": [
      {
        "language": "AR",
        "text": "يجب تحديد الحد الأدنى والأقصى للتاريخ للحفظ"
      },
      {
        "language": "EN",
        "text": "min and max dates are required to save"
      }
    ]
  },
  {
    "key": "invalidQuestionLength",
    "text": "Invalid question length",
    "translations": [
      {
        "language": "AR",
        "text": "صياغة السؤال غير صحيحة"
      },
      {
        "language": "EN",
        "text": "Invalid question length"
      }
    ]
  },
  {
    "key": "txt_Allfactor_914",
    "text": "Maximum 8 factors should be selected",
    "translations": [
      {
        "language": "AR",
        "text": "الحد الأقصى للعوامل المختارة هو 8"
      },
      {
        "language": "EN",
        "text": "Maximum 8 factors should be selected"
      }
    ]
  },
  {
    "key": "txtReviewData",
    "text": "Review Data",
    "translations": [
      {
        "language": "AR",
        "text": "مراجعة البيانات"
      },
      {
        "language": "EN",
        "text": "Review Data"
      }
    ]
  },
  {
    "key": "txt_EX:EXC08",
    "text": "Invalid separation type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الفصل غير صالح"
      },
      {
        "language": "EN",
        "text": "Invalid separation type"
      }
    ]
  },
  {
    "key": "txt_EX:EXC07",
    "text": "Invalid separation date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ مغادرة العمل غير صالح"
      },
      {
        "language": "EN",
        "text": "Invalid separation date"
      }
    ]
  },
  {
    "key": "txt_EX:EXC06",
    "text": "No records found",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم العثور على أي معلومات"
      },
      {
        "language": "EN",
        "text": "No records found"
      }
    ]
  },
  {
    "key": "txt_EX:EXC05",
    "text": "Error in translating excel",
    "translations": [
      {
        "language": "AR",
        "text": "خطأ في قراءة الملف"
      },
      {
        "language": "EN",
        "text": "Error in translating excel"
      }
    ]
  },
  {
    "key": "txt_EX:EXC04",
    "text": "Invalid email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني غير صالح"
      },
      {
        "language": "EN",
        "text": "Invalid email"
      }
    ]
  },
  {
    "key": "txt_EX:EXC03",
    "text": "Invalid reminder dates",
    "translations": [
      {
        "language": "AR",
        "text": "تواريخ التذكير غير صالحة"
      },
      {
        "language": "EN",
        "text": "Invalid reminder dates"
      }
    ]
  },
  {
    "key": "txt_EX:EXC02",
    "text": "Invalid end date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإكمال غير صالح"
      },
      {
        "language": "EN",
        "text": "Invalid end date"
      }
    ]
  },
  {
    "key": "txt_EX:EXC01",
    "text": "Invalid start date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء غير صالح"
      },
      {
        "language": "EN",
        "text": "Invalid start date"
      }
    ]
  },
  {
    "key": "txt_EX:60000",
    "text": "Something wrong with chosen survey template",
    "translations": [
      {
        "language": "AR",
        "text": "هناك خطأ في نموذج الاستبيان المختار"
      },
      {
        "language": "EN",
        "text": "Something wrong with chosen survey template"
      }
    ]
  },
  {
    "key": "txtErrorExcelUpload",
    "text": "Error has been found",
    "translations": [
      {
        "language": "AR",
        "text": "تم العثور على خطأ"
      },
      {
        "language": "EN",
        "text": "Error has been found"
      }
    ]
  },
  {
    "key": "txtGenerated",
    "text": "Generated",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاءه في"
      },
      {
        "language": "EN",
        "text": "Generated"
      }
    ]
  },
  {
    "key": "VPOOREXP",
    "text": "Very Poor Experience",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة سيئة للغاية"
      },
      {
        "language": "EN",
        "text": "Very Poor Experience"
      }
    ]
  },
  {
    "key": "txtSeperationType",
    "text": "Separation Type ",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الفصل"
      },
      {
        "language": "EN",
        "text": "Separation Type "
      }
    ]
  },
  {
    "key": "btn_leaver_list_edit",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "EN",
        "text": "Edit"
      }
    ]
  },
  {
    "key": "btn_leaver_list_delete",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "EN",
        "text": "Delete"
      }
    ]
  },
  {
    "key": "txt_in_progress",
    "text": "In-Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإنجاز"
      },
      {
        "language": "EN",
        "text": "In-Progress"
      }
    ]
  },
  {
    "key": "txt_leavers",
    "text": "leavers",
    "translations": [
      {
        "language": "AR",
        "text": "المغادرون "
      },
      {
        "language": "EN",
        "text": "leavers"
      }
    ]
  },
  {
    "key": "txt_download_comments",
    "text": "Download Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التعليقات"
      },
      {
        "language": "EN",
        "text": "Download Comments"
      }
    ]
  },
  {
    "key": "txtDownloadTemplate",
    "text": "Template Download",
    "translations": [
      {
        "language": "AR",
        "text": "تنزيل النموذج"
      },
      {
        "language": "EN",
        "text": "Template Download"
      }
    ]
  },
  {
    "key": "VERYGOODEXP",
    "text": "Very Good Experience",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة جيدة للغاية"
      },
      {
        "language": "EN",
        "text": "Very Good Experience"
      }
    ]
  },
  {
    "key": "txt_inactive",
    "text": "In Active",
    "translations": [
      {
        "language": "AR",
        "text": "غير فعّال"
      },
      {
        "language": "EN",
        "text": "In Active"
      }
    ]
  },
  {
    "key": "txtApply",
    "text": "Apply",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق"
      },
      {
        "language": "EN",
        "text": "Apply"
      }
    ]
  },
  {
    "key": "txtSelected",
    "text": "Selected",
    "translations": [
      {
        "language": "AR",
        "text": "المختارة"
      },
      {
        "language": "EN",
        "text": "Selected"
      }
    ]
  },
  {
    "key": "txtSelectEntity",
    "text": "Selected Entity",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة"
      },
      {
        "language": "EN",
        "text": "Selected Entity"
      }
    ]
  },
  {
    "key": "txtAtleastOneLeaverRequired",
    "text": "Total Leavers should be at least 1\t",
    "translations": [
      {
        "language": "AR",
        "text": "يجب ألا يقل العدد الكلي للمغادرين عن 1 "
      },
      {
        "language": "EN",
        "text": "Total Leavers should be at least 1\t"
      }
    ]
  },
  {
    "key": "txt_inprogress",
    "text": "In Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإتمام"
      },
      {
        "language": "EN",
        "text": "In Progress"
      }
    ]
  },
  {
    "key": "VGOODEXP",
    "text": "Very Good Experience",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة جيدة للغاية"
      },
      {
        "language": "EN",
        "text": "Very Good Experience"
      }
    ]
  },
  {
    "key": "VPOOREXP\t",
    "text": "Very Poor Experience\t",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة سيئة للغاية"
      },
      {
        "language": "EN",
        "text": "Very Poor Experience\t"
      }
    ]
  },
  {
    "key": "txtExtraDriver",
    "text": "Extra Factor",
    "translations": [
      {
        "language": "AR",
        "text": "عامل إضافي"
      },
      {
        "language": "EN",
        "text": "Extra Factor"
      }
    ]
  },
  {
    "key": "txtEditTemplate",
    "text": "Edit Template",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل النموذج"
      },
      {
        "language": "EN",
        "text": "Edit Template"
      }
    ]
  },
  {
    "key": "txtQuestionOptionsLength",
    "text": "At least two options need to be provided",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إضافة خيارين على الأقل"
      },
      {
        "language": "EN",
        "text": "At least two options need to be provided"
      }
    ]
  },
  {
    "key": "txtTemplate",
    "text": "Survey Templates",
    "translations": [
      {
        "language": "AR",
        "text": "نماذج الاستبيان"
      },
      {
        "language": "EN",
        "text": "Survey Templates"
      }
    ]
  },
  {
    "key": "txt_TemplateUpdated",
    "text": "Template Updated",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديث النموذج بنجاح"
      },
      {
        "language": "EN",
        "text": "Template Updated"
      }
    ]
  },
  {
    "key": "txt_TemplateCreated",
    "text": "Template Created",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاء النموذج"
      },
      {
        "language": "EN",
        "text": "Template Created"
      }
    ]
  },
  {
    "key": "txtMaxErrorOptions",
    "text": "Maximum option should be less than the choices selected",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون الحد الأقصى أقل من الخيارات"
      },
      {
        "language": "EN",
        "text": "Maximum option should be less than the choices selected"
      }
    ]
  },
  {
    "key": "txtMinErrorOptions",
    "text": "Minimum option should be less than the choices selected",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون الحد الأدنى أقل من الخيارات"
      },
      {
        "language": "EN",
        "text": "Minimum option should be less than the choices selected"
      }
    ]
  },
  {
    "key": "txtSelectRange",
    "text": "Select range",
    "translations": [
      {
        "language": "AR",
        "text": "حدد النطاق"
      },
      {
        "language": "EN",
        "text": "Select range"
      }
    ]
  },
  {
    "key": "txtSelectMin",
    "text": "Select min",
    "translations": [
      {
        "language": "AR",
        "text": "حدد الحد الأدنى"
      },
      {
        "language": "EN",
        "text": "Select min"
      }
    ]
  },
  {
    "key": "txtSelectMax",
    "text": "Select max",
    "translations": [
      {
        "language": "AR",
        "text": "حدد الحد الأقصى"
      },
      {
        "language": "EN",
        "text": "Select max"
      }
    ]
  },
  {
    "key": "txt_AddChoice_507",
    "text": "Add Choice",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة اختيار"
      },
      {
        "language": "EN",
        "text": "Add Choice"
      }
    ]
  },
  {
    "key": "txt_Choose4_247",
    "text": "Choose",
    "translations": [
      {
        "language": "AR",
        "text": "اختار"
      },
      {
        "language": "EN",
        "text": "Choose"
      }
    ]
  },
  {
    "key": "txtAll",
    "text": "All",
    "translations": [
      {
        "language": "AR",
        "text": "الكل"
      },
      {
        "language": "EN",
        "text": "All"
      }
    ]
  },
  {
    "key": "txt_SaveChang_405",
    "text": "Save Changes",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ التغييرات"
      },
      {
        "language": "EN",
        "text": "Save Changes"
      }
    ]
  },
  {
    "key": "txtText",
    "text": "Text",
    "translations": [
      {
        "language": "AR",
        "text": "نص"
      },
      {
        "language": "EN",
        "text": "Text"
      }
    ]
  },
  {
    "key": "multi-options-single-answer",
    "text": "Multiple Select Single Choice",
    "translations": [
      {
        "language": "AR",
        "text": "متعدد الاختيارات - خيار واحد"
      },
      {
        "language": "EN",
        "text": "Multiple Select Single Choice"
      }
    ]
  },
  {
    "key": "multi-options-multi-answer",
    "text": "Multiple Select Multiple Choice",
    "translations": [
      {
        "language": "AR",
        "text": "متعدد الاختيارات - أكثر من خيار"
      },
      {
        "language": "EN",
        "text": "Multiple Select Multiple Choice"
      }
    ]
  },
  {
    "key": "txt_QuestionT_164",
    "text": "Question Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع السؤال"
      },
      {
        "language": "EN",
        "text": "Question Type"
      }
    ]
  },
  {
    "key": "txt_QUESTIONP_258",
    "text": "QUESTION PROPERTIES",
    "translations": [
      {
        "language": "AR",
        "text": "إعدادات السؤال"
      },
      {
        "language": "EN",
        "text": "QUESTION PROPERTIES"
      }
    ]
  },
  {
    "key": "txt_Factornee_401",
    "text": "Factor must have a valid name and at least one statement",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن تكون صياغة العامل صحيحة ولديه عبارة واحدة على الأقل"
      },
      {
        "language": "EN",
        "text": "Factor must have a valid name and at least one statement"
      }
    ]
  },
  {
    "key": "txt_Addupto4s_862",
    "text": "Add up to 3 statements",
    "translations": [
      {
        "language": "AR",
        "text": "أضف ما يصل إلى 3 عبارات"
      },
      {
        "language": "EN",
        "text": "Add up to 3 statements"
      }
    ]
  },
  {
    "key": "txt_DeleteQue_569",
    "text": "Delete Statement",
    "translations": [
      {
        "language": "AR",
        "text": "حذف العبارة"
      },
      {
        "language": "EN",
        "text": "Delete Statement"
      }
    ]
  },
  {
    "key": "Note updated successfully",
    "text": "Note updated successfully",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديث الملحوظة بنجاح"
      },
      {
        "language": "EN",
        "text": "Note updated successfully"
      }
    ]
  },
  {
    "key": "txtInvitationMissingURL",
    "text": "The invitation is missing a link!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف الرابط الخاص في هذه الدعوة!"
      },
      {
        "language": "EN",
        "text": "The invitation is missing a link!"
      }
    ]
  },
  {
    "key": "txtSpreadUploadOnce",
    "text": "once the spreadsheet is uploaded!",
    "translations": [
      {
        "language": "AR",
        "text": "عند تحميل جدول البيانات!"
      },
      {
        "language": "EN",
        "text": "once the spreadsheet is uploaded!"
      }
    ]
  },
  {
    "key": "txtReviewData ",
    "text": "Review Data",
    "translations": [
      {
        "language": "AR",
        "text": "مراجعة البيانات"
      },
      {
        "language": "EN",
        "text": "Review Data"
      }
    ]
  },
  {
    "key": "txtClick",
    "text": "Click ",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ"
      },
      {
        "language": "EN",
        "text": "Click "
      }
    ]
  },
  {
    "key": "txtFilledTemplates",
    "text": "Upload the filled template\t",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل نموذج المعبأ"
      },
      {
        "language": "EN",
        "text": "Upload the filled template\t"
      }
    ]
  },
  {
    "key": "txtFilledDownloadedTemplates",
    "text": "after you've filled the downloaded template and saved it to be uploaded.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل النموذج المعبأ والذي تم حفظه"
      },
      {
        "language": "EN",
        "text": "after you've filled the downloaded template and saved it to be uploaded."
      }
    ]
  },
  {
    "key": "txtUploadNextStep",
    "text": "the file to be uploaded on the next step",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل الملف بالخطوة التالية"
      },
      {
        "language": "EN",
        "text": "the file to be uploaded on the next step"
      }
    ]
  },
  {
    "key": "txtSave",
    "text": "Save",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ"
      },
      {
        "language": "EN",
        "text": "Save"
      }
    ]
  },
  {
    "key": "txtDeleteExample",
    "text": "Note: Please delete the example row",
    "translations": [
      {
        "language": "AR",
        "text": "ملاحظة: يرجى حذف صف المثال"
      },
      {
        "language": "EN",
        "text": "Note: Please delete the example row"
      }
    ]
  },
  {
    "key": "txtFill",
    "text": "Fill",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة"
      },
      {
        "language": "EN",
        "text": "Fill"
      }
    ]
  },
  {
    "key": "txtPremadeStructure",
    "text": "the data without altering the premade structure of the template or changing the file extension (.xlsx)",
    "translations": [
      {
        "language": "AR",
        "text": "البيانات دون تغيير النموذج المعُرف مسبقاً أو تغيير نوع الملف (.xlsx)"
      },
      {
        "language": "EN",
        "text": "the data without altering the premade structure of the template or changing the file extension (.xlsx)"
      }
    ]
  },
  {
    "key": "txtSpreadsheetEditor",
    "text": "the template with your spreadsheet editor i.e. Microsoft Excel",
    "translations": [
      {
        "language": "AR",
        "text": "النموذج باستخدام تطبيق يعدل جدول البيانات مثل Microsoft Excel"
      },
      {
        "language": "EN",
        "text": "the template with your spreadsheet editor i.e. Microsoft Excel"
      }
    ]
  },
  {
    "key": "txt_TemplateDownload",
    "text": "Template Download",
    "translations": [
      {
        "language": "AR",
        "text": "تنزيل النموذج"
      },
      {
        "language": "EN",
        "text": "Template Download"
      }
    ]
  },
  {
    "key": "txtAddNewleaverText",
    "text": "Please select how you want to add the new leaver:",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تحديد الطريقة لإضافة المغادر الجديد:"
      },
      {
        "language": "EN",
        "text": "Please select how you want to add the new leaver:"
      }
    ]
  },
  {
    "key": "txtaddmultipleleaverstotheplatform",
    "text": "You can add multiple leavers to the platform at once using a premade spreadsheet template (.xlsx) file, it contains all the required and optional fields that can be filled with your own data.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك إضافة العديد من الموظفين باستخدام جدول البيانات المُعرف مسبقاً (.xlsx) وهو يتضمن جميع المعلومات المطلوبة والتي يتطلب منك بتعبئتها"
      },
      {
        "language": "EN",
        "text": "You can add multiple leavers to the platform at once using a premade spreadsheet template (.xlsx) file, it contains all the required and optional fields that can be filled with your own data."
      }
    ]
  },
  {
    "key": "txt_Downloadthepremade",
    "text": "Download the premade",
    "translations": [
      {
        "language": "AR",
        "text": "تنزيل الجدول المُعرف مسبقاً"
      },
      {
        "language": "EN",
        "text": "Download the premade"
      }
    ]
  },
  {
    "key": "txtSaveaSpreadsheet",
    "text": "to save a spreadsheet file on your computer first.",
    "translations": [
      {
        "language": "AR",
        "text": "لحفظ ملف جدول البيانات على جهاز الكبيوتر الخاص بك"
      },
      {
        "language": "EN",
        "text": "to save a spreadsheet file on your computer first."
      }
    ]
  },
  {
    "key": "txtClickon",
    "text": "Click on",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على"
      },
      {
        "language": "EN",
        "text": "Click on"
      }
    ]
  },
  {
    "key": "txt_TemplateUpload",
    "text": "Template Upload",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل النموذج"
      },
      {
        "language": "EN",
        "text": "Template Upload"
      }
    ]
  },
  {
    "key": "txt_PopulateTemplate",
    "text": "Populate Template",
    "translations": [
      {
        "language": "AR",
        "text": "تعبئة النموذج"
      },
      {
        "language": "EN",
        "text": "Populate Template"
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_subject",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      },
      {
        "language": "EN",
        "text": "Confirmation"
      }
    ]
  },
  {
    "key": "txt_ReminderSent",
    "text": "Reminder has been sent",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال التذكير"
      },
      {
        "language": "EN",
        "text": "Reminder has been sent"
      }
    ]
  },
  {
    "key": "txt_years",
    "text": "Year(s)",
    "translations": [
      {
        "language": "AR",
        "text": "أعوام"
      },
      {
        "language": "EN",
        "text": "Year(s)"
      }
    ]
  },
  {
    "key": "txt_SuccessfullyAdded",
    "text": "has been added successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تمت الإضافة بنجاح"
      },
      {
        "language": "EN",
        "text": "has been added successfully!"
      }
    ]
  },
  {
    "key": "txt_Submit",
    "text": "Submit",
    "translations": [
      {
        "language": "AR",
        "text": "يُقدِّم"
      },
      {
        "language": "EN",
        "text": "Submit"
      }
    ]
  },
  {
    "key": "txt_FillFormCorrectly",
    "text": "Kindly fill the form correctly\t",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة النموذج بشكل صحيح"
      },
      {
        "language": "EN",
        "text": "Kindly fill the form correctly\t"
      }
    ]
  },
  {
    "key": "txtReminderMissingURL",
    "text": "The reminder is missing a link!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف الرابط الخاص في هذا التذكير!"
      },
      {
        "language": "EN",
        "text": "The reminder is missing a link!"
      }
    ]
  },
  {
    "key": "txtReminderEmailTemplate",
    "text": "Reminder Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني للتذكير"
      },
      {
        "language": "EN",
        "text": "Reminder Email Template"
      }
    ]
  },
  {
    "key": "txt_add_reminder",
    "text": "Add Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة تذكير"
      },
      {
        "language": "EN",
        "text": "Add Reminder"
      }
    ]
  },
  {
    "key": "txt_SendReminderOn",
    "text": "Send Reminder on:",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكير في"
      },
      {
        "language": "EN",
        "text": "Send Reminder on:"
      }
    ]
  },
  {
    "key": "txtInvitationEmailTemplate",
    "text": "Invitation Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني للدعوة"
      },
      {
        "language": "EN",
        "text": "Invitation Email Template"
      }
    ]
  },
  {
    "key": "txtEmailTemplates",
    "text": "Email Templates",
    "translations": [
      {
        "language": "AR",
        "text": "نماذج البريد الإلكتروني"
      },
      {
        "language": "EN",
        "text": "Email Templates"
      }
    ]
  },
  {
    "key": "txtAutomatedReminders",
    "text": "Automated Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "ضبط التذكيرات"
      },
      {
        "language": "EN",
        "text": "Automated Reminders"
      }
    ]
  },
  {
    "key": "txt_Next",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "EN",
        "text": "Next"
      }
    ]
  },
  {
    "key": "txt_PhoneNumber",
    "text": "Phone Number",
    "translations": [
      {
        "language": "AR",
        "text": "رقم الهاتف المحمول"
      },
      {
        "language": "EN",
        "text": "Phone Number"
      }
    ]
  },
  {
    "key": "txt_SurveyOptions",
    "text": "Survey Options",
    "translations": [
      {
        "language": "AR",
        "text": "خيارات الاستبيان"
      },
      {
        "language": "EN",
        "text": "Survey Options"
      }
    ]
  },
  {
    "key": "txt_PositionInfo",
    "text": "Position Info",
    "translations": [
      {
        "language": "AR",
        "text": "المعلومات الوظيفية"
      },
      {
        "language": "EN",
        "text": "Position Info"
      }
    ]
  },
  {
    "key": "txt_PersonalInfo",
    "text": "Personal Info",
    "translations": [
      {
        "language": "AR",
        "text": "المعلومات الشخصية"
      },
      {
        "language": "EN",
        "text": "Personal Info"
      }
    ]
  },
  {
    "key": "btn_edit",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "EN",
        "text": "Edit"
      }
    ]
  },
  {
    "key": "btn_delete",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "EN",
        "text": "Delete"
      }
    ]
  },
  {
    "key": "txt_editor_NewQuestion",
    "text": "New Question",
    "translations": [
      {
        "language": "AR",
        "text": "سؤال جديد"
      },
      {
        "language": "EN",
        "text": "New Question"
      }
    ]
  },
  {
    "key": "txtDriverName",
    "text": "Factor Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم العامل"
      },
      {
        "language": "EN",
        "text": "Factor Name"
      }
    ]
  },
  {
    "key": "txt_editor_NewCustom_Factor",
    "text": "New Custom Factor",
    "translations": [
      {
        "language": "AR",
        "text": "عامل مخصص جديد"
      },
      {
        "language": "EN",
        "text": "New Custom Factor"
      }
    ]
  },
  {
    "key": "txt_editor_newstatement",
    "text": "New Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      },
      {
        "language": "EN",
        "text": "New Statement"
      }
    ]
  },
  {
    "key": "txt_editor_Addupto_statements",
    "text": "Add Up to 4 statements",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإضافة ما يصل إلى 4 عبارات"
      },
      {
        "language": "EN",
        "text": "Add Up to 4 statements"
      }
    ]
  },
  {
    "key": "txt_editor_statements_of",
    "text": "STATEMENTS OF ",
    "translations": [
      {
        "language": "AR",
        "text": "عبارات"
      },
      {
        "language": "EN",
        "text": "STATEMENTS OF "
      }
    ]
  },
  {
    "key": "txt_editor_Selectupto_factor",
    "text": "Select up to 8 factors",
    "translations": [
      {
        "language": "AR",
        "text": "قم باختيار 8 عوامل كحد أقصى"
      },
      {
        "language": "EN",
        "text": "Select up to 8 factors"
      }
    ]
  },
  {
    "key": "txtCustomFactors",
    "text": "Custom Factors",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل مخصصة"
      },
      {
        "language": "EN",
        "text": "Custom Factors"
      }
    ]
  },
  {
    "key": "txtGeneralRecommendations",
    "text": "General Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "توصيات عامة"
      },
      {
        "language": "EN",
        "text": "General Recommendations"
      }
    ]
  },
  {
    "key": "txtFactors",
    "text": "Factors",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل خروج الموظفين"
      },
      {
        "language": "EN",
        "text": "Factors"
      }
    ]
  },
  {
    "key": "txtGeneralQuestions",
    "text": "General Questions",
    "translations": [
      {
        "language": "AR",
        "text": "أسئلة عامة"
      },
      {
        "language": "EN",
        "text": "General Questions"
      }
    ]
  },
  {
    "key": "txt_survey_info",
    "text": "Survey Information",
    "translations": [
      {
        "language": "AR",
        "text": "معلومات الاستبيان"
      },
      {
        "language": "EN",
        "text": "Survey Information"
      }
    ]
  },
  {
    "key": "txtDeleteTemplate",
    "text": "Delete Template",
    "translations": [
      {
        "language": "AR",
        "text": "حذف النموذج"
      },
      {
        "language": "EN",
        "text": "Delete Template"
      }
    ]
  },
  {
    "key": "txtExportTemplate",
    "text": "Export Template",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل النموذج"
      },
      {
        "language": "EN",
        "text": "Export Template"
      }
    ]
  },
  {
    "key": "txt_template_name",
    "text": "Template Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم النموذج"
      },
      {
        "language": "EN",
        "text": "Template Name"
      }
    ]
  },
  {
    "key": "txtUpdateTemplate",
    "text": "Update Template",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث النموذج"
      },
      {
        "language": "EN",
        "text": "Update Template"
      }
    ]
  },
  {
    "key": "txtCreateTemplate",
    "text": "Create Template",
    "translations": [
      {
        "language": "AR",
        "text": "أنشئ نموذج"
      },
      {
        "language": "EN",
        "text": "Create Template"
      }
    ]
  },
  {
    "key": "txt_NewTemplate",
    "text": "New Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج جديد"
      },
      {
        "language": "EN",
        "text": "New Template"
      }
    ]
  },
  {
    "key": "txt_PREDEFINEDTEMPLATES",
    "text": "Predefined Templates",
    "translations": [
      {
        "language": "AR",
        "text": "نماذج مُعرفة مسبقاً"
      },
      {
        "language": "EN",
        "text": "Predefined Templates"
      }
    ]
  },
  {
    "key": "txt_CUSTOMTEMPLATES",
    "text": "Custom Templates",
    "translations": [
      {
        "language": "AR",
        "text": "نماذج مخصصة"
      },
      {
        "language": "EN",
        "text": "Custom Templates"
      }
    ]
  },
  {
    "key": "txt_send_reminders",
    "text": "Send Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات"
      },
      {
        "language": "EN",
        "text": "Send Reminders"
      }
    ]
  },
  {
    "key": "txtViewBy",
    "text": "View By",
    "translations": [
      {
        "language": "AR",
        "text": "عرض حسب"
      },
      {
        "language": "EN",
        "text": "View By"
      }
    ]
  },
  {
    "key": "txtNotStarted",
    "text": "Not Started",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم تعبئة الاستبيان"
      },
      {
        "language": "EN",
        "text": "Not Started"
      }
    ]
  },
  {
    "key": "txtSwitchTemplate",
    "text": "Switch Template",
    "translations": [
      {
        "language": "AR",
        "text": "اختر نموذج"
      },
      {
        "language": "EN",
        "text": "Switch Template"
      }
    ]
  },
  {
    "key": "txtOverview",
    "text": "Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة"
      },
      {
        "language": "EN",
        "text": "Overview"
      }
    ]
  },
  {
    "key": "txt_completed_318",
    "text": "completed",
    "translations": [
      {
        "language": "AR",
        "text": "منجز"
      },
      {
        "language": "EN",
        "text": "completed"
      }
    ]
  },
  {
    "key": "txt__all_766",
    "text": "_all",
    "translations": [
      {
        "language": "AR",
        "text": "_الجميع"
      },
      {
        "language": "EN",
        "text": "_all"
      }
    ]
  },
  {
    "key": "txt_LEAVERSBY_660",
    "text": "LEAVERS BY STATUS",
    "translations": [
      {
        "language": "AR",
        "text": "الموظفون المغادرون حسب الحالة"
      },
      {
        "language": "EN",
        "text": "LEAVERS BY STATUS"
      }
    ]
  },
  {
    "key": "txt_Permissio_766",
    "text": "Permission Required",
    "translations": [
      {
        "language": "AR",
        "text": "الترخيص مطلوب"
      },
      {
        "language": "EN",
        "text": "Permission Required"
      }
    ]
  },
  {
    "key": "txt_otherindu_175",
    "text": "other industries",
    "translations": [
      {
        "language": "AR",
        "text": "قطاعات أخرى"
      },
      {
        "language": "EN",
        "text": "other industries"
      }
    ]
  },
  {
    "key": "txtVeryPoor",
    "text": "Very Poor",
    "translations": [
      {
        "language": "EN",
        "text": "Very Poor"
      },
      {
        "language": "AR",
        "text": "سيئة للغاية"
      },
      {
        "language": "FR",
        "text": "très mauvaise"
      }
    ]
  },
  {
    "key": "txtVeryGood",
    "text": "Very Good",
    "translations": [
      {
        "language": "EN",
        "text": "Very Good"
      },
      {
        "language": "AR",
        "text": "جيدة للغاية"
      },
      {
        "language": "FR",
        "text": "très bonne"
      }
    ]
  },
  {
    "key": "VERYPOOREXP",
    "text": "Very Poor Experience",
    "translations": [
      {
        "language": "EN",
        "text": "Very Poor Experience"
      },
      {
        "language": "AR",
        "text": "تجربة سيئة للغاية"
      }
    ]
  },
  {
    "key": "POOREXP",
    "text": "Poor Experience",
    "translations": [
      {
        "language": "EN",
        "text": "Poor Experience"
      },
      {
        "language": "AR",
        "text": "تجربة سيئة "
      }
    ]
  },
  {
    "key": "FAIREXP",
    "text": "Fair Experience",
    "translations": [
      {
        "language": "EN",
        "text": "Fair Experience"
      },
      {
        "language": "AR",
        "text": "تجربة معتدلة"
      }
    ]
  },
  {
    "key": "GOODEXP",
    "text": "Good Experience",
    "translations": [
      {
        "language": "EN",
        "text": "Good Experience"
      },
      {
        "language": "AR",
        "text": "تجربة جيدة"
      }
    ]
  },
  {
    "key": "txtClearTimeFrame",
    "text": "Clear Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "إزالة المدة الزمنية"
      },
      {
        "language": "FR",
        "text": "Effacer a délai"
      },
      {
        "language": "EN",
        "text": "Clear Timeframe"
      }
    ]
  },
  {
    "key": "txtFindleavers",
    "text": "Search leavers...",
    "translations": [
      {
        "language": "AR",
        "text": "ابحث عن موظف..."
      },
      {
        "language": "FR",
        "text": "Rechercher des Répondants "
      },
      {
        "language": "EN",
        "text": "Search leavers..."
      }
    ]
  },
  {
    "key": "txtOpen",
    "text": "Open",
    "translations": [
      {
        "language": "AR",
        "text": "فتح"
      },
      {
        "language": "EN",
        "text": "Open"
      }
    ]
  },
  {
    "key": "txtDashboard",
    "text": "Dashboard",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة البيانات"
      },
      {
        "language": "FR",
        "text": "Tableau des Données "
      },
      {
        "language": "EN",
        "text": "Dashboard"
      }
    ]
  },
  {
    "key": "txtTotal",
    "text": "Total ",
    "translations": [
      {
        "language": "AR",
        "text": "المجموع"
      },
      {
        "language": "FR",
        "text": "Total "
      },
      {
        "language": "EN",
        "text": "Total "
      }
    ]
  },
  {
    "key": "txtTo",
    "text": "To ",
    "translations": [
      {
        "language": "AR",
        "text": "إلى"
      },
      {
        "language": "EN",
        "text": "To "
      }
    ]
  },
  {
    "key": "btn_add",
    "text": "Add",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة"
      },
      {
        "language": "FR",
        "text": "Ajouter"
      },
      {
        "language": "EN",
        "text": "Add"
      }
    ]
  },
  {
    "key": "txtEntity",
    "text": "Entity",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة"
      },
      {
        "language": "FR",
        "text": "Unité "
      },
      {
        "language": "EN",
        "text": "Entity"
      }
    ]
  },
  {
    "key": "txtReportsto",
    "text": "Reports to",
    "translations": [
      {
        "language": "AR",
        "text": "تابع ل"
      },
      {
        "language": "FR",
        "text": "Rapporter ŕ"
      },
      {
        "language": "EN",
        "text": "Reports to"
      }
    ]
  },
  {
    "key": "btn_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": "Annuler "
      },
      {
        "language": "EN",
        "text": "Cancel"
      }
    ]
  },
  {
    "key": "txtExportReport",
    "text": "Download Report",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      },
      {
        "language": "FR",
        "text": "Rapport de Téléchargement"
      },
      {
        "language": "EN",
        "text": "Download Report"
      }
    ]
  },
  {
    "key": "txtSpecifyHere",
    "text": "Specify here...",
    "translations": [
      {
        "language": "AR",
        "text": "وضح هنا..."
      },
      {
        "language": "FR",
        "text": "Précisez ici ..."
      },
      {
        "language": "EN",
        "text": "Specify here..."
      }
    ]
  },
  {
    "key": "txtQ",
    "text": "Q",
    "translations": [
      {
        "language": "AR",
        "text": "س"
      },
      {
        "language": "FR",
        "text": "Q"
      },
      {
        "language": "EN",
        "text": "Q"
      }
    ]
  },
  {
    "key": "txtMostLiked",
    "text": "Most Liked...",
    "translations": [
      {
        "language": "AR",
        "text": "الأكثر تفضيلاً"
      },
      {
        "language": "FR",
        "text": "Le Plus Préféré..."
      },
      {
        "language": "EN",
        "text": "Most Liked..."
      }
    ]
  },
  {
    "key": "txtLeastLiked",
    "text": "Least Liked...",
    "translations": [
      {
        "language": "AR",
        "text": "الأقل تفضيلاً"
      },
      {
        "language": "FR",
        "text": "Le Moins Préféré..."
      },
      {
        "language": "EN",
        "text": "Least Liked..."
      }
    ]
  },
  {
    "key": "btn_back",
    "text": "Back",
    "translations": [
      {
        "language": "AR",
        "text": "عودة"
      },
      {
        "language": "FR",
        "text": "Retour"
      },
      {
        "language": "BN",
        "text": "পূর্ববর্তী"
      },
      {
        "language": "EN",
        "text": "Back"
      }
    ]
  },
  {
    "key": "txtSAnswers",
    "text": "'s Answers",
    "translations": [
      {
        "language": "AR",
        "text": "أجوبة "
      },
      {
        "language": "FR",
        "text": "Réponses de"
      },
      {
        "language": "EN",
        "text": "'s Answers"
      }
    ]
  },
  {
    "key": "txtLeaversAnswers",
    "text": "Leaver Answers",
    "translations": [
      {
        "language": "AR",
        "text": "أجوبة الموظف المغادر"
      },
      {
        "language": "EN",
        "text": "Leaver Answers"
      }
    ]
  },
  {
    "key": "txt_leaver_employee_ID",
    "text": "Leaver ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      },
      {
        "language": "FR",
        "text": "ID du Sortant"
      },
      {
        "language": "EN",
        "text": "Leaver ID"
      }
    ]
  },
  {
    "key": "txt_leaver_employee_name",
    "text": "Leaver's Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الموظف"
      },
      {
        "language": "FR",
        "text": "Nom du Sortant"
      },
      {
        "language": "EN",
        "text": "Leaver's Name"
      }
    ]
  },
  {
    "key": "txt_leaver_email",
    "text": "Email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني"
      },
      {
        "language": "FR",
        "text": "Email (Courrier électronique)"
      },
      {
        "language": "BN",
        "text": "ইমেইল"
      },
      {
        "language": "EN",
        "text": "Email"
      }
    ]
  },
  {
    "key": "txt_country_code",
    "text": "Country Code",
    "translations": [
      {
        "language": "AR",
        "text": "رمز الدولة"
      },
      {
        "language": "FR",
        "text": "Code postal"
      },
      {
        "language": "EN",
        "text": "Country Code"
      }
    ]
  },
  {
    "key": "Next Step",
    "text": "Next Step",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية"
      },
      {
        "language": "EN",
        "text": "Next Step"
      }
    ]
  },
  {
    "key": "txt_dashboard_export",
    "text": "Dashboard",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة البيانات"
      },
      {
        "language": "FR",
        "text": "Tableau des Données "
      },
      {
        "language": "EN",
        "text": "Dashboard"
      }
    ]
  },
  {
    "key": "txt_country_code",
    "text": "Country Code",
    "translations": [
      {
        "language": "AR",
        "text": "رمز الدولة"
      },
      {
        "language": "FR",
        "text": "Code postal"
      }
    ]
  },
  {
    "key": "txt_updated_success",
    "text": "Updated Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم التحديث بنجاح!"
      },
      {
        "language": "FR",
        "text": "Mise ŕ jour avec Succčs!"
      },
      {
        "language": "EN",
        "text": "Updated Successfully!"
      }
    ]
  },
  {
    "key": "txt_okay_action",
    "text": "Okay",
    "translations": [
      {
        "language": "AR",
        "text": "حسناً"
      },
      {
        "language": "FR",
        "text": "D'accord"
      },
      {
        "language": "EN",
        "text": "Okay"
      }
    ]
  },
  {
    "key": "txt_unit_deduction",
    "text": "#UNITS# units will be deducted for this action",
    "translations": [
      {
        "language": "AR",
        "text": "#UNITS# وحدة سيتم خصمها لعمل هذا الاستبيان"
      },
      {
        "language": "FR",
        "text": "#UNITS# les unités seront déduites pour cette action"
      },
      {
        "language": "EN",
        "text": "#UNITS# units will be deducted for this action"
      }
    ]
  },
  {
    "key": "Set due date on",
    "text": "Set due date on",
    "translations": [
      {
        "language": "AR",
        "text": "عيِِن تاريخ الاتمام في"
      },
      {
        "language": "EN",
        "text": "Set due date on"
      }
    ]
  },
  {
    "key": "txt_leaver_mobile_number",
    "text": "Mobile Number",
    "translations": [
      {
        "language": "AR",
        "text": "رقم الهاتف المحمول"
      },
      {
        "language": "FR",
        "text": "Numéro de Portable"
      },
      {
        "language": "EN",
        "text": "Mobile Number"
      }
    ]
  },
  {
    "key": "txt_leaver_date_of_birth",
    "text": "Date of Birth",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الميلاد"
      },
      {
        "language": "FR",
        "text": "Date de Naissance "
      },
      {
        "language": "BN",
        "text": "জন্ম তারিখ"
      },
      {
        "language": "EN",
        "text": "Date of Birth"
      }
    ]
  },
  {
    "key": "txt_leaver_gender",
    "text": "Gender",
    "translations": [
      {
        "language": "AR",
        "text": "الجنس"
      },
      {
        "language": "FR",
        "text": "Sexe "
      },
      {
        "language": "HI",
        "text": "लिंग"
      },
      {
        "language": "TA",
        "text": "Kasarian"
      },
      {
        "language": "UR",
        "text": "جنس"
      },
      {
        "language": "BN",
        "text": "লিঙ্গ"
      },
      {
        "language": "EN",
        "text": "Gender"
      }
    ]
  },
  {
    "key": "txt_leaver_nationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "الجنسية"
      },
      {
        "language": "FR",
        "text": "Nationalité"
      },
      {
        "language": "HI",
        "text": "राष्ट्रीयता"
      },
      {
        "language": "TA",
        "text": "Nasyonalidad"
      },
      {
        "language": "UR",
        "text": "قومیت"
      },
      {
        "language": "BN",
        "text": "জাতীয়তা"
      },
      {
        "language": "EN",
        "text": "Nationality"
      }
    ]
  },
  {
    "key": "txt_entity_group_name",
    "text": "New Entity",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة"
      },
      {
        "language": "FR",
        "text": "Unité"
      },
      {
        "language": "EN",
        "text": "New Entity"
      }
    ]
  },
  {
    "key": "btn_add_structure_entity",
    "text": "Add Entity",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة وحدة"
      },
      {
        "language": "FR",
        "text": "Ajouter une Entité"
      },
      {
        "language": "EN",
        "text": "Add Entity"
      }
    ]
  },
  {
    "key": "txt_entity_name",
    "text": "Entity Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الوحدة"
      },
      {
        "language": "FR",
        "text": "Nom de l’Unité"
      },
      {
        "language": "EN",
        "text": "Entity Name"
      }
    ]
  },
  {
    "key": "btn_update",
    "text": "Update",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث"
      },
      {
        "language": "FR",
        "text": "Mettre ŕ jour"
      },
      {
        "language": "EN",
        "text": "Update"
      }
    ]
  },
  {
    "key": "txt_group_name",
    "text": "Entity Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الوحدة"
      },
      {
        "language": "FR",
        "text": "Type d’Unité"
      },
      {
        "language": "EN",
        "text": "Entity Type"
      }
    ]
  },
  {
    "key": "txt_define_entities_reports",
    "text": "Define Entities belonging to ",
    "translations": [
      {
        "language": "AR",
        "text": "عرّف الوحدات التي تنتمي إلى"
      },
      {
        "language": "FR",
        "text": "Définir les entités appartenant ŕ "
      },
      {
        "language": "EN",
        "text": "Define Entities belonging to "
      }
    ]
  },
  {
    "key": "txt_parent_entity_group",
    "text": "Parent Entity",
    "translations": [
      {
        "language": "AR",
        "text": "الوحدة الأم"
      },
      {
        "language": "FR",
        "text": "Société mčre"
      },
      {
        "language": "EN",
        "text": "Parent Entity"
      }
    ]
  },
  {
    "key": "txt_leaver_job_title",
    "text": "Job Title",
    "translations": [
      {
        "language": "AR",
        "text": "المسمى الوظيفي"
      },
      {
        "language": "FR",
        "text": "Titre d'Emploi"
      },
      {
        "language": "EN",
        "text": "Job Title"
      }
    ]
  },
  {
    "key": "txt_leaver_direct_manager_name",
    "text": "Direct Manager's Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المدير المباشر"
      },
      {
        "language": "FR",
        "text": "Nom du Directeur Directe"
      },
      {
        "language": "EN",
        "text": "Direct Manager's Name"
      }
    ]
  },
  {
    "key": "txt_leaver_job_level",
    "text": "Band Level",
    "translations": [
      {
        "language": "AR",
        "text": "المستوى الوظيفي"
      },
      {
        "language": "FR",
        "text": "Niveau d'Emploi"
      },
      {
        "language": "EN",
        "text": "Band Level"
      }
    ]
  },
  {
    "key": "txt_leaver_job_grade",
    "text": "Job Grade",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الوظيفية"
      },
      {
        "language": "FR",
        "text": "Catégorie d'Emploi"
      },
      {
        "language": "EN",
        "text": "Job Grade"
      }
    ]
  },
  {
    "key": "txt_leaver_performance_rate",
    "text": "Performance Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل تقييم الأداء"
      },
      {
        "language": "FR",
        "text": "Taux de Performance"
      },
      {
        "language": "EN",
        "text": "Performance Rate"
      }
    ]
  },
  {
    "key": "txt_leaver_seperation_type",
    "text": "Separation Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الفصل"
      },
      {
        "language": "FR",
        "text": "Type de Séparation"
      },
      {
        "language": "EN",
        "text": "Separation Type"
      }
    ]
  },
  {
    "key": "txtPoweredby",
    "text": "Powered by:",
    "translations": [
      {
        "language": "AR",
        "text": "مشغّل بواسطة"
      },
      {
        "language": "FR",
        "text": "Alimenté par:"
      },
      {
        "language": "BN",
        "text": "দ্বারা চালিত:"
      },
      {
        "language": "EN",
        "text": "Powered by:"
      }
    ]
  },
  {
    "key": "txt_leaver_seperation_types",
    "text": "Separation Types",
    "translations": [
      {
        "language": "AR",
        "text": "أنواع الفصل"
      },
      {
        "language": "EN",
        "text": "Separation Types"
      }
    ]
  },
  {
    "key": "txt_leaver_seperation_date",
    "text": "Seperation Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الفصل"
      },
      {
        "language": "FR",
        "text": "Date de Séparation d’emploi"
      },
      {
        "language": "EN",
        "text": "Seperation Date"
      }
    ]
  },
  {
    "key": "txt_leaver_end_date",
    "text": "Survey Completion Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء من الاستبيان"
      },
      {
        "language": "FR",
        "text": "Date d’Achčvement du Enquęte"
      },
      {
        "language": "EN",
        "text": "Survey Completion Date"
      }
    ]
  },
  {
    "key": "txt_direct_manager_ID",
    "text": "Direct Manager ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي للمدير المباشر"
      },
      {
        "language": "FR",
        "text": "ID du Directeur Direct"
      },
      {
        "language": "EN",
        "text": "Direct Manager ID"
      }
    ]
  },
  {
    "key": "txtOverallResponseRate",
    "text": "Overall Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة العام"
      },
      {
        "language": "FR",
        "text": "Taux de Réponse Global"
      },
      {
        "language": "EN",
        "text": "Overall Response Rate"
      }
    ]
  },
  {
    "key": "txtRespbygender",
    "text": "Respondents by Gender",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب الجنس"
      },
      {
        "language": "FR",
        "text": "Répondants par Sexe"
      },
      {
        "language": "EN",
        "text": "Respondents by Gender"
      }
    ]
  },
  {
    "key": "txtRespby",
    "text": "Respondents by ",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب "
      },
      {
        "language": "EN",
        "text": "Respondents by "
      }
    ]
  },
  {
    "key": "txtRespbynationality",
    "text": "Respondents by Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب الجنسية"
      },
      {
        "language": "FR",
        "text": "Répondants par Nationalité"
      },
      {
        "language": "EN",
        "text": "Respondents by Nationality"
      }
    ]
  },
  {
    "key": "txtRespBySepType",
    "text": "Respondents by Seperation Type",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب نوع الفصل"
      },
      {
        "language": "EN",
        "text": "Respondents by Seperation Type"
      }
    ]
  },
  {
    "key": "txtUseSpreadsheet",
    "text": "Use a spreadsheet",
    "translations": [
      {
        "language": "AR",
        "text": "استعمل جدول"
      },
      {
        "language": "EN",
        "text": "Use a spreadsheet"
      }
    ]
  },
  {
    "key": "txtID",
    "text": "ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      },
      {
        "language": "FR",
        "text": "ID"
      },
      {
        "language": "EN",
        "text": "ID"
      }
    ]
  },
  {
    "key": "btn_add_manually",
    "text": "Add Manually",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة يدوية"
      },
      {
        "language": "FR",
        "text": "Ajouter Manuellement"
      },
      {
        "language": "EN",
        "text": "Add Manually"
      }
    ]
  },
  {
    "key": "txt_date_of_birth",
    "text": "Date of Birth",
    "translations": [
      {
        "language": "AR",
        "text": "تاريح الميلاد"
      },
      {
        "language": "FR",
        "text": "Date de Naissance "
      },
      {
        "language": "BN",
        "text": "জন্ম তারিখ"
      },
      {
        "language": "EN",
        "text": "Date of Birth"
      }
    ]
  },
  {
    "key": "btn_previous",
    "text": "Previous",
    "translations": [
      {
        "language": "AR",
        "text": "السابق"
      },
      {
        "language": "FR",
        "text": "Précédent"
      },
      {
        "language": "EN",
        "text": "Previous"
      }
    ]
  },
  {
    "key": "txtPerformance",
    "text": "Performance",
    "translations": [
      {
        "language": "AR",
        "text": "الأداء"
      },
      {
        "language": "FR",
        "text": "Performance"
      },
      {
        "language": "BN",
        "text": "কর্মক্ষমতা"
      },
      {
        "language": "EN",
        "text": "Performance"
      }
    ]
  },
  {
    "key": "txt_survey",
    "text": "Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان"
      },
      {
        "language": "FR",
        "text": "Enquęte"
      },
      {
        "language": "EN",
        "text": "Survey"
      }
    ]
  },
  {
    "key": "txt_survey_questions",
    "text": "Survey Questions",
    "translations": [
      {
        "language": "AR",
        "text": "أسئلة الاستبيان"
      },
      {
        "language": "BN",
        "text": "সমীক্ষা প্রশ্ন"
      },
      {
        "language": "EN",
        "text": "Survey Questions"
      }
    ]
  },
  {
    "key": "txtColumnName",
    "text": "Column Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم العمود"
      },
      {
        "language": "EN",
        "text": "Column Name"
      }
    ]
  },
  {
    "key": "txt_notStartedYet",
    "text": "Not Started Yet",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم البدء بالعمل عليه بعد"
      },
      {
        "language": "EN",
        "text": "Not Started Yet"
      }
    ]
  },
  {
    "key": "txt_scheduled",
    "text": "Scheduled",
    "translations": [
      {
        "language": "AR",
        "text": "مجدولة"
      },
      {
        "language": "EN",
        "text": "Scheduled"
      }
    ]
  },
  {
    "key": "txt_status",
    "text": "Status",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      },
      {
        "language": "FR",
        "text": "Statut "
      },
      {
        "language": "EN",
        "text": "Status"
      }
    ]
  },
  {
    "key": "txt_dashboard",
    "text": "Dashboard",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة البيانات"
      },
      {
        "language": "FR",
        "text": "Tableau des Données "
      },
      {
        "language": "EN",
        "text": "Dashboard"
      }
    ]
  },
  {
    "key": "txt_completed",
    "text": "Completed",
    "translations": [
      {
        "language": "AR",
        "text": "مكتمل"
      },
      {
        "language": "FR",
        "text": "Complet"
      },
      {
        "language": "EN",
        "text": "Completed"
      }
    ]
  },
  {
    "key": "txt_expired",
    "text": "Expired",
    "translations": [
      {
        "language": "AR",
        "text": "منتهي الصلاحية"
      },
      {
        "language": "FR",
        "text": "Expiré"
      },
      {
        "language": "EN",
        "text": "Expired"
      }
    ]
  },
  {
    "key": "txtComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "FR",
        "text": "Commentaires"
      },
      {
        "language": "EN",
        "text": "Comments"
      }
    ]
  },
  {
    "key": "txtComment",
    "text": "Comment",
    "translations": [
      {
        "language": "AR",
        "text": "تعليق"
      },
      {
        "language": "FR",
        "text": "Commentaire"
      },
      {
        "language": "EN",
        "text": "Comment"
      }
    ]
  },
  {
    "key": "txtComments2",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تعليقات"
      },
      {
        "language": "EN",
        "text": "Comments"
      }
    ]
  },
  {
    "key": "txtDefinitions",
    "text": "Definitions",
    "translations": [
      {
        "language": "AR",
        "text": "التعريفات"
      },
      {
        "language": "EN",
        "text": "Definitions"
      }
    ]
  },
  {
    "key": "Selected Different Industries",
    "text": "Selected Different Industries",
    "translations": [
      {
        "language": "AR",
        "text": "القطاعات المختلفة المختارة"
      },
      {
        "language": "EN",
        "text": "Selected Different Industries"
      }
    ]
  },
  {
    "key": "Driver / Question",
    "text": "Factor / Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عامل / عبارة"
      },
      {
        "language": "EN",
        "text": "Factor / Statement"
      }
    ]
  },
  {
    "key": "Leavers By Seperation Type",
    "text": "Leavers By Seperation Type",
    "translations": [
      {
        "language": "AR",
        "text": "الموظفون المغادرون حسب نوع الفصل"
      },
      {
        "language": "EN",
        "text": "Leavers By Seperation Type"
      }
    ]
  },
  {
    "key": "txtLeaversAnalysis",
    "text": "Leavers' Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات المغادرين"
      },
      {
        "language": "EN",
        "text": "Leavers' Analysis"
      }
    ]
  },
  {
    "key": "txtEmployeeSatisfactionRate",
    "text": "Leavers Experience Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل تجربة الموظفين المغادرين"
      },
      {
        "language": "EN",
        "text": "Leavers Experience Rate"
      }
    ]
  },
  {
    "key": "txtEXTREMELYUNSATISFIED",
    "text": "VERY POOR EXPERIENCE",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة سيئة للغاية"
      },
      {
        "language": "EN",
        "text": "VERY POOR EXPERIENCE"
      }
    ]
  },
  {
    "key": "txtUNSATISFIED",
    "text": "POOR EXPERIENCE",
    "translations": [
      {
        "language": "AR",
        "text": " تجربة سيئة"
      },
      {
        "language": "EN",
        "text": "POOR EXPERIENCE"
      }
    ]
  },
  {
    "key": "txtof",
    "text": "of",
    "translations": [
      {
        "language": "AR",
        "text": "من"
      },
      {
        "language": "FR",
        "text": "De"
      },
      {
        "language": "BN",
        "text": "এর"
      },
      {
        "language": "EN",
        "text": "of"
      }
    ]
  },
  {
    "key": "txtNeutral",
    "text": "FAIR EXPERIENCE",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة معتدلة"
      },
      {
        "language": "FR",
        "text": "Modéré"
      },
      {
        "language": "EN",
        "text": "FAIR EXPERIENCE"
      }
    ]
  },
  {
    "key": "txtPromoters",
    "text": "Promoters",
    "translations": [
      {
        "language": "AR",
        "text": "المروجون"
      },
      {
        "language": "EN",
        "text": "Promoters"
      }
    ]
  },
  {
    "key": "txtPassives",
    "text": "Passives",
    "translations": [
      {
        "language": "AR",
        "text": "السلبيون (الغير مروجين)"
      },
      {
        "language": "EN",
        "text": "Passives"
      }
    ]
  },
  {
    "key": "txtPromotersDef",
    "text": "the employees who select a score of 9 or 10; are positive, motivated, and satisfied people.",
    "translations": [
      {
        "language": "AR",
        "text": "هم الذين أجابوا السؤال من 9 إلى 10 وهم المروجون والموظفون الأوفياء."
      },
      {
        "language": "EN",
        "text": "the employees who select a score of 9 or 10; are positive, motivated, and satisfied people."
      }
    ]
  },
  {
    "key": "txtPassivesDef",
    "text": "the employees who select a score of 7 or 8; are neutral, maybe content, or even not fully dedicated to the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "هم الذين أجابوا السؤال من 7 إلى 8 لأنهم معجبون بالعمل أو الشركة ولكنهم غير راضين بشكل كافٍ للتوصية بها للآخرين."
      },
      {
        "language": "EN",
        "text": "the employees who select a score of 7 or 8; are neutral, maybe content, or even not fully dedicated to the workplace."
      }
    ]
  },
  {
    "key": "txtTenure",
    "text": "Tenure",
    "translations": [
      {
        "language": "AR",
        "text": "سنوات الخدمة"
      },
      {
        "language": "EN",
        "text": "Tenure"
      }
    ]
  },
  {
    "key": "txt_search",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      },
      {
        "language": "FR",
        "text": "Rechercher"
      },
      {
        "language": "EN",
        "text": "Search"
      }
    ]
  },
  {
    "key": "txt_start_date",
    "text": "Start Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء"
      },
      {
        "language": "FR",
        "text": "Date de Début "
      },
      {
        "language": "EN",
        "text": "Start Date"
      }
    ]
  },
  {
    "key": "txt_end_date",
    "text": "End Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء"
      },
      {
        "language": "FR",
        "text": "Date de Fin"
      },
      {
        "language": "EN",
        "text": "End Date"
      }
    ]
  },
  {
    "key": "txtNA",
    "text": "N/A",
    "translations": [
      {
        "language": "AR",
        "text": "لا ينطبق"
      },
      {
        "language": "FR",
        "text": "N/A"
      },
      {
        "language": "EN",
        "text": "N/A"
      }
    ]
  },
  {
    "key": "txtStronglyDisagree",
    "text": "Strongly Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق بشدة"
      },
      {
        "language": "FR",
        "text": "Fortement en désaccord"
      },
      {
        "language": "EN",
        "text": "Strongly Disagree"
      }
    ]
  },
  {
    "key": "txtDisagree",
    "text": "Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق"
      },
      {
        "language": "FR",
        "text": "Désaccord"
      },
      {
        "language": "EN",
        "text": "Disagree"
      }
    ]
  },
  {
    "key": "txtAgree",
    "text": "Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق"
      },
      {
        "language": "FR",
        "text": "Accepter "
      },
      {
        "language": "EN",
        "text": "Agree"
      }
    ]
  },
  {
    "key": "btn_leaver_list_view_answers",
    "text": "View Answers",
    "translations": [
      {
        "language": "AR",
        "text": "تصفح الأجوبة"
      },
      {
        "language": "FR",
        "text": "Voir les Réponses"
      },
      {
        "language": "EN",
        "text": "View Answers"
      }
    ]
  },
  {
    "key": "txtMean",
    "text": "Mean",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      },
      {
        "language": "FR",
        "text": "Moyenne"
      },
      {
        "language": "EN",
        "text": "Mean"
      }
    ]
  },
  {
    "key": "txtStronglyAgree",
    "text": "Strongly Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق بشدة"
      },
      {
        "language": "FR",
        "text": "Tout ŕ fait d'accord"
      },
      {
        "language": "EN",
        "text": "Strongly Agree"
      }
    ]
  },
  {
    "key": "txt_leaver_joining_date",
    "text": "Joining Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانضمام للعمل"
      },
      {
        "language": "FR",
        "text": "Date d'Inscription"
      },
      {
        "language": "HI",
        "text": "कार्यग्रहण तिथि"
      },
      {
        "language": "TA",
        "text": "Petsa ng Pagsali"
      },
      {
        "language": "UR",
        "text": "شامل ہونے کی تاریخ"
      },
      {
        "language": "BN",
        "text": "যোগদানের তারিখ"
      },
      {
        "language": "EN",
        "text": "Joining Date"
      }
    ]
  },
  {
    "key": "txt_leaver_seperation_date",
    "text": "Seperation Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الفصل"
      },
      {
        "language": "FR",
        "text": "Date de Séparation d’emploi"
      }
    ]
  },
  {
    "key": "txt_leaver_start_date",
    "text": "Survey Start Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ بدء الاستبيان"
      },
      {
        "language": "FR",
        "text": "Date de Début de Enquęte "
      },
      {
        "language": "EN",
        "text": "Survey Start Date"
      }
    ]
  },
  {
    "key": "txt_leaver_end_date",
    "text": "Survey Completion Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء من الاستبيان"
      },
      {
        "language": "FR",
        "text": "Date d’Achčvement du Enquęte"
      }
    ]
  },
  {
    "key": "txt_leaver_personal_info",
    "text": "Personal Information",
    "translations": [
      {
        "language": "AR",
        "text": "المعلومات الشخصية للموظف المغادر"
      },
      {
        "language": "FR",
        "text": "Informations Personnelles du Sortant"
      },
      {
        "language": "EN",
        "text": "Personal Information"
      }
    ]
  },
  {
    "key": "txt_leaver_positional_info",
    "text": "Positional Information",
    "translations": [
      {
        "language": "AR",
        "text": "المعلومات الوظيفية للموظف المغادر"
      },
      {
        "language": "FR",
        "text": "Informations sur la Position du Sortant"
      },
      {
        "language": "EN",
        "text": "Positional Information"
      }
    ]
  },
  {
    "key": "txt_leaver_time_frame",
    "text": "Time Frame",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "FR",
        "text": "Délai"
      },
      {
        "language": "EN",
        "text": "Time Frame"
      }
    ]
  },
  {
    "key": "txt_time_frame_start",
    "text": "Time Frame Start",
    "translations": [
      {
        "language": "AR",
        "text": "بداية المدة الزمنية"
      },
      {
        "language": "EN",
        "text": "Time Frame Start"
      }
    ]
  },
  {
    "key": "txt_new_leaver",
    "text": "New Leaver",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة موظف مغادر"
      },
      {
        "language": "FR",
        "text": "Nouveau Sortant"
      },
      {
        "language": "EN",
        "text": "New Leaver"
      }
    ]
  },
  {
    "key": "txt_edit_leaver",
    "text": "Edit Leaver",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل الموظف المغادر"
      },
      {
        "language": "FR",
        "text": "Modifier le Sortant"
      },
      {
        "language": "EN",
        "text": "Edit Leaver"
      }
    ]
  },
  {
    "key": "txt_time_frame_end",
    "text": "Time Frame End",
    "translations": [
      {
        "language": "AR",
        "text": "نهاية المدة الزمنية"
      },
      {
        "language": "EN",
        "text": "Time Frame End"
      }
    ]
  },
  {
    "key": "txt_invitation_date",
    "text": "Invitation Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإرسال"
      },
      {
        "language": "FR",
        "text": "Date d'invitation"
      },
      {
        "language": "EN",
        "text": "Invitation Date"
      }
    ]
  },
  {
    "key": "txtCustomizeTable",
    "text": "Customize Table",
    "translations": [
      {
        "language": "AR",
        "text": "عدِل الجدول"
      },
      {
        "language": "EN",
        "text": "Customize Table"
      }
    ]
  },
  {
    "key": "txtCustomize",
    "text": "Customize",
    "translations": [
      {
        "language": "AR",
        "text": "عدِل"
      },
      {
        "language": "EN",
        "text": "Customize"
      }
    ]
  },
  {
    "key": "Finish",
    "text": "Finish",
    "translations": [
      {
        "language": "AR",
        "text": "انهِ"
      },
      {
        "language": "EN",
        "text": "Finish"
      }
    ]
  },
  {
    "key": "Joining Date",
    "text": "Joining Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانضمام"
      },
      {
        "language": "HI",
        "text": "कार्यग्रहण तिथि"
      },
      {
        "language": "TA",
        "text": "Petsa ng Pagsali"
      },
      {
        "language": "UR",
        "text": "شامل ہونے کی تاریخ"
      },
      {
        "language": "EN",
        "text": "Joining Date"
      }
    ]
  },
  {
    "key": "Start date",
    "text": "Start date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البداية"
      },
      {
        "language": "EN",
        "text": "Start date"
      }
    ]
  },
  {
    "key": "Due Date",
    "text": "Due Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الاتمام"
      },
      {
        "language": "EN",
        "text": "Due Date"
      }
    ]
  },
  {
    "key": "Send invitation on",
    "text": "Send invitation on",
    "translations": [
      {
        "language": "AR",
        "text": "ارسل الدعوة في تاريخ"
      },
      {
        "language": "EN",
        "text": "Send invitation on"
      }
    ]
  },
  {
    "key": "Separation Date",
    "text": "Separation Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الفصل"
      },
      {
        "language": "EN",
        "text": "Separation Date"
      }
    ]
  },
  {
    "key": "btnExport",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "FR",
        "text": "Télécharger"
      },
      {
        "language": "EN",
        "text": "Download"
      }
    ]
  },
  {
    "key": "txtDetractors",
    "text": "Detractors",
    "translations": [
      {
        "language": "AR",
        "text": "المنتقدون"
      },
      {
        "language": "EN",
        "text": "Detractors"
      }
    ]
  },
  {
    "key": "txtDetractorsDef",
    "text": "the employees who select a score between 0 – 6 are unhappy and disengaged employees who won't recommend your business as a good workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "هم الذين أجابوا السؤال من 0 إلى 6 لأنهم غير راضين عن العمل أو الشركة."
      },
      {
        "language": "EN",
        "text": "the employees who select a score between 0 – 6 are unhappy and disengaged employees who won't recommend your business as a good workplace."
      }
    ]
  },
  {
    "key": "txtENPS",
    "text": "Employee Net Promoter Score (eNPS)",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين (eNPS)"
      },
      {
        "language": "EN",
        "text": "Employee Net Promoter Score (eNPS)"
      }
    ]
  },
  {
    "key": "txtENPSDesc",
    "text": "eNPS measures employee loyalty by identifying them as promoters, passives, and detractors of your brand.",
    "translations": [
      {
        "language": "AR",
        "text": "eNPS يقيس ولاء الموظفين من خلال تحديدهم كمروجين أو سلبيين (غير مروجين) أو منتقدين لعلامتك التجارية."
      },
      {
        "language": "EN",
        "text": "eNPS measures employee loyalty by identifying them as promoters, passives, and detractors of your brand."
      }
    ]
  },
  {
    "key": "txtSATISFIED",
    "text": "GOOD EXPERIENCE",
    "translations": [
      {
        "language": "AR",
        "text": " تجربة جيدة"
      },
      {
        "language": "EN",
        "text": "GOOD EXPERIENCE"
      }
    ]
  },
  {
    "key": "txtEXTREMELYSATISFIED",
    "text": "VERY GOOD EXPERIENCE",
    "translations": [
      {
        "language": "AR",
        "text": " تجربة جيدة للغاية"
      },
      {
        "language": "EN",
        "text": "VERY GOOD EXPERIENCE"
      }
    ]
  },
  {
    "key": "txtSurveyStatus",
    "text": "Survey Status",
    "translations": [
      {
        "language": "AR",
        "text": "حالة الاستبيان"
      },
      {
        "language": "FR",
        "text": "Statut de Enquęte "
      },
      {
        "language": "EN",
        "text": "Survey Status"
      }
    ]
  },
  {
    "key": "txtPercentageOfLeavers",
    "text": "Percentage of Leavers",
    "translations": [
      {
        "language": "AR",
        "text": "نسبة المغادرين"
      },
      {
        "language": "FR",
        "text": "Pourcentage de sortants"
      },
      {
        "language": "EN",
        "text": "Percentage of Leavers"
      }
    ]
  },
  {
    "key": "txt_activeleaverslist_export",
    "text": "Active Leavers List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الموظفين المغادرين الفعالة"
      },
      {
        "language": "FR",
        "text": "Liste des Sortants Actifs"
      },
      {
        "language": "EN",
        "text": "Active Leavers List"
      }
    ]
  },
  {
    "key": "txt_leaver_action_updated",
    "text": "updated",
    "translations": [
      {
        "language": "AR",
        "text": "تم التحديث"
      },
      {
        "language": "FR",
        "text": "Mis ŕ jour"
      },
      {
        "language": "EN",
        "text": "updated"
      }
    ]
  },
  {
    "key": "txt_leaver_creation_today_no_email",
    "text": "Leaver #ACTION#, an email has been sent to you for your reference or you can share the link below",
    "translations": [
      {
        "language": "AR",
        "text": "Leaver #ACTION#, an email has been sent to you for your reference or you can share the link below"
      },
      {
        "language": "FR",
        "text": "Sortant #ACTION#, un email vous a été envoyé pour votre référence ou vous pouvez partager le lien ci-dessous"
      },
      {
        "language": "EN",
        "text": "Leaver #ACTION#, an email has been sent to you for your reference or you can share the link below"
      }
    ]
  },
  {
    "key": "txt_leaver_creation_not_today_email",
    "text": "Leaver #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to #LEAVEREMAIL# on #STARTDATE# or you can share the link below",
    "translations": [
      {
        "language": "AR",
        "text": "Leaver #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to #LEAVEREMAIL# on #STARTDATE# or you can share the link below"
      },
      {
        "language": "FR",
        "text": "Sortant #ACTION#, un email vous a été envoyé pour votre référence Un email sera automatiquement envoyé à #LEAVEREMAIL# le #STARTDATE# ou vous pouvez partager le lien ci-dessous"
      },
      {
        "language": "EN",
        "text": "Leaver #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to #LEAVEREMAIL# on #STARTDATE# or you can share the link below"
      }
    ]
  },
  {
    "key": "txt_leaver_creation_not_today_no_email",
    "text": "Leaver #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to you on #STARTDATE# or you can share the link below",
    "translations": [
      {
        "language": "AR",
        "text": "Leaver #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to you on #STARTDATE# or you can share the link below"
      },
      {
        "language": "FR",
        "text": "Sortant #ACTION#, un email vous a été envoyé pour votre référence Un email vous sera automatiquement envoyé le #STARTDATE# ou vous pouvez partager le lien ci-dessous"
      },
      {
        "language": "EN",
        "text": "Leaver #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to you on #STARTDATE# or you can share the link below"
      }
    ]
  },
  {
    "key": "txt_delete_leaver",
    "text": "Are you sure you want to set this leaver to Inactive?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد تغيير حالة الموظف المغادر لغير فعال؟"
      },
      {
        "language": "FR",
        "text": "Ętes-vous sűr de vouloir mettre ce sortant ŕ Inactif ?"
      },
      {
        "language": "EN",
        "text": "Are you sure you want to set this leaver to Inactive?"
      }
    ]
  },
  {
    "key": "txt_yes",
    "text": "Yes",
    "translations": [
      {
        "language": "AR",
        "text": "نعم"
      },
      {
        "language": "FR",
        "text": "Oui"
      },
      {
        "language": "EN",
        "text": "Yes"
      }
    ]
  },
  {
    "key": "txt_leavers_list",
    "text": "Leavers List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الموظفين المغادرين"
      },
      {
        "language": "FR",
        "text": "Liste des Sortants"
      },
      {
        "language": "EN",
        "text": "Leavers List"
      }
    ]
  },
  {
    "key": "txt_pending",
    "text": "Pending",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإتمام"
      },
      {
        "language": "FR",
        "text": "En attente"
      },
      {
        "language": "EN",
        "text": "Pending"
      }
    ]
  },
  {
    "key": "LEAVER DETAILS",
    "text": "LEAVER DETAILS",
    "translations": [
      {
        "language": "AR",
        "text": "بيانات المغادر"
      },
      {
        "language": "EN",
        "text": "LEAVER DETAILS"
      }
    ]
  },
  {
    "key": "txtIntroduction",
    "text": "Introduction",
    "translations": [
      {
        "language": "AR",
        "text": "مقدمة"
      },
      {
        "language": "FR",
        "text": "introduction"
      },
      {
        "language": "EN",
        "text": "Introduction"
      }
    ]
  },
  {
    "key": "retirement",
    "text": "Retirement",
    "translations": [
      {
        "language": "AR",
        "text": "تقاعد"
      },
      {
        "language": "EN",
        "text": "Retirement"
      }
    ]
  },
  {
    "key": "resignation",
    "text": "Resignation",
    "translations": [
      {
        "language": "AR",
        "text": "استقالة"
      },
      {
        "language": "EN",
        "text": "Resignation"
      }
    ]
  },
  {
    "key": "termination",
    "text": "Termination",
    "translations": [
      {
        "language": "AR",
        "text": "إنهاء الخدمات"
      },
      {
        "language": "EN",
        "text": "Termination"
      }
    ]
  },
  {
    "key": "txtHowtousethisreport",
    "text": "How to Use this Report?",
    "translations": [
      {
        "language": "AR",
        "text": "كيف يمكن الاستفادة من هذا التقرير؟"
      },
      {
        "language": "FR",
        "text": "Comment Utiliser le Rapport  "
      },
      {
        "language": "EN",
        "text": "How to Use this Report?"
      }
    ]
  },
  {
    "key": "txtPreparedFor",
    "text": "Prepared For",
    "translations": [
      {
        "language": "AR",
        "text": "أُعدَّ لـ"
      },
      {
        "language": "FR",
        "text": "Préparé pour"
      },
      {
        "language": "EN",
        "text": "Prepared For"
      }
    ]
  },
  {
    "key": "txtResultsRating",
    "text": "Results Rating",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس النتائج"
      },
      {
        "language": "EN",
        "text": "Results Rating"
      }
    ]
  },
  {
    "key": "txtRatingScale",
    "text": "Rating Scale",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس التقييم"
      },
      {
        "language": "FR",
        "text": "Échelle d’Évaluation"
      },
      {
        "language": "BN",
        "text": "নির্ধারণের মাপকাঠি"
      },
      {
        "language": "EN",
        "text": "Rating Scale"
      }
    ]
  },
  {
    "key": "txtCalculationProcess",
    "text": "Calculation Process",
    "translations": [
      {
        "language": "AR",
        "text": "عملية الحساب"
      },
      {
        "language": "FR",
        "text": "Processus de Calcul"
      },
      {
        "language": "EN",
        "text": "Calculation Process"
      }
    ]
  },
  {
    "key": "txtCalculationProcess1",
    "text": "Each statement score is given an average rating based on the received feedback.",
    "translations": [
      {
        "language": "AR",
        "text": "يتم حساب نتيجة كل عبارة من خلال أخذ متوسط نتائج اختيارات الموظفين."
      },
      {
        "language": "EN",
        "text": "Each statement score is given an average rating based on the received feedback."
      }
    ]
  },
  {
    "key": "txtCalculationProcess2",
    "text": "Each factor score is calculated by taking the average of the overall rating score of the statements.",
    "translations": [
      {
        "language": "AR",
        "text": "يتم حساب درجة كل عامل من عوامل خروج الموظفين من خلال أخذ متوسط نتائج العبارات."
      },
      {
        "language": "EN",
        "text": "Each factor score is calculated by taking the average of the overall rating score of the statements."
      }
    ]
  },
  {
    "key": "txtHappinessCalculationProcess2",
    "text": "Each factor score is calculated as the overall rating score of the statements.",
    "translations": [
      {
        "language": "AR",
        "text": "يتم احتساب نتيجة كل عامل من عوامل السعادة في مكان العمل من خلال أخذ متوسط نتائج العبارات. "
      },
      {
        "language": "EN",
        "text": "Each factor score is calculated as the overall rating score of the statements."
      }
    ]
  },
  {
    "key": "Personal",
    "text": "Personal",
    "translations": [
      {
        "language": "AR",
        "text": "شخصي"
      },
      {
        "language": "EN",
        "text": "Personal"
      }
    ]
  },
  {
    "key": "Position",
    "text": "Position",
    "translations": [
      {
        "language": "AR",
        "text": "الوظيفة"
      },
      {
        "language": "EN",
        "text": "Position"
      }
    ]
  },
  {
    "key": "Positional",
    "text": "Positional",
    "translations": [
      {
        "language": "AR",
        "text": "وظيفي"
      },
      {
        "language": "EN",
        "text": "Positional"
      }
    ]
  },
  {
    "key": "txt_total_questionnaires",
    "text": "Total Surveys",
    "translations": [
      {
        "language": "AR",
        "text": "مجموع الاستبيانات"
      },
      {
        "language": "FR",
        "text": "Enquętes Totales"
      },
      {
        "language": "EN",
        "text": "Total Surveys"
      }
    ]
  },
  {
    "key": "txt_inactiveleaverslist_export",
    "text": "InActive Leavers List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الموظفين المغادرين غير الفعالة"
      },
      {
        "language": "FR",
        "text": "Liste des Sortants Inactifs"
      },
      {
        "language": "EN",
        "text": "InActive Leavers List"
      }
    ]
  },
  {
    "key": "Inactive",
    "text": "Inactive",
    "translations": [
      {
        "language": "AR",
        "text": "غير فعال"
      },
      {
        "language": "EN",
        "text": "Inactive"
      }
    ]
  },
  {
    "key": "txtSection",
    "text": "Section",
    "translations": [
      {
        "language": "AR",
        "text": "قسم"
      },
      {
        "language": "FR",
        "text": "Section"
      },
      {
        "language": "EN",
        "text": "Section"
      }
    ]
  },
  {
    "key": "txt_expiredleaverslist_export",
    "text": "Expired Leavers List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الموظفين المغادرين المنتهية صلاحيتها"
      },
      {
        "language": "FR",
        "text": "Liste des Sortants Expirés"
      },
      {
        "language": "EN",
        "text": "Expired Leavers List"
      }
    ]
  },
  {
    "key": "txtNoOfLeavers",
    "text": "Number of Leavers",
    "translations": [
      {
        "language": "AR",
        "text": "عدد المغادرين"
      },
      {
        "language": "FR",
        "text": "Nombre des Partants"
      },
      {
        "language": "EN",
        "text": "Number of Leavers"
      }
    ]
  },
  {
    "key": "txt_Exit_Questionnaire",
    "text": "Employee Exit Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان خروج الموظف وإنتهاء العمل"
      },
      {
        "language": "FR",
        "text": "Enquęte sur les sorties des employés"
      },
      {
        "language": "EN",
        "text": "Employee Exit Survey"
      }
    ]
  },
  {
    "key": "txtDistribution",
    "text": "Distribution",
    "translations": [
      {
        "language": "AR",
        "text": "توزيع الإجابات"
      },
      {
        "language": "FR",
        "text": "Distribution"
      },
      {
        "language": "EN",
        "text": "Distribution"
      }
    ]
  },
  {
    "key": "txt_question",
    "text": "Statement",
    "translations": [
      {
        "language": "AR",
        "text": "العبارة"
      },
      {
        "language": "FR",
        "text": "Question"
      },
      {
        "language": "BN",
        "text": "প্রশ্ন"
      },
      {
        "language": "EN",
        "text": "Statement"
      }
    ]
  },
  {
    "key": "txt_questions",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      },
      {
        "language": "FR",
        "text": "Questions"
      },
      {
        "language": "BN",
        "text": "টি প্রশ্ন"
      },
      {
        "language": "EN",
        "text": "Statements"
      }
    ]
  },
  {
    "key": "txt_deleted",
    "text": "Deleted",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذفه"
      },
      {
        "language": "FR",
        "text": "Supprimé"
      },
      {
        "language": "EN",
        "text": "Deleted"
      }
    ]
  },
  {
    "key": "txt_send_reminder",
    "text": "Send Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكير"
      },
      {
        "language": "FR",
        "text": "Envoyer un Rappel"
      },
      {
        "language": "EN",
        "text": "Send Reminder"
      }
    ]
  },
  {
    "key": "txtNoReportsYet",
    "text": "No leavers to generate reports yet!",
    "translations": [
      {
        "language": "AR",
        "text": "لا يمكن إنشاء تقارير لعدم وجود مغادرين!"
      },
      {
        "language": "FR",
        "text": "Aucun sortant pour générer des rapports pour le moment!"
      },
      {
        "language": "EN",
        "text": "No leavers to generate reports yet!"
      }
    ]
  },
  {
    "key": "btn_add_new_leaver",
    "text": "Add Leaver",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة موظف مغادر"
      },
      {
        "language": "FR",
        "text": "Ajouter Un Sortant"
      },
      {
        "language": "EN",
        "text": "Add Leaver"
      }
    ]
  },
  {
    "key": "txt_resp_by_generation",
    "text": "Respondents by Generation",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب نوع الجيل"
      },
      {
        "language": "EN",
        "text": "Respondents by Generation"
      }
    ]
  },
  {
    "key": "txt_resp_by_age_group",
    "text": " Respondents by Age Group",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب الفئات العمرية"
      },
      {
        "language": "EN",
        "text": " Respondents by Age Group"
      }
    ]
  },
  {
    "key": "txt_resp_by_tenure_group",
    "text": "Respondents by Tenure Group",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب فئات سنوات الخدمة"
      },
      {
        "language": "EN",
        "text": "Respondents by Tenure Group"
      }
    ]
  },
  {
    "key": "txt_reports",
    "text": "Reports",
    "translations": [
      {
        "language": "AR",
        "text": "التقارير"
      },
      {
        "language": "FR",
        "text": "Rapports"
      },
      {
        "language": "EN",
        "text": "Reports"
      }
    ]
  },
  {
    "key": "txt_timeframe",
    "text": "Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "FR",
        "text": "Délai"
      },
      {
        "language": "EN",
        "text": "Timeframe"
      }
    ]
  },
  {
    "key": "txt_report",
    "text": "Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير"
      },
      {
        "language": "FR",
        "text": "Rapport"
      },
      {
        "language": "EN",
        "text": "Report"
      }
    ]
  },
  {
    "key": "txtConfidential",
    "text": "Confidential",
    "translations": [
      {
        "language": "AR",
        "text": "خاص وسري"
      },
      {
        "language": "FR",
        "text": "Confidentiel"
      },
      {
        "language": "EN",
        "text": "Confidential"
      }
    ]
  },
  {
    "key": "txtEmployeeExitAnalysis",
    "text": "Employee Exit",
    "translations": [
      {
        "language": "AR",
        "text": "خروج الموظفين"
      },
      {
        "language": "FR",
        "text": "Sortie de l'employé"
      },
      {
        "language": "EN",
        "text": "Employee Exit"
      }
    ]
  },
  {
    "key": "txtEmployeeExitAnalysisReport",
    "text": "Employee Exit Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان خروج الموظفين"
      },
      {
        "language": "EN",
        "text": "Employee Exit Survey"
      }
    ]
  },
  {
    "key": "txtEmployeeExitReport",
    "text": "Employee Exit Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير خروج الموظفين"
      },
      {
        "language": "EN",
        "text": "Employee Exit Report"
      }
    ]
  },
  {
    "key": "Leaver Notes",
    "text": "Leaver Notes",
    "translations": [
      {
        "language": "AR",
        "text": "ملاحظات الموظف المغادر"
      },
      {
        "language": "EN",
        "text": "Leaver Notes"
      }
    ]
  },
  {
    "key": "Add Note",
    "text": "Add Note",
    "translations": [
      {
        "language": "AR",
        "text": "أضف ملاحظة"
      },
      {
        "language": "EN",
        "text": "Add Note"
      }
    ]
  },
  {
    "key": "New Note",
    "text": "New Note",
    "translations": [
      {
        "language": "AR",
        "text": "ملاحظة جديدة"
      },
      {
        "language": "EN",
        "text": "New Note"
      }
    ]
  },
  {
    "key": "Name",
    "text": "Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      },
      {
        "language": "EN",
        "text": "Name"
      }
    ]
  },
  {
    "key": "A note can't be empty!",
    "text": "A note can't be empty!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب كتابة الملاحظة"
      },
      {
        "language": "EN",
        "text": "A note can't be empty!"
      }
    ]
  },
  {
    "key": "Note added successuflly",
    "text": "Note added successfully",
    "translations": [
      {
        "language": "AR",
        "text": "تمت إضافة الملاحظة بنجاح"
      },
      {
        "language": "EN",
        "text": "Note added successfully"
      }
    ]
  },
  {
    "key": "Note deleted successuflly",
    "text": "Note deleted successfully",
    "translations": [
      {
        "language": "AR",
        "text": "تم مسح الملاحظة بنجاح"
      },
      {
        "language": "EN",
        "text": "Note deleted successfully"
      }
    ]
  },
  {
    "key": "Leave a note here.",
    "text": "Leave a note here.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف ملاحظة هنا."
      },
      {
        "language": "EN",
        "text": "Leave a note here."
      }
    ]
  },
  {
    "key": "Notes",
    "text": "Notes",
    "translations": [
      {
        "language": "AR",
        "text": "الملاحظات"
      },
      {
        "language": "EN",
        "text": "Notes"
      }
    ]
  },
  {
    "key": "Note",
    "text": "Note",
    "translations": [
      {
        "language": "AR",
        "text": "الملاحظة"
      },
      {
        "language": "EN",
        "text": "Note"
      }
    ]
  },
  {
    "key": "Delete Note",
    "text": "Delete Note",
    "translations": [
      {
        "language": "AR",
        "text": "مسح الملاحظة"
      },
      {
        "language": "EN",
        "text": "Delete Note"
      }
    ]
  },
  {
    "key": "Edit Note",
    "text": "Edit Note",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل الملاحظة"
      },
      {
        "language": "EN",
        "text": "Edit Note"
      }
    ]
  },
  {
    "key": "txtEmployeeExitFactors",
    "text": "Employee Exit Factors",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل خروج الموظفين"
      },
      {
        "language": "EN",
        "text": "Employee Exit Factors"
      }
    ]
  },
  {
    "key": "txtLikely",
    "text": "Likely",
    "translations": [
      {
        "language": "AR",
        "text": "مُرجّح"
      },
      {
        "language": "EN",
        "text": "Likely"
      },
      {
        "language": "FR",
        "text": "très probable"
      }
    ]
  },
  {
    "key": "txtNeutralLikely",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "محايد"
      },
      {
        "language": "FR",
        "text": "probable"
      },
      {
        "language": "EN",
        "text": "Neutral"
      }
    ]
  },
  {
    "key": "txtUnLikely",
    "text": "Unlikely",
    "translations": [
      {
        "language": "AR",
        "text": "غير مُرجح"
      },
      {
        "language": "EN",
        "text": "Unlikely"
      },
      {
        "language": "FR",
        "text": " peu probable"
      }
    ]
  },
  {
    "key": "EXTREME_UNSATISFIED",
    "text": "Very Poor Experience",
    "translations": [
      {
        "language": "AR",
        "text": " تجربة سيئة للغاية"
      },
      {
        "language": "EN",
        "text": "Very Poor Experience"
      }
    ]
  },
  {
    "key": "UNSATISFIED",
    "text": "Poor Experience",
    "translations": [
      {
        "language": "AR",
        "text": " تجربة سيئة"
      },
      {
        "language": "EN",
        "text": "Poor Experience"
      }
    ]
  },
  {
    "key": "MODERATE",
    "text": "Moderate",
    "translations": [
      {
        "language": "AR",
        "text": "محايد"
      },
      {
        "language": "EN",
        "text": "Moderate"
      }
    ]
  },
  {
    "key": "SATISFIED",
    "text": "Good Experience",
    "translations": [
      {
        "language": "AR",
        "text": " تجربة جيدة"
      },
      {
        "language": "EN",
        "text": "Good Experience"
      }
    ]
  },
  {
    "key": "EXTREME_SATISFIED",
    "text": "Very Good Experience",
    "translations": [
      {
        "language": "AR",
        "text": " تجربة جيدة للغاية"
      },
      {
        "language": "EN",
        "text": "Very Good Experience"
      }
    ]
  },
  {
    "key": "txtEmployeeExitGeneralAnalysis",
    "text": "Employee Exit General Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "التحليل العام لخروج الموظفين"
      },
      {
        "language": "EN",
        "text": "Employee Exit General Analysis"
      }
    ]
  },
  {
    "key": "txtEmployeeExitMeasures",
    "text": "The Employee Exit General Analysis measures the following:",
    "translations": [
      {
        "language": "AR",
        "text": "يقيس التحليل العام لخروج الموظفين ما يلي:"
      },
      {
        "language": "EN",
        "text": "The Employee Exit General Analysis measures the following:"
      }
    ]
  },
  {
    "key": "The below scores identify how likely your employees will recommend your workplace as a great place to work:",
    "text": "The below scores identify how likely your employees will recommend your workplace as a great place to work:",
    "translations": [
      {
        "language": "AR",
        "text": "تحدد الدرجات أدناه مدى احتمالية أن يُروِج الموظف مكان العمل كمكان صالح للعمل:"
      },
      {
        "language": "EN",
        "text": "The below scores identify how likely your employees will recommend your workplace as a great place to work:"
      }
    ]
  },
  {
    "key": "txtLeaverOverallSatisfaction",
    "text": "Leavers Experience Rate at [Company Name]:",
    "translations": [
      {
        "language": "AR",
        "text": "معدل تجربة الموظفين المغادرين في [Company Name]:"
      },
      {
        "language": "EN",
        "text": "Leavers Experience Rate at [Company Name]:"
      }
    ]
  },
  {
    "key": "Leavers' satisfaction",
    "text": "Leavers Experience Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل تجربة الموظفين المغادرين"
      },
      {
        "language": "EN",
        "text": "Leavers Experience Rate"
      }
    ]
  },
  {
    "key": "txtAtCompany",
    "text": "at [Company Name].",
    "translations": [
      {
        "language": "AR",
        "text": "في [Company Name]."
      },
      {
        "language": "EN",
        "text": "at [Company Name]."
      }
    ]
  },
  {
    "key": "txtAt",
    "text": "at",
    "translations": [
      {
        "language": "AR",
        "text": "في"
      },
      {
        "language": "EN",
        "text": "at"
      }
    ]
  },
  {
    "key": "txtFactorsInfluenced",
    "text": "Reasons Behind Why Employees are Leaving the Workplace",
    "translations": [
      {
        "language": "AR",
        "text": "أسباب مغادرة الموظفين مكان العمل"
      },
      {
        "language": "EN",
        "text": "Reasons Behind Why Employees are Leaving the Workplace"
      }
    ]
  },
  {
    "key": "txtFactorsInfluencedDesc",
    "text": "The below chart illustrates the main reasons behind employees leaving [Company Name]:",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح الرسم البياني أدناه الأسباب الرئيسية لمغادرة الموظف مكان عمله:"
      },
      {
        "language": "EN",
        "text": "The below chart illustrates the main reasons behind employees leaving [Company Name]:"
      }
    ]
  },
  {
    "key": "txtIndustriesLeftFor",
    "text": "Industries Employees are Leaving for",
    "translations": [
      {
        "language": "AR",
        "text": "القطاعات التي اختارها الموظفين الحاصلين على فرص عمل جديدة"
      },
      {
        "language": "EN",
        "text": "Industries Employees are Leaving for"
      }
    ]
  },
  {
    "key": "txtIndustriesLeftForDesc",
    "text": "The below chart illustrates the industries that employees are leaving for:",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح الرسم البياني أدناه نوع القطاع الذي اختاره الموظف الحاصل على فرص عمل جديدة:"
      },
      {
        "language": "EN",
        "text": "The below chart illustrates the industries that employees are leaving for:"
      }
    ]
  },
  {
    "key": "txttableofcontents",
    "text": "Table of Contents",
    "translations": [
      {
        "language": "AR",
        "text": "جدول المحتويات"
      },
      {
        "language": "FR",
        "text": "Table des matičres"
      },
      {
        "language": "EN",
        "text": "Table of Contents"
      }
    ]
  },
  {
    "key": "txtExportCommentsUnavailable",
    "text": "Comments Unavailable",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات غير متاحة"
      },
      {
        "language": "FR",
        "text": "Commentaires Indisponibles"
      },
      {
        "language": "EN",
        "text": "Comments Unavailable"
      }
    ]
  },
  {
    "key": "txtExportCommentCheckbox",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "FR",
        "text": "Télécharger avec commentaires"
      },
      {
        "language": "EN",
        "text": "Comments"
      }
    ]
  },
  {
    "key": "txtFactorsofWorkplaceExitDesc",
    "text": "The below indicates the scores for each of the [Drivers Count] factors of Workplace Employee Exit at [Company Name]:",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح التالي النتيجة لكل من ال [Drivers Count] عوامل لخروج الموظفين من مكان العمل في [Company Name]:"
      },
      {
        "language": "EN",
        "text": "The below indicates the scores for each of the [Drivers Count] factors of Workplace Employee Exit at [Company Name]:"
      }
    ]
  },
  {
    "key": "txtRecommendations",
    "text": "Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "توصيات"
      },
      {
        "language": "EN",
        "text": "Recommendations"
      }
    ]
  },
  {
    "key": "txtPositionFactorDesc",
    "text": "The term position is the clarification of the job description given to the employee from day one of their joining date to the organization. The key components of the job description include job purpose, roles & responsibilities, qualifications, years of experience, and required competencies; these components create a foundation for workplace goals and employee development, and clarify employees' roles and make them feel valued. Clarifying the position and its key components in the workplace are essential elements to prevent top talent from leaving, retain valuable employees, and improve the employee experience.",
    "translations": [
      {
        "language": "AR",
        "text": "مصطلح الوظيفة يستخدم لتوضيح الوصف الوظيفي الموكّل للموظف منذ اليوم الأول من تاريخ انضمامه إلى مكان العمل، وتتكون العناصر الرئيسية للوصف الوظيفي من التالي: الغرض من الوظيفة والمهام والمسؤوليات والمؤهلات وسنوات الخبرة والمهارات المطلوبة. تُشكل هذه المكونات بنية أساسية لخلق مكان عمل فعّال يقدّر الموظفين ويوضّح أدوارهم ممّا يسمح بتطويرهم وتقدّمهم.يُعد توضيح الأدوار الوظيفية في مكان العمل عنصراً أساسيّاً للحد من مغادرة الموظفين الكفء ذوي المواهب الاستثنائية، والمساهمة في الاحتفاظ بهم وتحسين تجربتهم."
      },
      {
        "language": "EN",
        "text": "The term position is the clarification of the job description given to the employee from day one of their joining date to the organization. The key components of the job description include job purpose, roles & responsibilities, qualifications, years of experience, and required competencies; these components create a foundation for workplace goals and employee development, and clarify employees' roles and make them feel valued. Clarifying the position and its key components in the workplace are essential elements to prevent top talent from leaving, retain valuable employees, and improve the employee experience."
      }
    ]
  },
  {
    "key": "txtDetailedPerformance",
    "text": "Detailed Performance Score",
    "translations": [
      {
        "language": "AR",
        "text": "معدل تقييم أداء مفصل"
      },
      {
        "language": "EN",
        "text": "Detailed Performance Score"
      }
    ]
  },
  {
    "key": "txtEmployeeExitIntroductionpara",
    "text": "<p>Employee Exit refers to the end of an employee's work within the workplace. An employee may leave their workplace for different reasons. The Employee Exit Survey provides an in-depth insight analysis addressing the challenges the workplace may be facing to understand the reasons and issues of why employees are leaving: why talents are leaving? What is the average age of leaving talents? Their performance rates? And where is their geographical location?</p> <br> <p>Understanding the reasons behind an employee’s exit helps identify and address the fundamental challenges of reducing employee turnover, retaining talents, and enhancing workplace culture and environment.</p> <br>  <p>The Employee Exit survey outcomes are based on the measurement of the following factors: Position, Rules & Policies, Compensation & Benefits, Career Advancement, Communication, Management Style, and Working Conditions.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>يشير مصطلح مغادرة الموظف إلى نهاية خدمة هذا الموظف في مكان عمله، والذي قد يكون ناتجًا عن أسبابٍ عدة. يوفر استبيان مغادرة الموظف تحليلاً شاملاً عن أهم التحديات التي تواجه مكان العمل والتي تؤدي بالموظف لترك مكان عمله، مما يساعد في فهم أسباب مغادرة الموظفين. أهم أجزاء ذلك الاستبيان تتمثل في معرفة: سبب مغادرة الموظفين الكفء، متوسط أعمارهم عند المغادرة، معدل أداءهم، وموقعهم الجغرافي الحالي.</p>\n <br> <p>الهدف الأسمى لأي مؤسسة هو الاحتفاظ بأفضل موظفيها، وبناءً على ذلك يتم إجراء استبيان مغادرة الموظفين الذي يساهم في تقييم ومعالجة التحديات الأساسية بهدف الحد من الدوران الوظيفي والاحتفاظ بالموظفين الكفء ذوي المواهب الاستثنائية وتحسين بيئة وثقافة العمل.</p>\n <br> <p>مخرجات استبيان مغادرة الموظفين ترتكز على قياس العوامل التالية: الوظيفة والقواعد والسياسات والتعويضات والمزايا والتطور الوظيفي والتواصل وأسلوب الإدارة وظروف العمل.</p>"
      },
      {
        "language": "EN",
        "text": "<p>Employee Exit refers to the end of an employee's work within the workplace. An employee may leave their workplace for different reasons. The Employee Exit Survey provides an in-depth insight analysis addressing the challenges the workplace may be facing to understand the reasons and issues of why employees are leaving: why talents are leaving? What is the average age of leaving talents? Their performance rates? And where is their geographical location?</p> <br> <p>Understanding the reasons behind an employee’s exit helps identify and address the fundamental challenges of reducing employee turnover, retaining talents, and enhancing workplace culture and environment.</p> <br>  <p>The Employee Exit survey outcomes are based on the measurement of the following factors: Position, Rules & Policies, Compensation & Benefits, Career Advancement, Communication, Management Style, and Working Conditions.</p>"
      }
    ]
  },
  {
    "key": "txtExitCalculationProcess3",
    "text": "eNPS.",
    "translations": [
      {
        "language": "AR",
        "text": "eNPS."
      },
      {
        "language": "EN",
        "text": "eNPS."
      }
    ]
  },
  {
    "key": "txtExitObjectives",
    "text": "\n <h4 class=\"text-zen text-xl font-medium pb-7 pt-10\">Objectives of this Report</h4>\n <div class=\"flex flex-col items-stretch\">\n <div class=\"flex flex-col w-full\">\n <ul>\n <li class=\"flex flex-row item-stretch pb-3 gap-2\">\n <i class=\"fa-solid text-exp fa-circle text-zen text-xxs leading-5\"></i>\n <p>Identify and understand the reasons influencing employees to leave the workplace.</p>\n </li>\n <li class=\"flex flex-row item-stretch pb-3 gap-2\">\n <i class=\"fa-solid text-exp fa-circle text-zen text-xxs leading-5\"></i>\n <p>Address areas of improvement through factors with low scores and the reason behind the results.</p>\n </li>\n\n </ul>\n </div>\n <div class=\"col-sep\"></div>\n <div class=\"flex flex-row item-stretch gap-2\">\n <ul>\n <li class=\"flex flex-row item-stretch pb-3 gap-2\">\n <i class=\"fa-solid text-exp fa-circle text-zen text-xxs leading-5\"></i>\n <p>Access recommended initiatives and actions to be taken for each factor to improve the workplace and environment.</p>\n </li>\n <li class=\"flex flex-row item-stretch pb-3 gap-2\">\n <i class=\"fa-solid text-exp fa-circle text-zen text-xxs leading-5\"></i>\n <p>Obtain open-ended statements or feedback submitted by employees during the survey, use it to improve ways of doing things, and understand why employees decided to leave the workplace.</p>\n </li>\n </ul>\n </div>\n </div> ",
    "translations": [
      {
        "language": "AR",
        "text": "\n <h4 class=\"text-zen text-xl font-medium pb-7 pt-10\">أهداف التقرير</h4>\n <div class=\"flex flex-col items-stretch\">\n <div class=\"flex flex-col w-full\">\n <ul>\n <li class=\"flex flex-row item-stretch pb-3 gap-2\">\n <i class=\"fa-solid text-exp fa-circle text-zen text-xxs leading-5\"></i>\n <p>تحديد وفهم العوامل المؤثرة على مغادرة الموظفين.</p>\n </li>\n <li class=\"flex flex-row item-stretch pb-3 gap-2\">\n <i class=\"fa-solid text-exp fa-circle text-zen text-xxs leading-5\"></i>\n <p>تحديد النطاقات الممكنة للتقدم بناءً على العوامل ذات الدرجات المنخفضة واستنتاج الأسباب وراء هذه النتائج.</p>\n </li>\n\n </ul>\n </div>\n <div class=\"col-sep\"></div>\n <div class=\"flex flex-row item-stretch gap-2\">\n <ul>\n <li class=\"flex flex-row item-stretch pb-3 gap-2\">\n <i class=\"fa-solid text-exp fa-circle text-zen text-xxs leading-5\"></i>\n <p>الحصول على توصيات وأخذها بعين الاعتبار لكل عامل من عوامل مغادرة الموظفين، وتطبيقها للحصول على بيئة عمل فعالة. </p>\n </li>\n <li class=\"flex flex-row item-stretch pb-3 gap-2\">\n <i class=\"fa-solid text-exp fa-circle text-zen text-xxs leading-5\"></i>\n <p>الحصول على تعليقات وآراء الموظفين من خلال الاستبيان، والاستفادة منها في تطوير استراتيجية تنفيذ الأعمال المتعلقة بمكان العمل، وفهم أسباب مغادرة الموظفين.</p>\n </li>\n </ul>\n </div>\n </div> "
      },
      {
        "language": "EN",
        "text": "\n <h4 class=\"text-zen text-xl font-medium pb-7 pt-10\">Objectives of this Report</h4>\n <div class=\"flex flex-col items-stretch\">\n <div class=\"flex flex-col w-full\">\n <ul>\n <li class=\"flex flex-row item-stretch pb-3 gap-2\">\n <i class=\"fa-solid text-exp fa-circle text-zen text-xxs leading-5\"></i>\n <p>Identify and understand the reasons influencing employees to leave the workplace.</p>\n </li>\n <li class=\"flex flex-row item-stretch pb-3 gap-2\">\n <i class=\"fa-solid text-exp fa-circle text-zen text-xxs leading-5\"></i>\n <p>Address areas of improvement through factors with low scores and the reason behind the results.</p>\n </li>\n\n </ul>\n </div>\n <div class=\"col-sep\"></div>\n <div class=\"flex flex-row item-stretch gap-2\">\n <ul>\n <li class=\"flex flex-row item-stretch pb-3 gap-2\">\n <i class=\"fa-solid text-exp fa-circle text-zen text-xxs leading-5\"></i>\n <p>Access recommended initiatives and actions to be taken for each factor to improve the workplace and environment.</p>\n </li>\n <li class=\"flex flex-row item-stretch pb-3 gap-2\">\n <i class=\"fa-solid text-exp fa-circle text-zen text-xxs leading-5\"></i>\n <p>Obtain open-ended statements or feedback submitted by employees during the survey, use it to improve ways of doing things, and understand why employees decided to leave the workplace.</p>\n </li>\n </ul>\n </div>\n </div> "
      }
    ]
  },
  {
    "key": "txtExitHowtousethisreportpara",
    "text": "<p class=\"mb-4\">Employee Exit factors displayed in this report are a result of the employees' responses. Below every score is the analysis of the employees' exit with this specific factor at the workplace.</p>\n <p class=\"mb-4\">Recommended actions in this report are only a few of the many activities that can be taken to improve the environment, and they are not limited to the displayed suggestions.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p class=\"mb-4\">عوامل مغادرة الموظفين المبينة في هذا التقرير ومستوى الرضى الخاص بهم هي نتيجةً لإجاباتهم على هذا الاستبيان، ويلي كل نتيجة في التقرير، تحليل متعلق بأسباب خروج الموظفين المرتبطة بكل عامل من عوامل خروج الموظفين.</p>\n <p class=\"mb-4\">إن الإجراءات الموصى بها في هذا التقرير ما هي إلا جزء من الإجراءات الممكن اتخاذها في تحسين بيئة العمل، ولا تقتصر عليها فقط.</p>"
      },
      {
        "language": "EN",
        "text": "<p class=\"mb-4\">Employee Exit factors displayed in this report are a result of the employees' responses. Below every score is the analysis of the employees' exit with this specific factor at the workplace.</p>\n <p class=\"mb-4\">Recommended actions in this report are only a few of the many activities that can be taken to improve the environment, and they are not limited to the displayed suggestions.</p>"
      }
    ]
  },
  {
    "key": "txtPositionRecommendationDesc",
    "text": "Position Recommendations:",
    "translations": [
      {
        "language": "AR",
        "text": "الإجراءات التي يمكن الاستعانة بها لتحسين عامل الوظيفة:"
      },
      {
        "language": "EN",
        "text": "Position Recommendations:"
      }
    ]
  },
  {
    "key": "txtPositionRecommendation_1",
    "text": "Provide good opportunities for career progression by planning them, implementing them and properly communicating them to the employees. This way, the employees can be directed and mentored by conducting different evaluations to improve their performance and enhance their work productivity.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير فرص لتقدّم وتطوّر المسار الوظيفي للموظفين من خلال تنفيذ خطط التقدّم الوظيفي بشكل واضح وفعّال، وتوجيههم لإجراء تقييمات مختلفة لتحسين أدائهم الوظيفي وتعزيز إنتاجية عملهم."
      },
      {
        "language": "EN",
        "text": "Provide good opportunities for career progression by planning them, implementing them and properly communicating them to the employees. This way, the employees can be directed and mentored by conducting different evaluations to improve their performance and enhance their work productivity."
      }
    ]
  },
  {
    "key": "txtPositionRecommendation_2",
    "text": "Provide employees with coaching and training sessions to educate them on their required job roles and responsibilities to have a clear understanding of the tasks they are required to do.",
    "translations": [
      {
        "language": "AR",
        "text": "تزويد الموظّفين بدورات تدريبيّة تهدف لإرشاد الموظّف إلى المسؤوليات الوظيفيّة المطلوبة منه حتى يتمكن من تحسين أدائه الوظيفي وتعزيز إنتاجيّة عمله."
      },
      {
        "language": "EN",
        "text": "Provide employees with coaching and training sessions to educate them on their required job roles and responsibilities to have a clear understanding of the tasks they are required to do."
      }
    ]
  },
  {
    "key": "txtPositionRecommendation_3",
    "text": "Provide a healthy work-life balance to employees by encouraging breaks, focusing on productivity rather than hours, and offering flexible working hours.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير بيئة عمل متوازنة للموظّفين تهتم بتقديم ساعات عمل مرنة تتضمّن فترات للراحة، وتأخذ بعين الاعتبار الإنتاجيّة بدلاً من ساعات العمل."
      },
      {
        "language": "EN",
        "text": "Provide a healthy work-life balance to employees by encouraging breaks, focusing on productivity rather than hours, and offering flexible working hours."
      }
    ]
  },
  {
    "key": "txtPositionRecommendation_4",
    "text": "Conduct 1 – to – 1 meetings with employees on a regular basis to clarify their roles and responsibilities and eliminate any misunderstandings.",
    "translations": [
      {
        "language": "AR",
        "text": "عقد اجتماعات فرديّة مع الموظّفين بشكل دوري لتوضيح أدوارهم ومسؤولياتهم، والعمل على حل أي سوء فهم من قبل أي طرف من الأطراف."
      },
      {
        "language": "EN",
        "text": "Conduct 1 – to – 1 meetings with employees on a regular basis to clarify their roles and responsibilities and eliminate any misunderstandings."
      }
    ]
  },
  {
    "key": "txtPositionRecommendation_5",
    "text": "Implement employee recognition programs to identify and recognize milestones achieved by the employees. This program must provide rewards for the achievement of employees in the workplace and decide which employees are eligible based on their performance and contribution in their roles and responsibilities. ",
    "translations": [
      {
        "language": "AR",
        "text": "Implement employee recognition programs to identify and recognize milestones achieved by the employees. This program must provide rewards for the achievement of employees in the workplace and decide which employees are eligible based on their performance and contribution in their roles and responsibilities. "
      },
      {
        "language": "EN",
        "text": "Implement employee recognition programs to identify and recognize milestones achieved by the employees. This program must provide rewards for the achievement of employees in the workplace and decide which employees are eligible based on their performance and contribution in their roles and responsibilities. "
      }
    ]
  },
  {
    "key": "txtRulesPoliciesFactorDesc",
    "text": "The rules & policies are essential for employee retention as they enhance understanding of the workplace's culture and improve employees' job satisfaction.  The rules & policies of the workplace must be identified for the employee to know the objectives of the workplace and implement what they must and must not do. They come in the form of orders or instructions that need compliance to help the employee understand what is expected and provide them with guidelines on how work will be conducted. Employees get familiar with the rules & policies of the workplace by providing them with the Employee Handbook; this way, they become more engaged with the workplace's mission and vision, resulting in motivated employees who are empowered to stay in the workplace. This grants the employees an identity to a place they belong and boosts their loyalty, thus driving their hard-working, cooperative work ethics for the prosperity of their workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "تُعد القواعد والسياسات من أساسيات استبقاء الموظفين لدورها الفعّال في تعزيز فهم ثقافة مكان العمل وتحسين مستوى الرّضا الوظيفي للموظّفين.   يجب تحديد القواعد والسّياسات المرتبطة بمكان العمل لتمكين الموظف من معرفة الأهداف المرجوّة منه وكيفيّة تنفيذها بالشّكل اللازم. يتم التّعبير عن القواعد والسّياسات بأوامر أو تعليمات تتطلّب من الموظّف الامتثال لها لمساعدته على فهم طبيعة عمله، كما يتم تزويده بإرشادات حول ما هو متوقّع منه والطّريقة المثلى لتنفيذه. تجدر الإشارة إلى أنّه من الضروري أن يتلقّى الموظّف دليل القواعد والسّياسات لفهم  السّلوكيات الأخلاقيّة والقانونيّة داخل بيئة العمل مما يجعله أكثر اندماجاً ودراية بالرّؤية والرّسالة الخاصّة بالمؤسسّة، وكنتيجة لذلك سيتم خلق بيئة عمل مترابطة تحرص على استبقاء موظّفيها، وتعزّز شعور الانتماء والولاء لديهم بالإضافة إلى الاعتزاز لكونهم جزءاً من فريق العمل، وبالتّالي دفعهم إلى العمل الجاد والتّعاون من أجل الارتقاء بمكان العمل ."
      },
      {
        "language": "EN",
        "text": "The rules & policies are essential for employee retention as they enhance understanding of the workplace's culture and improve employees' job satisfaction.  The rules & policies of the workplace must be identified for the employee to know the objectives of the workplace and implement what they must and must not do. They come in the form of orders or instructions that need compliance to help the employee understand what is expected and provide them with guidelines on how work will be conducted. Employees get familiar with the rules & policies of the workplace by providing them with the Employee Handbook; this way, they become more engaged with the workplace's mission and vision, resulting in motivated employees who are empowered to stay in the workplace. This grants the employees an identity to a place they belong and boosts their loyalty, thus driving their hard-working, cooperative work ethics for the prosperity of their workplace."
      }
    ]
  },
  {
    "key": "txtRulesPoliciesRecommendationDesc",
    "text": "Rules & Policies Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "الإجراءات التي يمكن الاستعانة بها لتحسين القواعد والسياسات"
      },
      {
        "language": "EN",
        "text": "Rules & Policies Recommendations"
      }
    ]
  },
  {
    "key": "txtRulesPolicies",
    "text": "Rules & Policies",
    "translations": [
      {
        "language": "AR",
        "text": "القواعد والسياسات"
      },
      {
        "language": "EN",
        "text": "Rules & Policies"
      }
    ]
  },
  {
    "key": "txtRulesPoliciesRecommendation_1",
    "text": "Ensure that guidelines and supportive documents for the rules & policies manuals are available to all employees to enhance their knowledge of the workplace's readiness and capabilities.",
    "translations": [
      {
        "language": "AR",
        "text": "التأكّد من أنّ المبادئ التوجيهيّة والوثائق الداعمة للوائح القواعد والسّياسات متاحة لجميع الموظّفين لتعزيز معرفتهم بجاهزيّة واستعداد مكان العمل لاستقبالهم."
      },
      {
        "language": "EN",
        "text": "Ensure that guidelines and supportive documents for the rules & policies manuals are available to all employees to enhance their knowledge of the workplace's readiness and capabilities."
      }
    ]
  },
  {
    "key": "txtRulesPoliciesRecommendation_2",
    "text": "Develop the rules & policies in a realistic manner that adheres to being specific, relevant, consistent, and well-structured to implement the best practice possible.",
    "translations": [
      {
        "language": "AR",
        "text": "التأكّد من أنّ القواعد والسّياسات واقعية ومن أنّها دقيقة وملائمة ومتّسقة بشكل يسمح للموظّفين بإظهار أفضل الإمكانيّات الممكنة."
      },
      {
        "language": "EN",
        "text": "Develop the rules & policies in a realistic manner that adheres to being specific, relevant, consistent, and well-structured to implement the best practice possible."
      }
    ]
  },
  {
    "key": "txtRulesPoliciesRecommendation_3",
    "text": "Update the rules & policies of the workplace to provide an efficient roadmap to guide the employees and, outline the correct ways of working, set standards of behavior, and help articulate the mission and values.",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث قواعد وسياسات المؤسّسة لضمان توفير خارطة طريق فعّالة لتوجيه الموظّفين، وتوضيح أساليب العمل والمعايير السّلوكية اللّازم اتّباعها والمساعدة في توضيح رؤية ورسالة المؤسسّة."
      },
      {
        "language": "EN",
        "text": "Update the rules & policies of the workplace to provide an efficient roadmap to guide the employees and, outline the correct ways of working, set standards of behavior, and help articulate the mission and values."
      }
    ]
  },
  {
    "key": "txtRulesPoliciesRecommendation_4",
    "text": "Provide training to all employees on the workplace’s rules & policies. If employees are familiar with the workplace’s rules & policies, the business will run more smoothly and efficiently as employees understand what is expected of them.",
    "translations": [
      {
        "language": "AR",
        "text": "تقديم دورات تدريبيّة لجميع الموظّفين بما يخص قواعد وسياسات المؤسّسة والأهداف المرجوّة منهم بما يتناسب مع وظائفهم لضمان أنّ الموظّفين على دراية تامّة بتلك الأهداف والقواعد والسّياسات وبالتّالي ضمان سير الأعمال بسلاسة وكفاءة أكبر."
      },
      {
        "language": "EN",
        "text": "Provide training to all employees on the workplace’s rules & policies. If employees are familiar with the workplace’s rules & policies, the business will run more smoothly and efficiently as employees understand what is expected of them."
      }
    ]
  },
  {
    "key": "txtCompensationBenefitsFactorDesc",
    "text": "The compensation & benefits package offered to employees impacts the employees' satisfaction, well-being, dedication, and commitment. When the workplace offers employees competitive compensation & benefits packages, it is more likely to retain key employees. Achieving equity between employees by giving them fair financial packages aids in reducing turnover rates, attracting talent, and motivating employees to be more productive.  The compensation & benefits package significantly boosts employees' performance, improves job satisfaction, and lowers absence.",
    "translations": [
      {
        "language": "AR",
        "text": "تحظى التّعويضات والمزايا المقدّمة للموظّفين باهتمام كبير من قبلهم لتأثيرها المباشر على مدى سعادتهم ورضاهم الوظيفي وارتباطهم وإخلاصهم للعمل والمؤسّسة.  ولهذا السّبب تتمكّن المؤسسة من استبقاء الموظفين الكفء ذوي المهارات والمواهب الاستثنائيّة عن طريق تقديم تعويضات ومزايا تنافسيّة لهم. كما تتمكّن المؤسّسة من تنفيذ برامج تعويضات ومكافآت دقيقة وعادلة لضمان تحقيق المساواة الدّاخلية بين الموظفين وذلك بمنحهم حزم مالية تساعد في تقليل معدّل الدوران الوظيفي، وجذب الموظفين الكفء ذوي المواهب والمهارات الاستثنائيّة، وتحفيز الموظّفين ليكونوا أكثر إنتاجية. تعمل التّعويضات والمزايا على تعزيز أداء الموظّفين بشكل كبير وتحسين الرّضا الوظيفي وزيادة الكفاءة والإنتاجيّة وتقليل حالات التغيّب عن العمل."
      },
      {
        "language": "EN",
        "text": "The compensation & benefits package offered to employees impacts the employees' satisfaction, well-being, dedication, and commitment. When the workplace offers employees competitive compensation & benefits packages, it is more likely to retain key employees. Achieving equity between employees by giving them fair financial packages aids in reducing turnover rates, attracting talent, and motivating employees to be more productive.  The compensation & benefits package significantly boosts employees' performance, improves job satisfaction, and lowers absence."
      }
    ]
  },
  {
    "key": "txtCompensationBenefitsRecommendationDesc",
    "text": "Compensation & Benefits Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "الإجراءات التي يمكن الاستعانة بها لتحسين التعويضات والمزايا"
      },
      {
        "language": "EN",
        "text": "Compensation & Benefits Recommendations"
      }
    ]
  },
  {
    "key": "txtCompensationBenefits",
    "text": "Compensation & Benefits",
    "translations": [
      {
        "language": "AR",
        "text": "التعويضات والمزايا"
      },
      {
        "language": "EN",
        "text": "Compensation & Benefits"
      }
    ]
  },
  {
    "key": "txtCompensationBenefitsRecommendation_1",
    "text": "Grant employees benefit schemes that reduce their costs for retirement planning, health care, dental, vision & life insurance, and travel & telephone allowances to provide them with a sense of stability, security, and responsibility towards improving upon their work and encouraging them to stay.",
    "translations": [
      {
        "language": "AR",
        "text": "تزويد الموظّفين بلائحة المزايا التي تضمن لهم التقليل من تكاليف التّقاعد وخدمات الرّعاية الصحيّة وطب الأسنان كما تشمل التّأمين على الحياة والتّأمين المختص بعمليّات تصحيح النّظر وبدلات السّفر والهاتف وذلك لضمان استقرار الموظّفين وتنمية حسّ المسؤوليّة لديهم تجاه تطوير مستوى أدائهم وتشجيعهم على البقاء."
      },
      {
        "language": "EN",
        "text": "Grant employees benefit schemes that reduce their costs for retirement planning, health care, dental, vision & life insurance, and travel & telephone allowances to provide them with a sense of stability, security, and responsibility towards improving upon their work and encouraging them to stay."
      }
    ]
  },
  {
    "key": "txtCompensationBenefitsRecommendation_2",
    "text": "Grant employees with ideal salaries and rewards for their contributions and indirect compensation consisting of a good work-life balance, recognition for the executed job, and training and development programs to motivate and encourage them in the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "منح الموظّفين رواتب ومكافآت نموذجيّة تقديرًا لمساهماتهم الفعّالة في المؤسسّة، بالإضافة إلى التّعويضات المعنويّة (الغير مباشرة) المتمثّلة في توفير بيئة عمل مريحة ومتوازنة، وتقديم الدّعم والتّقدير المستمر للمهام الوظيفيّة المنفّذة، وتزويد الموظفين ببرامج تدريب وتطوير فعالة لتحفيزهم وتشجيعهم على الاستمرار في مكان العمل."
      },
      {
        "language": "EN",
        "text": "Grant employees with ideal salaries and rewards for their contributions and indirect compensation consisting of a good work-life balance, recognition for the executed job, and training and development programs to motivate and encourage them in the workplace."
      }
    ]
  },
  {
    "key": "txtCompensationBenefitsRecommendation_3",
    "text": "Conduct market benchmark on the competitors' compensation and ensure offering a more attractive and competitive package that involves merit increments to reward top performers, short- and long-term incentives, or non-financial rewards that involves recognition programs such as personal letters from peers & leaders, gratitude, and symbolic awards that reflects the workplace's culture and history.",
    "translations": [
      {
        "language": "AR",
        "text": "إجراء مقارنة معيارية على أنظمة تعويضات ومزايا الشركات المنافسة والحرص على تقديم تعويضات ومزايا أكثر فاعلية وتنافسية تتضمن زيادات في الراتب لمكافأة أصحاب الأداء الأفضل، وحوافز قصيرة وطويلة المدى، أو مكافآت معنوية (غير مادية) تتضمن برامج تقديرية مثل تقديم رسائل الشكر والامتنان من الزملاء والقادة في العمل بالإضافة إلى الجوائز الرمزية التي ترمز لثقافة وتاريخ المؤسسة.  "
      },
      {
        "language": "EN",
        "text": "Conduct market benchmark on the competitors' compensation and ensure offering a more attractive and competitive package that involves merit increments to reward top performers, short- and long-term incentives, or non-financial rewards that involves recognition programs such as personal letters from peers & leaders, gratitude, and symbolic awards that reflects the workplace's culture and history."
      }
    ]
  },
  {
    "key": "txtCompensationBenefitsRecommendation_4",
    "text": "Provide employees with unique benefits schemes such as complimentary meals, and free transportation and give them exceptional holidays related to their traditions to distinguish the workplace from others and make it competitive to retain and maintain talent.",
    "translations": [
      {
        "language": "AR",
        "text": "تزويد الموظفين بلائحة مزايا فريدة ومميزة تتضمن توفير وجبات طعام ووسائل نقل مجانية، بالإضافة إلى إجازات استثنائية متعلقة بثقافة وتقاليد الموظفين المختلفة لتمييز مكان العمل عن غيره من المنافسين خاصة بما يتعلق باستبقاء الموظفين ذوي المواهب المتميزة."
      },
      {
        "language": "EN",
        "text": "Provide employees with unique benefits schemes such as complimentary meals, and free transportation and give them exceptional holidays related to their traditions to distinguish the workplace from others and make it competitive to retain and maintain talent."
      }
    ]
  },
  {
    "key": "txtCareerAdvancementFactorDesc",
    "text": "Career advancement is an essential key for retaining employees and reducing turnover. If the workplace grants the employees fulfillment with career advancement opportunities, they are more likely to be productive and motivated to stay. The focus on employees' career development attracts top talents and retains valued employees. Setting clear and well-defined short- & long-term goals and plans for their career path empowers their passion to progress because realistic expectations for their career path are set, and their next career milestone is visible. A workplace that can contribute to the employees' career advancement develops a sense of loyalty for employees who see that their employers are willing to invest in them. When employees see they are moving up the hierarchy of job levels, they are open to new challenges motivating them to strengthen their skills professionally and personally. Career advancement is a significant element in increasing satisfaction rates, decreasing turnover rates, and retaining top talent.",
    "translations": [
      {
        "language": "AR",
        "text": "يُعد التطور الوظيفي  لبنة أساسية لاستبقاء  الموظفين وتقليل معدل الدوران الوظيفي، ويمكن تعليل ذلك بأنه إذا كان مكان العمل يضمن  للموظفين فرص مميزة  لتطويرهم  وتقدمهم في التسلسل الهرمي الوظيفي، فهذا سيساهم -وبشكل كبير- بجعل الموظفين أكثر إنتاجية، وسيجعلهم أكثر دراية بالتحديات الجديدة المقبلة عليهم، وبالتالي سيحفزهم على تطوير مهاراتهم ومستوى أدائهم على الصعيد الشخصي والمهني، كما سيتيح للمؤسسة فرصة جذب واستقطاب الكفاءات المختلفة،  بالإضافة إلى استبقاء الموظفين الكفء، وذلك لكونها عاملًا رئيسيًا  لتعزيز ولاء الموظفين وثقتهم بأصحاب العمل، لإيمانهم أن أصحاب العمل مستعدون  لاستثمار قدراتهم ومهاراتهم . تجدر الإشارة إلى أن وضع أهداف وخطط قصيرة وطويلة المدى بشكل واضح ومحدد للمسار الوظيفي يعزز شغف الموظفين ورغبتهم بالتقدم والتطور، وذلك بعد أن أصبح مسارهم الوظيفي محددًا بتطلعات واقعية، والخطوة القادمة ليحققوا إنجازهم المهني أصبحت مرئية وواضحة."
      },
      {
        "language": "EN",
        "text": "Career advancement is an essential key for retaining employees and reducing turnover. If the workplace grants the employees fulfillment with career advancement opportunities, they are more likely to be productive and motivated to stay. The focus on employees' career development attracts top talents and retains valued employees. Setting clear and well-defined short- & long-term goals and plans for their career path empowers their passion to progress because realistic expectations for their career path are set, and their next career milestone is visible. A workplace that can contribute to the employees' career advancement develops a sense of loyalty for employees who see that their employers are willing to invest in them. When employees see they are moving up the hierarchy of job levels, they are open to new challenges motivating them to strengthen their skills professionally and personally. Career advancement is a significant element in increasing satisfaction rates, decreasing turnover rates, and retaining top talent."
      }
    ]
  },
  {
    "key": "txtCareerAdvancementRecommendationDesc",
    "text": "Career Advancement Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "الإجراءات التي يمكن الاستعانة بها لتحسين التطور الوظيفي"
      },
      {
        "language": "EN",
        "text": "Career Advancement Recommendations"
      }
    ]
  },
  {
    "key": "txtCareerAdvancement",
    "text": "Career Advancement",
    "translations": [
      {
        "language": "AR",
        "text": "التطور الوظيفي"
      },
      {
        "language": "EN",
        "text": "Career Advancement"
      }
    ]
  },
  {
    "key": "txtCareerAdvancementRecommendation_1",
    "text": "Make employee development a necessity by implementing personal development programs to improve their skills, performance, and knowledge. ",
    "translations": [
      {
        "language": "AR",
        "text": "جعل عملية تطوير الموظفين ضرورة حتمية من خلال تنفيذ برامج التطوير الذاتي والمهني   لتنمية مهاراتهم ومستوى أدائهم ومعرفتهم الوظيفية."
      },
      {
        "language": "EN",
        "text": "Make employee development a necessity by implementing personal development programs to improve their skills, performance, and knowledge. "
      }
    ]
  },
  {
    "key": "txtCareerAdvancementRecommendation_2",
    "text": "Implement a technology platform/e-learning portal that offers training courses and workshops focused on hard and soft skills to enhance employees' career development and have a clear and fair career path for all employees at all job levels.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير منصة تكنولوجية/ بوابة تعلم إلكترونية تقدم دورات تدريبية وورش عمل تلقي الضوء على المهارات المهنية والذاتية اللازمة لتعزيز التطور الوظيفي للموظفين وخلق مسار وظيفي واضح وعادل على جميع المستويات الوظيفية."
      },
      {
        "language": "EN",
        "text": "Implement a technology platform/e-learning portal that offers training courses and workshops focused on hard and soft skills to enhance employees' career development and have a clear and fair career path for all employees at all job levels."
      }
    ]
  },
  {
    "key": "txtCareerAdvancementRecommendation_3",
    "text": "Form learning support groups to provide employees with a broader knowledge and maintain a continuous learning culture by preparing annual training and guidance plans accompanying employees' work nature and training needs, measured by the annual appraisal.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير فرق دعم تعليمية تساهم في توسيع نطاق المعرفة الوظيفية لدى الموظفين وتحافظ على ثقافة التعلم المستمر من خلال إعداد خطط تدريبية وتوجيهية سنوية بما يتوافق مع طبيعة عمل الموظفين واحتياجات التدريب، والتي يتم قياسها من خلال التقييم السنوي."
      },
      {
        "language": "EN",
        "text": "Form learning support groups to provide employees with a broader knowledge and maintain a continuous learning culture by preparing annual training and guidance plans accompanying employees' work nature and training needs, measured by the annual appraisal."
      }
    ]
  },
  {
    "key": "txtfor",
    "text": "For",
    "translations": [
      {
        "language": "AR",
        "text": "لـ"
      },
      {
        "language": "FR",
        "text": "Pour"
      },
      {
        "language": "EN",
        "text": "For"
      }
    ]
  },
  {
    "key": "txtfrom",
    "text": "From",
    "translations": [
      {
        "language": "AR",
        "text": "من"
      },
      {
        "language": "EN",
        "text": "From"
      }
    ]
  },
  {
    "key": "txtCareerAdvancementRecommendation_4",
    "text": "Create succession planning programs to give opportunities for the suitable and potential skilled employees to move into higher leadership role levels that become vacant in the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء برامج تخطيط التعاقب الوظيفي لمنح   المرشحين المناسبين والمحتملين فرصة الترقي إلى المناصب القيادية الأعلى عندما تصبح شاغرة في المؤسسة."
      },
      {
        "language": "EN",
        "text": "Create succession planning programs to give opportunities for the suitable and potential skilled employees to move into higher leadership role levels that become vacant in the workplace."
      }
    ]
  },
  {
    "key": "txtCommunicationFactorDesc",
    "text": "Building an effective communication workplace environment is essential for boosting morale, increasing employee retention, improving job satisfaction, and attracting top-tier talent. One way to help retain top talent is through strong and clear communication inside the workplace. Proper communication is one of the most crucial strategies to improve the lack of internal communication in building a consistent and retention-oriented workplace culture. It aids in reducing doubts, misunderstandings, and mistakes derived from poor communication; it helps build strong relationships amongst employees of different job levels, improving employees' productivity as they become motivated and feel a sense of belonging and loyalty toward the workplace. ",
    "translations": [
      {
        "language": "AR",
        "text": "يعتبر التواصل الفعال داخل المؤسسة إحدى  الاستراتيجيات الأكثر تأثيرًا  لاستبقاء الموظفين الكفء ذوي  المهارات الاستثنائية، وذلك لأهميته في خلق تواصل داخلي ناجح بين الموظفين عن طريق إزالة أي شكوك أو سوء فهم أو أخطاء ناتجة عن ضعف التواصل؛ والمساعدة في بناء علاقات إيجابية بين الموظفين من مختلف المستويات الوظيفية مما يؤدي إلى رفع إنتاجية الموظف وتعزيز شعور الانتماء والولاء لديه ودفعه لبذل جهد أكبر لتطوير أدائه الوظيفي، وكنتيجة لذلك ستتمكن المؤسسة من خلق بيئة عمل مثلى تسعى لأن تكون متوازنة وملائمة لمختلف الموظفين وتهتم بثقافة استبقاء الموظف. "
      },
      {
        "language": "EN",
        "text": "Building an effective communication workplace environment is essential for boosting morale, increasing employee retention, improving job satisfaction, and attracting top-tier talent. One way to help retain top talent is through strong and clear communication inside the workplace. Proper communication is one of the most crucial strategies to improve the lack of internal communication in building a consistent and retention-oriented workplace culture. It aids in reducing doubts, misunderstandings, and mistakes derived from poor communication; it helps build strong relationships amongst employees of different job levels, improving employees' productivity as they become motivated and feel a sense of belonging and loyalty toward the workplace. "
      }
    ]
  },
  {
    "key": "txtCommunicationRecommendationDesc",
    "text": "Communication Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "الإجراءات التي يمكن الاستعانة بها لتحسين التواصل"
      },
      {
        "language": "EN",
        "text": "Communication Recommendations"
      }
    ]
  },
  {
    "key": "txtCommunication",
    "text": "Communication",
    "translations": [
      {
        "language": "AR",
        "text": "التواصل"
      },
      {
        "language": "EN",
        "text": "Communication"
      }
    ]
  },
  {
    "key": "txtCommunicationRecommendation_1",
    "text": "Build a communication-friendly relationship with the superior by conducting regular 1-to-1 meetings to discuss ideas, goals, and areas of improvement and give feedback.",
    "translations": [
      {
        "language": "AR",
        "text": "بناء علاقة تواصل إيجابية بين رؤساء الأقسام والموظفين من خلال عقد اجتماعات فردية ودورية لمناقشة الأفكار والأهداف ونطاقات التحسين الممكنة في المؤسسة، وأخذ الآراء المطروحة من قبل الموظفين بعين الاعتبار."
      },
      {
        "language": "EN",
        "text": "Build a communication-friendly relationship with the superior by conducting regular 1-to-1 meetings to discuss ideas, goals, and areas of improvement and give feedback."
      }
    ]
  },
  {
    "key": "txtCommunicationRecommendation_2",
    "text": "Ensure the involvement of employees in the new initiatives in the workplace, such as setting strategic directions & plans, improvements, assessing issues, and initiating solutions to make them feel engaged and valued. ",
    "translations": [
      {
        "language": "AR",
        "text": "التأكد من إشراك الموظفين في المبادرات الجديدة في المؤسسة، مثل وضع الخطط التوجيهية والاستراتيجية، وتحديد مواضع التطوير والتحسين الممكنة، وتقييم آخر المستجدات في العمل، بالإضافة إلى اقتراح حلول ممكنة لأي إشكاليات تطرأ في مكان العمل، مما يؤدي إلى تعزيز ارتباط الموظفين بالمؤسسة وجعلهم يشعرون التقدير."
      },
      {
        "language": "EN",
        "text": "Ensure the involvement of employees in the new initiatives in the workplace, such as setting strategic directions & plans, improvements, assessing issues, and initiating solutions to make them feel engaged and valued. "
      }
    ]
  },
  {
    "key": "txtCommunicationRecommendation_3",
    "text": "Develop strategies to allow effective communication between the top management and their subordinates to signify a positive vibe in the workplace and show appreciation towards employees by making them feel cared for and supported. This can be implemented by regular office visits to different departments, adopting the open-door policy and having small chats that do not revolve around work precisely.",
    "translations": [
      {
        "language": "AR",
        "text": "تطوير استراتيجيات تهتم بتحقيق تواصل فعّال بين الإدارة العليا ومرؤوسيهم لخلق بيئة عمل إيجابية تقدّر وتدعم موظّفيها. تشمل هذه الاستراتيجيات الزيارات المكتبية الدورية إلى مختلف الإدارات، واعتماد سياسة الباب المفتوح، والسماح للموظفين بقضاء جزء صغير من وقتهم بإجراء محادثات جانبية أو ممارسة أي اهتمامات أخرى خارج نطاق العمل."
      },
      {
        "language": "EN",
        "text": "Develop strategies to allow effective communication between the top management and their subordinates to signify a positive vibe in the workplace and show appreciation towards employees by making them feel cared for and supported. This can be implemented by regular office visits to different departments, adopting the open-door policy and having small chats that do not revolve around work precisely."
      }
    ]
  },
  {
    "key": "txtCommunicationRecommendation_4",
    "text": "Encourage regular team communication and interaction between departments on a routine basis by holding in-person/zoom meetings and conferences and maintaining leadership meetings to discuss any concerns and suggest possible improvements and proper solutions to solve any issue within the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "تشجيع التواصل والتفاعل المستمر بين الموظفين ومختلف الإدارات من خلال إقامة مؤتمرات واجتماعات حضورية/ عبر المنصات الإلكترونية بالإضافة إلى عقد اجتماعات خاصة بالمناصب القيادية لمناقشة أي مخاوف أو إشكاليات، واقتراح تحسينات ممكنة وحلول فعالة لحل أي إشكالية داخل نطاق العمل."
      },
      {
        "language": "EN",
        "text": "Encourage regular team communication and interaction between departments on a routine basis by holding in-person/zoom meetings and conferences and maintaining leadership meetings to discuss any concerns and suggest possible improvements and proper solutions to solve any issue within the workplace."
      }
    ]
  },
  {
    "key": "txtManagementStyleFactorDesc",
    "text": "Managers strongly influence retaining valuable employees and improving their performance in general. Maintaining an effective and ideal management style to lead the employees within the workplace plays a vital role in strengthening the bond among the employees, ensuring their job satisfaction in all practical aspects. Every manager must provide their employees with continuous support and appreciation; they should actively listen to their employees, deal with complaints and concerns, and provide suggestions. Employees tend to focus more on how the manager is treating them rather than the other external factors (pay rate, incentives, bonuses, etc.) because if a poor management style is implemented, employees tend to leave the workplace as they feel unsatisfied and disengaged; consequently, resulting in higher turnover and decreased productivity.",
    "translations": [
      {
        "language": "AR",
        "text": "للمدراء تأثير جوهري في استبقاء الموظفين الكفء في المؤسسة وتحسين مستوى الأداء الوظيفي للموظفين بشكل عام، وذلك باتباع أساليب إدارية وقيادية نموذجية تضمن تقوية أواصر المحبة وتعزيز روح الفريق الواحد بين الموظفين والتي بدورها تضمن رضاهم الوظيفي من جميع النواحي العملية. ذلك وبالإضافة إلى الدعم والتقدير المستمر الذي يجب أن يحظى به كل موظف من قبل مديره، والاستماع الفعال لشكاوى الموظفين والمشاكل التي قد تطرأ داخل المؤسسة وتقديم الاقتراحات والحلول الممكنة لحل أي إشكالية.  يميل الموظفون للتركيز بشكل أكبر على كيفية تعامل رؤسائهم معهم عوضًا عن العوامل الخارجية الأخرى مثل معدل الأجور الممنوح لهم، الحوافز والمكافآت ... إلخ، وذلك لأن تطبيق أسلوب إداري سيئ داخل المؤسسة سيعيق الرضا والاندماج الوظيفي الذي يجب أن يتولد لدى الموظف مما يؤدي به لترك العمل، كما سيؤدي إلى ارتفاع معدل الدوران الوظيفي وانخفاض الإنتاجية في المؤسسة في نهاية المطاف. "
      },
      {
        "language": "EN",
        "text": "Managers strongly influence retaining valuable employees and improving their performance in general. Maintaining an effective and ideal management style to lead the employees within the workplace plays a vital role in strengthening the bond among the employees, ensuring their job satisfaction in all practical aspects. Every manager must provide their employees with continuous support and appreciation; they should actively listen to their employees, deal with complaints and concerns, and provide suggestions. Employees tend to focus more on how the manager is treating them rather than the other external factors (pay rate, incentives, bonuses, etc.) because if a poor management style is implemented, employees tend to leave the workplace as they feel unsatisfied and disengaged; consequently, resulting in higher turnover and decreased productivity."
      }
    ]
  },
  {
    "key": "txtManagementStyleRecommendationDesc",
    "text": "Management Style Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "الإجراءات التي يمكن الاستعانة بها لتحسين أسلوب الإدارة"
      },
      {
        "language": "EN",
        "text": "Management Style Recommendations"
      }
    ]
  },
  {
    "key": "txtManagementStyle",
    "text": "Management Style",
    "translations": [
      {
        "language": "AR",
        "text": "أسلوب الإدارة"
      },
      {
        "language": "EN",
        "text": "Management Style"
      }
    ]
  },
  {
    "key": "txtManagementStyleRecommendation_1",
    "text": "Implement Change Management Training Programs that allow managers to assist employees by monitoring their progress, encouraging them to innovate, and increasing the company’s overall productivity.",
    "translations": [
      {
        "language": "AR",
        "text": "إقامة برامج تدريبية متعلقة بإدارة التغيير لتتيح للمدراء فرصة مساعدة الموظفين عن طريق مراقبة تقدمهم وتشجيعهم على الابتكار وزيادة الإنتاجية الكلية للمؤسسة."
      },
      {
        "language": "EN",
        "text": "Implement Change Management Training Programs that allow managers to assist employees by monitoring their progress, encouraging them to innovate, and increasing the company’s overall productivity."
      }
    ]
  },
  {
    "key": "txtManagementStyleRecommendation_2",
    "text": "Managers should enhance employees’ creative and critical thinking by giving them the opportunity to take action for tasks that involve planning management, decision making and solving problems. This way, employees feel more valued and engaged in the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "العمل على تنمية التفكير الإبداعي والبنّاء لدى الموظفين من قبل مدرائهم وذلك من خلال إقامة أنشطة مختلفة تتبنى مبدأ إدارة التخطيط، واتخاذ القرار وحل المشكلات، والذي بدوره سيولد لدى الموظفين الشعور بالاندماج الوظيفي والتقدير من قبل المؤسسة. "
      },
      {
        "language": "EN",
        "text": "Managers should enhance employees’ creative and critical thinking by giving them the opportunity to take action for tasks that involve planning management, decision making and solving problems. This way, employees feel more valued and engaged in the workplace."
      }
    ]
  },
  {
    "key": "txtManagementStyleRecommendation_3",
    "text": "Set goals and support employees by providing them with feedback on their performance and monitoring their progress to motivate them to achieve more and enhance their productivity.",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد الأهداف المرجوة من قبل الموظفين ودعمهم على تحقيقها عن طريق تزويدهم بملاحظات حول مستوى أدائهم ومراقبة تقدمهم وتحفيزهم على تحقيق المزيد ورفع مستوى أدائهم الوظيفي."
      },
      {
        "language": "EN",
        "text": "Set goals and support employees by providing them with feedback on their performance and monitoring their progress to motivate them to achieve more and enhance their productivity."
      }
    ]
  },
  {
    "key": "txtManagementStyleRecommendation_4",
    "text": "Manage employees and conduct frequent follow-ups by directing employees and explaining what is expected of them, getting their opinion, and following up with them on their tasks from beginning to end.",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة ومتابعة أداء الموظفين بشكل دوري من قبل مدرائهم عن طريق توجيههم وشرح ما هو متوقع منهم والحصول على ملاحظاتهم وآرائهم والاشراف على مهامهم بشكل كامل من البداية إلى النهاية."
      },
      {
        "language": "EN",
        "text": "Manage employees and conduct frequent follow-ups by directing employees and explaining what is expected of them, getting their opinion, and following up with them on their tasks from beginning to end."
      }
    ]
  },
  {
    "key": "txtWorkingConditionsFactorDesc",
    "text": "The working conditions greatly influence employees' satisfaction at the workplace. It is an integral part of a positive work environment to encourage personal respect for all members in the workplace, disregarding their job level to build feelings of trust, safety, and well-being. Working conditions must comply with the safety and health regulations to ensure that employees feel safe and secure within the workplace environment by keeping it clean and neat to avoid the chances of their sickness and reduce lost workdays. Having the right technology handed to the employees helps them to implement their tasks efficiently, resulting in increased performance level and production rate, and optimized communication using online communication tools. This will create an environment that focuses on support and collaboration, improving job satisfaction, reducing turnover rates, and retaining key talented employees.",
    "translations": [
      {
        "language": "AR",
        "text": "تؤثر بيئة العمل بشكل جوهري على مستوى الرضا الوظيفي داخل المؤسسة، ويعد الاحترام والتقدير المتبادل بين جميع العاملين داخل المؤسسة -بغض النظر عن مستواهم الوظيفي- من أهم العوامل التي تضمن توفير بيئة عمل آمنة وإيجابية تنمي الثقة بين موظفيها ويسودها الرفاه. ولتحقيق ذلك يجب أن تتوافق ظروف العمل مع لوائح السلامة والصحة المهنية لضمان أمن وسلامة الموظفين داخل المؤسسة، وذلك بالحفاظ على نظافة مكان العمل وتعقيمه بشكل دوري للحد من خطر الإصابة بالأمراض داخل المؤسسة وتقليل عدد الإجازات المرضية المأخوذة من قبل الموظفين. توفير وسائل التكنولوجيا المتطورة للموظفين داخل المؤسسة تساعد على رفع كفاءة مهامهم المنجزة والتي بدورها تؤدي إلى رفع مستوى الأداء الوظيفي وزيادة الإنتاجية الكلية للمؤسسة. هذا وبالإضافة إلى مساهمة هذه الوسائل في تحسين التواصل بين الموظفين بما يخص أمور العمل -داخل المؤسسة وخارجها- عن طريق استغلال أدوات ومنصات الاتصال عن بعد، والذي سيترتب عليه خلق بيئة عمل فعّالة تهتم بتقديم الدعم لكافة موظفيها وتعزز روح التعاون بينهم وتستبقي الكفء منهم، وفي نهاية المطاف ستنتج زيادة ملحوظة في معدل الرضا الوظيفي داخل المؤسسة على خلاف معدل الدوران الوظيفي الذي سيتناقص بشكل ملحوظ."
      },
      {
        "language": "EN",
        "text": "The working conditions greatly influence employees' satisfaction at the workplace. It is an integral part of a positive work environment to encourage personal respect for all members in the workplace, disregarding their job level to build feelings of trust, safety, and well-being. Working conditions must comply with the safety and health regulations to ensure that employees feel safe and secure within the workplace environment by keeping it clean and neat to avoid the chances of their sickness and reduce lost workdays. Having the right technology handed to the employees helps them to implement their tasks efficiently, resulting in increased performance level and production rate, and optimized communication using online communication tools. This will create an environment that focuses on support and collaboration, improving job satisfaction, reducing turnover rates, and retaining key talented employees."
      }
    ]
  },
  {
    "key": "txtWorkingConditionsRecommendationDesc",
    "text": "Working Conditions Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "الإجراءات التي يمكن الاستعانة بها لتحسين ظروف العمل"
      },
      {
        "language": "EN",
        "text": "Working Conditions Recommendations"
      }
    ]
  },
  {
    "key": "txtWorkingConditions",
    "text": "Working Conditions",
    "translations": [
      {
        "language": "AR",
        "text": "ظروف العمل"
      },
      {
        "language": "EN",
        "text": "Working Conditions"
      }
    ]
  },
  {
    "key": "txtWorkingConditionsRecommendation_1",
    "text": "Ensure appropriate workplace design by having proper lighting, furniture, appliances, organized & sanitized workspace, modern technologies, and well-designed meeting & break rooms, to allocate space that allows focus.",
    "translations": [
      {
        "language": "AR",
        "text": "التأكد من تصميم مكان عمل ملائم يتوافق مع طبيعة العمل والموظفين من خلال توفير إضاءة وأثاث وأجهزة مناسبة، والتأكد أن مساحة العمل منظمة ومعقمة بشكل دوري، هذا وبالإضافة إلى توفير وسائل التكنولوجيا الحديثة اللازمة وغرف الاجتماعات والاستراحة المصممة بشكل مناسب يلبي احتياجات الموظف والمؤسسة. ويوفر له مساحة مخصصة للعمل بتركيز."
      },
      {
        "language": "EN",
        "text": "Ensure appropriate workplace design by having proper lighting, furniture, appliances, organized & sanitized workspace, modern technologies, and well-designed meeting & break rooms, to allocate space that allows focus."
      }
    ]
  },
  {
    "key": "txtWorkingConditionsRecommendation_2",
    "text": "Show employees appreciation and support by hosting events developed upon team-building activities to facilitate their interpersonal skills and collaboration.",
    "translations": [
      {
        "language": "AR",
        "text": "إظهار التقدير والدعم الدائم للموظفين من خلال استضافة أنشطة وإقامة فعاليات متمحورة حول كيفية بناء فريق عمل جماعي، والذي بدوره سيؤدي إلى تنمية مهاراتهم في التعامل مع الآخرين وتعزيز روح التعاون بينهم. "
      },
      {
        "language": "EN",
        "text": "Show employees appreciation and support by hosting events developed upon team-building activities to facilitate their interpersonal skills and collaboration."
      }
    ]
  },
  {
    "key": "txtWorkingConditionsRecommendation_3",
    "text": "Build a convenient workplace environment by providing employees with the required flexibility in their job to make them feel comfortable and motivated to accomplish their tasks effectively.",
    "translations": [
      {
        "language": "AR",
        "text": "بناء بيئة عمل ملائمة تضمن للموظف المرونة في العمل مما يعود عليه بالشعور بالراحة وتحفزه لإنجاز مهامه بفعالية وكفاءة."
      },
      {
        "language": "EN",
        "text": "Build a convenient workplace environment by providing employees with the required flexibility in their job to make them feel comfortable and motivated to accomplish their tasks effectively."
      }
    ]
  },
  {
    "key": "txtWorkingConditionsRecommendation_4",
    "text": "Inform employees to constantly check in with the cleaning staff in case of an un-clean workspace, bathroom, lunchroom, etc. to ensure the workplace is maintained clean at all times.",
    "translations": [
      {
        "language": "AR",
        "text": "إخطار الموظفين بضرورة مراجعة عمال النظافة بشكل فوري في حال ملاحظة عدم نظافة مكان العمل ومرافقه مثل الحمامات والأماكن المخصصة للطعام ... إلخ، وذلك لضمان نظافة مكان العمل على نحو دائم. "
      },
      {
        "language": "EN",
        "text": "Inform employees to constantly check in with the cleaning staff in case of an un-clean workspace, bathroom, lunchroom, etc. to ensure the workplace is maintained clean at all times."
      }
    ]
  },
  {
    "key": "txtWorkingConditionsRecommendation_5",
    "text": "Consider employee’s opinions when taking any change in the working conditions for example, changing the light, organizing the office, switching to a different free office space, etc.",
    "translations": [
      {
        "language": "AR",
        "text": "أخذ رأي الموظفين بعين الاعتبار قبل الإقبال على أي تغييرات تخص مكان العمل والتي تتضمن تغيير الإضاءة وإعادة تنظيم المكاتب و استغلال المساحات الفارغة بنقل مكان عمل الموظفين إليها."
      },
      {
        "language": "EN",
        "text": "Consider employee’s opinions when taking any change in the working conditions for example, changing the light, organizing the office, switching to a different free office space, etc."
      }
    ]
  },
  {
    "key": "AP_T_1_TITLE",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "AP_T_1_DESCRIPTION",
    "text": "In the “Action Planning” page, you turn employee feedback into clear initiatives. Here, you create, set up, and launch your plan to boost employee exit.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة خطة العمل، يتم تحويل ملاحظات الموظفين إلى مبادرات واضحة وقابلة للتنفيذ. هنا يمكنك إنشاء خطتك، إعدادها، وإطلاقها لتعزيز مستوى خروج الموظفين."
      }
    ]
  },
  {
    "key": "AP_T_2_TITLE",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر"
      }
    ]
  },
  {
    "key": "AP_T_2_DESCRIPTION",
    "text": "Click here to filter and create an action plan for a selected entity or company-wide.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط هنا لاستخدام الفلاتر وإنشاء خطة عمل لجهة محددة أو على مستوى الشركة بالكامل."
      }
    ]
  },
  {
    "key": "AP_T_3_TITLE",
    "text": "Entity Selection – by Business Level",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الوحدة - جهة العمل"
      }
    ]
  },
  {
    "key": "AP_T_3_DESCRIPTION",
    "text": "Select the desired entity for your action plan by checking its box, then click Apply.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة المطلوبة لخطة العمل الخاصة بك عن طريق تحديد المربع بجانبها، ثم اضغط على تطبيق."
      }
    ]
  },
  {
    "key": "AP_T_4_TITLE",
    "text": "Crate Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء خطة العمل"
      }
    ]
  },
  {
    "key": "AP_T_4_DESCRIPTION",
    "text": "After selecting an entity or company-wide for your action plan, click Create Action Plan to get started.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار الجهة محددة أو على مستوى الشركة لخطة العمل، اضغط على إنشاء خطة عمل للبدء."
      }
    ]
  },
  {
    "key": "AP_T_5_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_T_5_DESCRIPTION",
    "text": "Give your plan a clear, descriptive name to get started.",
    "translations": [
      {
        "language": "AR",
        "text": "امنح خطتك عنوانًا واضحًا للبدء."
      }
    ]
  },
  {
    "key": "AP_T_6_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_T_6_DESCRIPTION",
    "text": "Add a brief description to explain the purpose and focus of your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف وصفًا موجزًا لشرح هدف وتركيز لخطة العمل الخاصة بك."
      }
    ]
  },
  {
    "key": "AP_T_7_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "AP_T_7_DESCRIPTION",
    "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام  بالمهمة بالنيابية عنك!"
      }
    ]
  },
  {
    "key": "AP_T_8_TITLE",
    "text": "Scope",
    "translations": [
      {
        "language": "AR",
        "text": "النطاق"
      }
    ]
  },
  {
    "key": "AP_T_8_DESCRIPTION",
    "text": "The “Scope” shows whether the action plan is applied organization-wide or to a specific business level.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض \"النطاق\" ما إذا كانت خطة العمل تنطبق على المنظمة بأكملها أو على مستوى عمل محدد."
      }
    ]
  },
  {
    "key": "AP_T_9_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة"
      }
    ]
  },
  {
    "key": "AP_T_9_DESCRIPTION",
    "text": "Choose the start and end dates for your action plan and then click on continue.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر تاريخ البدء وتاريخ الانتهاء لخطة العمل الخاصة بك، ثم اضغط على متابعة."
      }
    ]
  },
  {
    "key": "AP_T_10_TITLE",
    "text": "Action Plan List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة خطط العمل"
      }
    ]
  },
  {
    "key": "AP_T_10_DESCRIPTION",
    "text": "The action plan list displays all created action plans, showing their scope along with the number of focus areas, initiatives, and tasks.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض قائمة خطط العمل جميع الخطط التي تم إنشاؤها، موضحة نطاق كل منها وعدد مجالات التركيز والمبادرات والمهام."
      }
    ]
  },
  {
    "key": "AP_T_11_TITLE",
    "text": "Edit Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل خطط العمل"
      }
    ]
  },
  {
    "key": "AP_T_11_DESCRIPTION",
    "text": "Edit or delete the action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف خطط العمل."
      }
    ]
  },
  {
    "key": "AP_T_12_TITLE",
    "text": "Accessing Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "الوصول إلى خطة العمل"
      }
    ]
  },
  {
    "key": "AP_T_12_DESCRIPTION",
    "text": "To access an action plan, click Open.",
    "translations": [
      {
        "language": "AR",
        "text": "للوصول إلى خطة العمل، اضغط على فتح."
      }
    ]
  },
  {
    "key": "AP_T_13_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_T_13_DESCRIPTION",
    "text": "Select key factors or topics based on low scores and employee feedback to drive targeted improvements.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر العوامل أو المواضيع الرئيسية بناءً على النتائج المنخفضة وملاحظات الموظفين لدعم تحسينات موجهة وفعّالة."
      }
    ]
  },
  {
    "key": "AP_T_14_TITLE",
    "text": "Status Bar",
    "translations": [
      {
        "language": "AR",
        "text": "شريط الحالة"
      }
    ]
  },
  {
    "key": "AP_T_14_DESCRIPTION",
    "text": "View all selected focus areas, initiatives, and tasks in one place.",
    "translations": [
      {
        "language": "AR",
        "text": "هنا يتم عرض جميع مجالات التركيز والمبادرات والمهام المحددة في مكان واحد."
      }
    ]
  },
  {
    "key": "AP_T_15_TITLE",
    "text": "Factor Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب العامل"
      }
    ]
  },
  {
    "key": "AP_T_15_DESCRIPTION",
    "text": "Based on the selected exit factors, choose the ones you want to focus on.\nNote: An upward arrow (↑) signifies high organizational impact, while a downward arrow (↓) indicates low impact.",
    "translations": [
      {
        "language": "AR",
        "text": "استنادًا إلى عوامل خروج الموظفين، اختر العوامل التي ترغب في التركيز عليها.\nتلميح: يشير السهم للأعلى (↑) إلى تأثير مرتفع على المنظمة، بينما يشير السهم للأسفل (↓) إلى تأثير منخفض."
      }
    ]
  },
  {
    "key": "AP_T_16_TITLE",
    "text": "Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      }
    ]
  },
  {
    "key": "AP_T_16_DESCRIPTION",
    "text": "Once you’ve selected your focus area, choose the desired predefined initiative by checking the box next to it.\nNote: predefined initiatives cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد اختيار مجال التركيز، حدد المبادرة المعرفة مسبقًا عن طريق تحديد المربع بجانبها.\nتلميح: لا يمكن تعديل المبادرات المعرفة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_T_17_TITLE",
    "text": "Manual Initiative Entry",
    "translations": [
      {
        "language": "AR",
        "text": "إدخال المبادرة يدويًا"
      }
    ]
  },
  {
    "key": "AP_T_17_DESCRIPTION",
    "text": "You can also add initiatives manually.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك أيضًا إضافة المبادرات يدويًا."
      }
    ]
  },
  {
    "key": "AP_T_18_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_T_18_DESCRIPTION",
    "text": "Fill in your \"Initiative Title\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة عنوان المبادرة."
      }
    ]
  },
  {
    "key": "AP_T_19_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_T_19_DESCRIPTION",
    "text": "Fill in your \" Initiative Description\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة وصف المبادرة."
      }
    ]
  },
  {
    "key": "AP_T_20_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_T_20_DESCRIPTION",
    "text": "Set the due date for your initiative.\nNote: The due date cannot be later than the overall action plan due date.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ الإكمال المبادرة.\nتلميح: لا يمكن أن يكون تاريخ الإكمال للمبادرة بعد تاريخ إكمال خطة العمل الإجمالي."
      }
    ]
  },
  {
    "key": "AP_T_21_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      }
    ]
  },
  {
    "key": "AP_T_21_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nNote: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      }
    ]
  },
  {
    "key": "AP_T_22_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "AP_T_22_DESCRIPTION",
    "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “🌐”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابية عنك!"
      }
    ]
  },
  {
    "key": "AP_T_23_TITLE",
    "text": "AI-Generated Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_T_23_DESCRIPTION",
    "text": "Generate initiatives effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المبادرات بسهولة بالضغط على “✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة لخطة العمل!"
      }
    ]
  },
  {
    "key": "AP_T_24_TITLE",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      }
    ]
  },
  {
    "key": "AP_T_24_DESCRIPTION",
    "text": "You can update your initiative details by clicking on the three vertical dots.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تعديل تفاصيل المبادرة بالضغط على النقاط الرأسية الثلاث."
      }
    ]
  },
  {
    "key": "AP_T_25_TITLE",
    "text": "Topic Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب الموضوع"
      }
    ]
  },
  {
    "key": "AP_T_25_DESCRIPTION",
    "text": "Topic-based Focus Areas, generated from employee comments, these topics highlight key concerns and show the number and distribution of positive, neutral, and negative comments.",
    "translations": [
      {
        "language": "AR",
        "text": "في مجالات التركيز حسب الموضوع، يتم إنشاء المواضيع من تعليقات الموظفين، حيث تسلط الضوء على أبرز الاهتمامات وتعرض عدد وتوزيع التعليقات الإيجابية والمحايدة والسلبية."
      }
    ]
  },
  {
    "key": "AP_T_26_TITLE",
    "text": "Add Task",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة المهام يدويًا"
      }
    ]
  },
  {
    "key": "AP_T_26_DESCRIPTION",
    "text": "Add customized tasks based on your specific needs.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء مهام مخصصة وفقًا لاحتياجاتك."
      }
    ]
  },
  {
    "key": "AP_T_27_TITLE",
    "text": "AI-Generated Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_T_27_DESCRIPTION",
    "text": "Generate tasks effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المهام بسهولة بالضغط على “✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة لخطة العمل!"
      }
    ]
  },
  {
    "key": "AP_T_28_TITLE",
    "text": "Launch",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق"
      }
    ]
  },
  {
    "key": "AP_T_28_DESCRIPTION",
    "text": "Once everything is set, click Launch to make your action plan live.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد الانتهاء من الإعدادات، اضغط على إطلاق لبدء خطة العمل."
      }
    ]
  },
  {
    "key": "AP_T_29_TITLE",
    "text": "Tracking",
    "translations": [
      {
        "language": "AR",
        "text": "التتبع"
      }
    ]
  },
  {
    "key": "AP_T_29_DESCRIPTION",
    "text": "View overall progress, task status, and key details such as Focus Areas, Initiatives, dates, and time remaining at a glance.",
    "translations": [
      {
        "language": "AR",
        "text": "اعرض f مجالات التركيز والمبادرات والتواريخ والوقت المتبقي بنظرة سريعة."
      }
    ]
  },
  {
    "key": "AP_T_30_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_T_30_DESCRIPTION",
    "text": "Here you view the selected Focus Areas, whether Topics or Factors.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض مجالات التركيز المختارة، سواء كانت مواضيع أو عوامل."
      }
    ]
  },
  {
    "key": "AP_T_31_TITLE",
    "text": "Tasks Management",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة المهام"
      }
    ]
  },
  {
    "key": "AP_T_31_DESCRIPTION",
    "text": "Mark individual tasks as done using the checkbox, or finish all at once with Mark All as Complete.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المهام الفردية كمكتملة باستخدام المربع، أو قم بإكمال جميع المهام بالضغط على تحديد الكل كمكتمل."
      }
    ]
  },
  {
    "key": "AP_T_32_TITLE",
    "text": "Status Filter",
    "translations": [
      {
        "language": "AR",
        "text": "فرز حسب الحالة"
      }
    ]
  },
  {
    "key": "AP_T_32_DESCRIPTION",
    "text": "You can filter initiatives by status: In Progress, Completed, or Expired.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك فرز المبادرات حسب الحالة: قيد التنفيذ مكتملة، أو منتهية."
      }
    ]
  },
  {
    "key": "AP_T_33_TITLE",
    "text": "Request for Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "طلب ملاحظات"
      }
    ]
  },
  {
    "key": "AP_T_33_DESCRIPTION",
    "text": "Click “Request Feedback” to invite employees to share their opinions and experiences regarding the implemented initiative, and measure its impact.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على طلب ملاحظات لدعوة الموظفين لمشاركة آرائهم وتجاربهم حول المبادرة المنفذة وقياس أثرها."
      }
    ]
  },
  {
    "key": "AP_T_34_TITLE",
    "text": "Respondent Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المستجيب"
      }
    ]
  },
  {
    "key": "AP_T_34_DESCRIPTION",
    "text": "Invite respondents to share their feedback on the completed initiative to evaluate its effectiveness and overall impact.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بدعوة المستجيبين لتقديم ملاحظاتهم حول المبادرة المكتملة لمعرفة مدى فعاليتها."
      }
    ]
  },
  {
    "key": "AP_T_35_TITLE",
    "text": "Time Frame",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_T_35_DESCRIPTION",
    "text": "In Timeframe, you set the feedback deadline in addition to automated reminders.\nNote: you can add up to three reminders",
    "translations": [
      {
        "language": "AR",
        "text": "في \"المدة الزمنية\"، يمكنك تحديد الإطار الزمني لتقديم ملاحظاتهم بالإضافة إلى تذكيرات تلقائية.\nتلميح: يمكنك إضافة ما يصل إلى ثلاثة رسائل تذكير."
      }
    ]
  },
  {
    "key": "AP_T_36_TITLE",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني"
      }
    ]
  },
  {
    "key": "AP_T_36_DESCRIPTION",
    "text": "Customize the email template sent or use the default template generated by Zenithr.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج الإيميل أو استخدم النموذج الأساسي المُعرف من زينيثر."
      }
    ]
  },
  {
    "key": "AP_T_37_TITLE",
    "text": "Send Invite",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      }
    ]
  },
  {
    "key": "AP_T_37_DESCRIPTION",
    "text": "Click Send Now to share the invitations with respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على إرسال الآن لمشاركة الدعوات مع المستجيبين."
      }
    ]
  },
  {
    "key": "AP_T_38_TITLE",
    "text": "Live Analytics",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات اللحظية"
      }
    ]
  },
  {
    "key": "AP_T_38_DESCRIPTION",
    "text": "Monitor real-time responses and track participation as feedback is submitted.\nNote: A minimum of three responses is required to close the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "تابع الردود بشكل فوري وراقب مستوى المشاركة لحظة بلحظة مع وصول الملاحظات.\nتلميح: يتطلب إغلاق الاستبيان ثلاثة ردود على الأقل."
      }
    ]
  },
  {
    "key": "AP_T_39_TITLE",
    "text": "Result View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض النتائج"
      }
    ]
  },
  {
    "key": "AP_T_39_DESCRIPTION",
    "text": "Click View Results to see responses, overall rating, and response distribution to quickly evaluate the initiative’s impact and effectiveness",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على عرض النتائج للاطلاع على الردود، التقييم العام، وتوزيع المشاركات لتقييم أثر المبادرة وفعاليتها بسرعة."
      }
    ]
  },
  {
    "key": "AP_T_40_TITLE",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "AP_T_40_DESCRIPTION",
    "text": "Easily showcase your progress! Click “Export” to save and share your initiatives, tasks, feedback, and live dashboard data as a PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض تقدم خطة العمل بكل سهولة! انقر على \"تحميل\" لحفظ ومشاركة المبادرات والمهام وملاحظات الموظفين وبيانات لوحة التحكم المباشرة بصيغة PDF."
      }
    ]
  },
  {
    "key": "AP_S_T_1_TITLE",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_1_DESCRIPTION",
    "text": "In the “Action Planning” page, you turn employee feedback into clear initiatives. Here, you create, set up, and launch your plan to lower employee exit.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة خطة العمل، يتم تحويل ملاحظات الموظفين إلى مبادرات واضحة وقابلة للتنفيذ. هنا يمكنك إنشاء خطتك، إعدادها، وإطلاقها لتخفيض مستوى خروج الموظفين."
      }
    ]
  },
  {
    "key": "AP_S_T_2_TITLE",
    "text": "Create Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_2_DESCRIPTION",
    "text": "After selecting an entity or choosing company-wide, click New Action Plan in the center to get started, or use the top-right button.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد تحديد وحدة معيّنة أو اختيار مستوى الشركة بالكامل، انقر على خطة عمل جديدة في وسط الشاشة للبدء، أو استخدم الزر الموجود في أعلى اليسار."
      }
    ]
  },
  {
    "key": "AP_S_T_3_TITLE",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر"
      }
    ]
  },
  {
    "key": "AP_S_T_3_DESCRIPTION",
    "text": "Click here to filter and create an action plan for a selected entity or company-wide.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط هنا لاستخدام الفلاتر وإنشاء خطة عمل لجهة محددة أو على مستوى الشركة بالكامل."
      }
    ]
  },
  {
    "key": "AP_S_T_4_TITLE",
    "text": "Entity Selection – by Business Level",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الوحدة - جهة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_4_DESCRIPTION",
    "text": "Select the desired entity for your action plan by checking its box, then click Apply.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة المطلوبة لخطة العمل الخاصة بك عن طريق تحديد المربع بجانبها، ثم اضغط على تطبيق."
      }
    ]
  },
  {
    "key": "AP_S_T_5_TITLE",
    "text": "Action Plan List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة خطط العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_5_DESCRIPTION",
    "text": "The action plan list displays all created action plans, showing their scope along with the number of focus areas, initiatives, and tasks.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض قائمة خطط العمل جميع الخطط التي تم إنشاؤها، موضحة نطاق كل منها وعدد مجالات التركيز والمبادرات والمهام."
      }
    ]
  },
  {
    "key": "AP_S_T_6_TITLE",
    "text": "Edit Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل خطط العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_6_DESCRIPTION",
    "text": "Edit or delete the action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف خطط العمل."
      }
    ]
  },
  {
    "key": "AP_S_T_7_TITLE",
    "text": "Accessing Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "الوصول إلى خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_7_DESCRIPTION",
    "text": "To access an action plan, click Open.",
    "translations": [
      {
        "language": "AR",
        "text": "للوصول إلى خطة العمل، اضغط على فتح."
      }
    ]
  },
  {
    "key": "AP_S_T_8_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_S_T_8_DESCRIPTION",
    "text": "Give your plan a clear, descriptive name to get started.",
    "translations": [
      {
        "language": "AR",
        "text": "امنح خطتك عنوانًا واضحًا للبدء."
      }
    ]
  },
  {
    "key": "AP_S_T_9_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_S_T_9_DESCRIPTION",
    "text": "Add a brief description to explain the purpose and focus of your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف وصفًا موجزًا لشرح هدف وتركيز لخطة العمل الخاصة بك."
      }
    ]
  },
  {
    "key": "AP_S_T_10_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "AP_S_T_10_DESCRIPTION",
    "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابية عنك!"
      }
    ]
  },
  {
    "key": "AP_S_T_11_TITLE",
    "text": "Scope",
    "translations": [
      {
        "language": "AR",
        "text": "النطاق"
      }
    ]
  },
  {
    "key": "AP_S_T_11_DESCRIPTION",
    "text": "The “Scope” shows whether the action plan is applied organization-wide or to a specific business level.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض \"النطاق\" ما إذا كانت خطة العمل تنطبق على المنظمة بأكملها أو على مستوى عمل محدد."
      }
    ]
  },
  {
    "key": "AP_S_T_12_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة"
      }
    ]
  },
  {
    "key": "AP_S_T_12_DESCRIPTION",
    "text": "Choose the start and end dates for your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر تاريخ البدء وتاريخ الانتهاء لخطة العمل الخاصة بك."
      }
    ]
  },
  {
    "key": "AP_S_T_13_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_13_DESCRIPTION",
    "text": "Once everything looks good, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد التأكد من أن كل شيء يبدو على ما يرام، اضغط على \"التالي\" للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_14_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_14_DESCRIPTION",
    "text": "Select key exit factors or topics based on low scores and employee feedback to drive targeted improvements.\nNote: An upward arrow (↑) signifies high organizational impact, while a downward arrow (↓) indicates low impact.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر عوامل خروج الموظفين أو المواضيع الرئيسية بناءً على النتائج المنخفضة وملاحظات الموظفين لدعم تحسينات موجهة وفعّالة.\nتلميح: يشير السهم للأعلى (↑) إلى تأثير مرتفع على المنظمة، بينما يشير السهم للأسفل (↓) إلى تأثير منخفض."
      }
    ]
  },
  {
    "key": "AP_S_T_15_TITLE",
    "text": "Topic Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب الموضوع"
      }
    ]
  },
  {
    "key": "AP_S_T_15_DESCRIPTION",
    "text": "Topic-based Focus Areas, generated from employee comments, these topics highlight key concerns and show the number and distribution of positive, neutral, and negative comments.",
    "translations": [
      {
        "language": "AR",
        "text": "في مجالات التركيز حسب الموضوع، يتم إنشاء المواضيع من تعليقات الموظفين، حيث تسلط الضوء على أبرز الاهتمامات وتعرض عدد وتوزيع التعليقات الإيجابية والمحايدة والسلبية."
      }
    ]
  },
  {
    "key": "AP_S_T_16_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_16_DESCRIPTION",
    "text": "Once you’re satisfied with the selected focus areas, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد التأكد من مجالات التركيز المختارة، اضغط على “التالي” للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_17_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_17_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your initiatives!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المبادرات المناسبة!"
      }
    ]
  },
  {
    "key": "AP_S_T_18_TITLE",
    "text": "Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      }
    ]
  },
  {
    "key": "AP_S_T_18_DESCRIPTION",
    "text": "Select your focus area and choose the desired initiative by checking the box next to it.\nNote: predefined initiatives cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر مجال التركيز، ثم حدّد المبادرة المربع بجانبها.\nملاحظة: لا يمكن تعديل المبادرات المعرفة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_S_T_19_TITLE",
    "text": "Custom Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "مبادرة مخصصة"
      }
    ]
  },
  {
    "key": "AP_S_T_19_DESCRIPTION",
    "text": "You can also add initiatives manually.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك أيضًا إضافة المبادرات يدويًا."
      }
    ]
  },
  {
    "key": "AP_S_T_20_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_S_T_20_DESCRIPTION",
    "text": "Fill in your \"Initiative Title\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة عنوان المبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_21_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_S_T_21_DESCRIPTION",
    "text": "Fill in your \" Initiative Description\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة وصف المبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_22_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_S_T_22_DESCRIPTION",
    "text": "Set the due date for your initiative.\nNote: The due date cannot be later than the overall action plan due date.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ الإكمال المبادرة.\nتلميح: لا يمكن أن يكون تاريخ الإكمال للمبادرة بعد تاريخ إكمال خطة العمل الإجمالي."
      }
    ]
  },
  {
    "key": "AP_S_T_23_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      }
    ]
  },
  {
    "key": "AP_S_T_23_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nNote: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_24_TITLE",
    "text": "AI-Generated Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_S_T_24_DESCRIPTION",
    "text": "Generate initiatives effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المبادرات بسهولة بالضغط على“✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة لخطة العمل!"
      }
    ]
  },
  {
    "key": "AP_S_T_25_TITLE",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      }
    ]
  },
  {
    "key": "AP_S_T_25_DESCRIPTION",
    "text": "You can update your initiative details, such as the owner and the due date, by clicking on the three vertical dots.\nNote: You can edit the title and the description of the custom initiative as well.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث تفاصيل المبادرة، مثل المسؤول وتاريخ الاستحقاق، من خلال النقر على النقاط الرأسية الثلاث.\nملاحظة: يمكنك أيضًا تعديل عنوان المبادرة المخصصة ووصفها."
      }
    ]
  },
  {
    "key": "AP_S_T_26_TITLE",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "مسح"
      }
    ]
  },
  {
    "key": "AP_S_T_26_DESCRIPTION",
    "text": "You can delete any initiative by clicking on the three vertical dots",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك مسح المبادرة بالضغط على النقاط الرأسية الثلاث."
      }
    ]
  },
  {
    "key": "AP_S_T_27_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_27_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرات، اضغط على \"التالي\" للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_28_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_28_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your tasks!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المهام المناسبة!"
      }
    ]
  },
  {
    "key": "AP_S_T_29_TITLE",
    "text": "Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_29_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, choose the desired tasks by checking the box next to it.\nHint: Predefined tasks cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرة، حدِّد المهام بوضع علامة في المربع المجاور لها.\nتلميح: لا يمكن تعديل المهام المحددة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_S_T_30_TITLE",
    "text": "Add Task",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة المهام يدويًا"
      }
    ]
  },
  {
    "key": "AP_S_T_30_DESCRIPTION",
    "text": "Add customized tasks based on your specific needs.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء مهام مخصصة وفقًا لاحتياجاتك."
      }
    ]
  },
  {
    "key": "AP_S_T_31_TITLE",
    "text": "Edit Task",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_31_DESCRIPTION",
    "text": "You can update the task by clicking on the pen icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث المهمة بالنقر على أيقونة القلم."
      }
    ]
  },
  {
    "key": "AP_S_T_32_TITLE",
    "text": "Delete Task",
    "translations": [
      {
        "language": "AR",
        "text": "مسح المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_32_DESCRIPTION",
    "text": "You can delete any task by clicking on the delete icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك مسح أي مهمة بالنقر على أيقونة المسح."
      }
    ]
  },
  {
    "key": "AP_S_T_33_TITLE",
    "text": "AI- Generated Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_S_T_33_DESCRIPTION",
    "text": "Generate tasks effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your initiative!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المهام بسهولة بالضغط على “✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة للمبادرة!"
      }
    ]
  },
  {
    "key": "AP_S_T_34_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      }
    ]
  },
  {
    "key": "AP_S_T_34_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nHint: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_35_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_35_DESCRIPTION",
    "text": "Once you’ve selected your tasks, click Next to continue.\nNote: each initiative must have at least 1 task and 1 owner",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المهام، اضغط على التالي للمتابعة.\nملاحظة: يجب أن تحتوي كل مبادرة على مهمة واحدة على الأقل ومالك واحد"
      }
    ]
  },
  {
    "key": "AP_S_T_36_TITLE",
    "text": "Action Plan Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_36_DESCRIPTION",
    "text": "Review your full action plan, including focus areas, initiatives, tasks, owners, and timelines—all in one place before launching.",
    "translations": [
      {
        "language": "AR",
        "text": "راجع تفاصيل خطة العمل بما في ذلك مجالات التركيز والمبادرات والمهام والمسؤولين والجداول الزمنية."
      }
    ]
  },
  {
    "key": "AP_S_T_37_TITLE",
    "text": "Launch",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق"
      }
    ]
  },
  {
    "key": "AP_S_T_37_DESCRIPTION",
    "text": "Once everything is set, click Launch to make your action plan live.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد الانتهاء من الإعدادات، اضغط على إطلاق لبدء خطة العمل."
      }
    ]
  },
  {
    "key": "AP_S_T_38_TITLE",
    "text": "Tracking",
    "translations": [
      {
        "language": "AR",
        "text": "التتبع"
      }
    ]
  },
  {
    "key": "AP_S_T_38_DESCRIPTION",
    "text": "View overall progress, task status, and key details such as Focus Areas, Initiatives, dates, and time remaining at a glance.",
    "translations": [
      {
        "language": "AR",
        "text": "اعرض التقدم العام، حالة المهام، والتفاصيل الأساسية مثل مجالات التركيز والمبادرات والتواريخ والوقت المتبقي بنظرة سريعة."
      }
    ]
  },
  {
    "key": "AP_S_T_39_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_39_DESCRIPTION",
    "text": "Here you view the selected Focus Areas, whether Topics or Exit Factors.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض مجالات التركيز المختارة، سواء كانت مواضيع أو عوامل الخروج."
      }
    ]
  },
  {
    "key": "AP_S_T_40_TITLE",
    "text": "Tasks Management",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_40_DESCRIPTION",
    "text": "Mark individual tasks as done using the checkbox or finish all at once with Mark All as Complete.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المهام الفردية كمكتملة باستخدام المربع، أو قم بإكمال جميع المهام بالضغط على تحديد الكل كمكتمل."
      }
    ]
  },
  {
    "key": "AP_S_T_41_TITLE",
    "text": "Status Filter",
    "translations": [
      {
        "language": "AR",
        "text": "فرز حسب الحالة"
      }
    ]
  },
  {
    "key": "AP_S_T_41_DESCRIPTION",
    "text": "You can filter initiatives by status: In Progress, Completed, or Expired.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك فرز المبادرات حسب الحالة: قيد التنفيذ مكتملة، أو منتهية."
      }
    ]
  },
  {
    "key": "AP_S_T_42_TITLE",
    "text": "Request for Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "طلب ملاحظات"
      }
    ]
  },
  {
    "key": "AP_S_T_42_DESCRIPTION",
    "text": "Click “Request Feedback” to invite employees to share their opinions and experiences regarding the implemented initiative, and measure its impact.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على طلب ملاحظات لدعوة الموظفين لمشاركة آرائهم وتجاربهم حول المبادرة المنفذة وقياس أثرها."
      }
    ]
  },
  {
    "key": "AP_S_T_43_TITLE",
    "text": "Respondent Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المستجيب"
      }
    ]
  },
  {
    "key": "AP_S_T_43_DESCRIPTION",
    "text": "Invite respondents to share their feedback on the completed initiative to evaluate its effectiveness and overall impact.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بدعوة المستجيبين لتقديم ملاحظاتهم حول المبادرة المكتملة لمعرفة مدى فعاليتها."
      }
    ]
  },
  {
    "key": "AP_S_T_44_TITLE",
    "text": "Time Frame",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_S_T_44_DESCRIPTION",
    "text": "In Timeframe, you set the feedback deadline in addition to automated reminders.\nHint: you can add up to three reminders",
    "translations": [
      {
        "language": "AR",
        "text": "في \"المدة الزمنية\"، يمكنك تحديد الإطار الزمني لتقديم ملاحظاتهم بالإضافة إلى تذكيرات تلقائية.\nتلميح: يمكنك إضافة ما يصل إلى ثلاثة رسائل تذكير."
      }
    ]
  },
  {
    "key": "AP_S_T_45_TITLE",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني"
      }
    ]
  },
  {
    "key": "AP_S_T_45_DESCRIPTION",
    "text": "Customize the email template sent or use the default template generated by Zenithr.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج الإيميل أو استخدم النموذج الأساسي المُعرف من زينيثر."
      }
    ]
  },
  {
    "key": "AP_S_T_46_TITLE",
    "text": "Send Invite",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      }
    ]
  },
  {
    "key": "AP_S_T_46_DESCRIPTION",
    "text": "Click Send Now to share the invitations with respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على إرسال الآن لمشاركة الدعوات مع المستجيبين."
      }
    ]
  },
  {
    "key": "AP_S_T_47_TITLE",
    "text": "Live Analytics",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات اللحظية"
      }
    ]
  },
  {
    "key": "AP_S_T_47_DESCRIPTION",
    "text": "Monitor real-time responses and track participation as feedback is submitted.\nHint: Minimum of three responses is required to close the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "تابع الردود بشكل فوري وراقب مستوى المشاركة لحظة بلحظة مع وصول الملاحظات.\nتلميح: يتطلب إغلاق الاستبيان ثلاثة ردود على الأقل."
      }
    ]
  },
  {
    "key": "AP_S_T_48_TITLE",
    "text": "Result View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض النتائج"
      }
    ]
  },
  {
    "key": "AP_S_T_48_DESCRIPTION",
    "text": "Click View Results to see responses, overall rating, and response distribution to quickly evaluate the initiative’s impact and effectiveness",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على عرض النتائج للاطلاع على الردود، التقييم العام، وتوزيع المشاركات لتقييم أثر المبادرة وفعاليتها بسرعة."
      }
    ]
  },
  {
    "key": "AP_S_T_49_TITLE",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "AP_S_T_49_DESCRIPTION",
    "text": "Easily showcase your progress! Click “Export” to save and share your initiatives, tasks, feedback, and live dashboard data as a PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض تقدم خطة العمل بكل سهولة! انقر على \"تحميل\" لحفظ ومشاركة المبادرات والمهام وملاحظات الموظفين وبيانات لوحة التحكم المباشرة بصيغة PDF."
      }
    ]
  }
]